var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

const shopifyRoot = typeof Shopify !== 'undefined' ? Shopify.routes.root : '/'; 

// js/common/utilities/country-selector.js
var CountrySelector = class extends HTMLElement {
  constructor() {
    super();
    this._onCountryChangedListener = this._onCountryChanged.bind(this);
  }
  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement.addEventListener("change", this._onCountryChangedListener);
    if (this.hasAttribute("country") && this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute("country")));
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this._onCountryChanged();
    }
  }
  disconnectedCallback() {
    this.countryElement.removeEventListener("change", this._onCountryChangedListener);
  }
  _onCountryChanged() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute("data-provinces"));
    this.provinceElement.parentElement.hidden = provinces.length === 0;
    if (provinces.length === 0) {
      return;
    }
    this.provinceElement.innerHTML = "";
    provinces.forEach((data) => {
      const selected = data[1] === this.getAttribute("province");
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
};
if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

// js/common/utilities/extract-section-id.js
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}

// js/common/utilities/player.js
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _onVisibilityChange, onVisibilityChange_fn;
var Player = class extends EventTarget {
  constructor(durationInSec, stopOnVisibility = true) {
    super();
    __privateAdd(this, _onVisibilityChange);
    __privateAdd(this, _callback, void 0);
    __privateAdd(this, _duration, void 0);
    __privateAdd(this, _remainingTime, void 0);
    __privateAdd(this, _startTime, void 0);
    __privateAdd(this, _timer, void 0);
    __privateAdd(this, _state, "paused");
    __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _onVisibilityChange, onVisibilityChange_fn).bind(this));
    __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end")));
    this.setDuration(durationInSec);
    if (stopOnVisibility) {
      document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener));
    }
  }
  getDuration() {
    return __privateGet(this, _duration) / 1e3;
  }
  setDuration(durationInSec) {
    __privateSet(this, _duration, __privateSet(this, _remainingTime, durationInSec * 1e3));
  }
  pause() {
    if (__privateGet(this, _state) !== "started") {
      return;
    }
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "paused");
    __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - ((/* @__PURE__ */ new Date()).getTime() - __privateGet(this, _startTime)));
    this.dispatchEvent(new CustomEvent("player:pause", { detail: { duration: __privateGet(this, _duration) / 1e3, remainingTime: __privateGet(this, _remainingTime) / 1e3 } }));
  }
  resume(restartTimer = false) {
    if (__privateGet(this, _state) !== "stopped") {
      if (restartTimer) {
        this.start();
      } else {
        clearTimeout(__privateGet(this, _timer));
        __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
        __privateSet(this, _state, "started");
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
        this.dispatchEvent(new CustomEvent("player:resume", { detail: { duration: __privateGet(this, _duration) / 1e3, remainingTime: __privateGet(this, _remainingTime) / 1e3 } }));
      }
    }
  }
  start() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
    __privateSet(this, _state, "started");
    __privateSet(this, _remainingTime, __privateGet(this, _duration));
    __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
    this.dispatchEvent(new CustomEvent("player:start", { detail: { duration: __privateGet(this, _duration) / 1e3, remainingTime: __privateGet(this, _remainingTime) / 1e3 } }));
  }
  stop() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "stopped");
    this.dispatchEvent(new CustomEvent("player:stop"));
  }
};
_callback = new WeakMap();
_duration = new WeakMap();
_remainingTime = new WeakMap();
_startTime = new WeakMap();
_timer = new WeakMap();
_state = new WeakMap();
_onVisibilityChangeListener = new WeakMap();
_onVisibilityChange = new WeakSet();
onVisibilityChange_fn = function() {
  if (document.visibilityState === "hidden") {
    this.pause();
  } else if (document.visibilityState === "visible") {
    this.resume();
  }
};

// js/common/actions/confirm-button.js
var ConfirmButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (!window.confirm(this.getAttribute("data-message") ?? "Are you sure you wish to do this?")) {
        event.preventDefault();
      }
    });
  }
};
if (!window.customElements.get("confirm-button")) {
  window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });
}

// js/common/actions/controls.js
var PageDots = class extends HTMLElement {
  constructor() {
    super();
    this._abortController = new AbortController();
    this.adjustMaxHeight = this.adjustMaxHeight.bind(this); // Bind once and reuse
  }

  connectedCallback() {
    this._abortController = new AbortController();
    this.items = Array.from(this.children);
    this.items.forEach((button, index) => button.addEventListener("click", () => this.select(index), { signal: this._abortController.signal }));
    this.addEventListener("control:filter", this._filterItems, { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("carousel:change", (event) => this.select(event.detail.index, false), { signal: this._abortController.signal });
    }
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target)));
    }
    this.adjustMaxHeight();
    window.addEventListener('resize', this.adjustMaxHeight);
  }
  disconnectedCallback() {
    this._abortController.abort();
    window.removeEventListener('resize', this.adjustMaxHeight.bind(this));
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
  get selectedIndex() {
    return this.items.findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  select(selectedIndex, dispatchEvent = true) {
    if (this.hasAttribute("align-selected")) {
      const scrollElement = this.getAttribute("align-selected") !== "" ? this.closest(this.getAttribute("align-selected")) : this;
      scrollElement.scrollTo({
        left: this.items[selectedIndex].offsetLeft - scrollElement.clientWidth / 2 + this.items[selectedIndex].clientWidth / 2,
        top: this.items[selectedIndex].offsetTop - scrollElement.clientHeight / 2 - this.items[selectedIndex].clientHeight / 2,
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
      });
    }
    if (this.selectedIndex === selectedIndex) {
      return;
    }
    this.items.forEach((button, index) => button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
    if (dispatchEvent) {
      this._dispatchEvent(selectedIndex);
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => {
      item.hidden = event.detail.filteredIndexes.includes(index) || event.detail.marketExcludeIndexes.includes(index) || event.detail.marketSpecificIndexes.includes(index);
    });
  }
  _dispatchEvent(index) {
    (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:select", { bubbles: true, cancelable: true, detail: { index } }));
  }
  adjustMaxHeight() {
    if (window.innerWidth >= 1150) {
      const mediaListWrapper = this.closest('.product-gallery')?.querySelector('.product-gallery__media-list-wrapper');
      if (mediaListWrapper) {
        this.style.maxHeight = `${mediaListWrapper.clientHeight}px`;
      } else {
        this.style.maxHeight = '';
      }
    } else {
      this.style.maxHeight = '';
    }
  }
};
var PrevButton = class extends HTMLButtonElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:prev", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "start", { signal: this._abortController.signal });
      this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "start" ? false : this.disabled, { signal: this._abortController.signal });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
var NextButton = class extends HTMLButtonElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:next", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "end", { signal: this._abortController.signal });
      this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "end" ? false : this.disabled, { signal: this._abortController.signal });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
if (!window.customElements.get("page-dots")) {
  window.customElements.define("page-dots", PageDots);
}
if (!window.customElements.get("prev-button")) {
  window.customElements.define("prev-button", PrevButton, { extends: "button" });
}
if (!window.customElements.get("next-button")) {
  window.customElements.define("next-button", NextButton, { extends: "button" });
}

// js/common/actions/copy-button.js
import { timeline } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var CopyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.append(this.contentElement, this.animationElement);
    this.addEventListener("click", this._copyToClipboard.bind(this));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__feedback">  
        <svg role="presentation" focusable="false" fill="none" width="18px" height="18px" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
          <path d="m6 9.8 2.63 2.8L14 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
    `).firstElementChild;
  }
  async _copyToClipboard() {
    if (!navigator.clipboard) {
      return;
    }
    await navigator.clipboard.writeText(this.getAttribute("data-text") || "");
    timeline([
      [this.contentElement, { y: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15, at: "+0.5" }],
      [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
    ]);
  }
};
if (!window.customElements.get("copy-button")) {
  window.customElements.define("copy-button", CopyButton, { extends: "button" });
}

// js/common/actions/custom-button.js
import { animate, timeline as timeline2, stagger } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var CustomButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    if (this.type === "submit" && this.form) {
      this.form.addEventListener("submit", () => this.setAttribute("aria-busy", "true"));
    }
    this.append(this.contentElement, this.animationElement);
    window.addEventListener("pageshow", () => this.removeAttribute("aria-busy"));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild;
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timeline2([
        [this.contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
      animate(this.animationElement.children, { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timeline2([
        [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
    }
  }
};
if (!window.customElements.get("custom-button")) {
  window.customElements.define("custom-button", CustomButton, { extends: "button" });
}

// js/common/actions/share-button.js
var ShareButton = class extends HTMLButtonElement {
  constructor() {
    super();
    if (navigator.share) {
      this.addEventListener("click", this._showSystemShare);
    }
  }
  _showSystemShare() {
    navigator.share({
      title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
      url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
    });
  }
};
if (!window.customElements.get("share-button")) {
  window.customElements.define("share-button", ShareButton, { extends: "button" });
}

// js/common/animation/heading.js
import { stagger as stagger2 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
function getHeadingKeyframe(element, options = {}) {
  if (!element) {
    return [];
  }
  const splitLines = element.querySelector("split-lines")?.lines;
  if (window.themeVariables.settings.headingApparition === "fade" || !splitLines) {
    return [element, { opacity: [0, 1] }, { duration: 0.2, ...options }];
  } else {
    element.style.opacity = "1";
    switch (window.themeVariables.settings.headingApparition) {
      case "split_fade":
        return [splitLines, { transform: ["translateY(0.5em)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3, delay: stagger2(0.1), ...options }];
      case "split_clip":
        return [splitLines, { clipPath: ["inset(0 0 100% 0)", "inset(0 0 -0.3em 0)"], transform: ["translateY(100%)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.7, delay: stagger2(0.15), easing: [0.22, 1, 0.36, 1], ...options }];
      case "split_rotation":
        const rotatedSpans = splitLines.map((line) => line.querySelector("span"));
        rotatedSpans.forEach((span) => span.style.transformOrigin = "top left");
        splitLines.forEach((line) => line.style.clipPath = "inset(0 0 -0.3em 0)");
        return [rotatedSpans, { transform: ["translateY(0.5em) rotateZ(5deg)", "translateY(0) rotateZ(0)"], opacity: [0, 1] }, { duration: 0.4, delay: stagger2(0.1), ...options }];
    }
  }
}

// js/common/animation/reveal-items.js
import { animate as animate2, stagger as stagger3, inView } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var _reveal, reveal_fn;
var RevealItems = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _reveal);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, __privateMethod(this, _reveal, reveal_fn).bind(this), { margin: this.getAttribute("margin") ?? "-50px 0px" });
    }
  }
};
_reveal = new WeakSet();
reveal_fn = function() {
  this.style.opacity = "1";
  animate2(
    this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children,
    { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] },
    { duration: 0.35, delay: stagger3(0.05, { easing: "ease-out" }), easing: "ease" }
  );
};
if (!window.customElements.get("reveal-items")) {
  window.customElements.define("reveal-items", RevealItems);
}

// js/common/behavior/custom-cursor.js
var _abortController, _onPointerLeave, onPointerLeave_fn, _onPointerMove, onPointerMove_fn;
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onPointerLeave);
    __privateAdd(this, _onPointerMove);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this), { passive: true, signal: __privateGet(this, _abortController).signal });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerLeave, onPointerLeave_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
};
_abortController = new WeakMap();
_onPointerLeave = new WeakSet();
onPointerLeave_fn = function() {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};
_onPointerMove = new WeakSet();
onPointerMove_fn = function(event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

// js/common/behavior/gesture-area.js
var _domElement, _thresholdDistance, _thresholdTime, _signal, _firstClientX, _tracking, _start, _touchStart, touchStart_fn, _preventTouch, preventTouch_fn, _gestureStart, gestureStart_fn, _gestureMove, gestureMove_fn, _gestureEnd, gestureEnd_fn;
var GestureArea = class {
  constructor(domElement, { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}) {
    __privateAdd(this, _touchStart);
    __privateAdd(this, _preventTouch);
    __privateAdd(this, _gestureStart);
    __privateAdd(this, _gestureMove);
    __privateAdd(this, _gestureEnd);
    __privateAdd(this, _domElement, void 0);
    __privateAdd(this, _thresholdDistance, void 0);
    __privateAdd(this, _thresholdTime, void 0);
    __privateAdd(this, _signal, void 0);
    __privateAdd(this, _firstClientX, void 0);
    __privateAdd(this, _tracking, false);
    __privateAdd(this, _start, {});
    __privateSet(this, _domElement, domElement);
    __privateSet(this, _thresholdDistance, thresholdDistance);
    __privateSet(this, _thresholdTime, thresholdTime);
    __privateSet(this, _signal, signal);
    __privateGet(this, _domElement).addEventListener("touchstart", __privateMethod(this, _touchStart, touchStart_fn).bind(this), { passive: true, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("touchmove", __privateMethod(this, _preventTouch, preventTouch_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerdown", __privateMethod(this, _gestureStart, gestureStart_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointermove", __privateMethod(this, _gestureMove, gestureMove_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerup", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerleave", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointercancel", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
  }
};
_domElement = new WeakMap();
_thresholdDistance = new WeakMap();
_thresholdTime = new WeakMap();
_signal = new WeakMap();
_firstClientX = new WeakMap();
_tracking = new WeakMap();
_start = new WeakMap();
_touchStart = new WeakSet();
touchStart_fn = function(event) {
  __privateSet(this, _firstClientX, event.touches[0].clientX);
};
_preventTouch = new WeakSet();
preventTouch_fn = function(event) {
  if (Math.abs(event.touches[0].clientX - __privateGet(this, _firstClientX)) > 10) {
    event.preventDefault();
  }
};
_gestureStart = new WeakSet();
gestureStart_fn = function(event) {
  __privateSet(this, _tracking, true);
  __privateSet(this, _start, {
    time: (/* @__PURE__ */ new Date()).getTime(),
    x: event.clientX,
    y: event.clientY
  });
};
_gestureMove = new WeakSet();
gestureMove_fn = function(event) {
  if (__privateGet(this, _tracking)) {
    event.preventDefault();
  }
};
_gestureEnd = new WeakSet();
gestureEnd_fn = function(event) {
  if (!__privateGet(this, _tracking)) {
    return;
  }
  __privateSet(this, _tracking, false);
  const now = (/* @__PURE__ */ new Date()).getTime(), deltaTime = now - __privateGet(this, _start).time, deltaX = event.clientX - __privateGet(this, _start).x, deltaY = event.clientY - __privateGet(this, _start).y;
  if (deltaTime > __privateGet(this, _thresholdTime)) {
    return;
  }
  let matchedEvent;
  if (deltaX === 0 && deltaY === 0 && !event.target.matches("a, button, a :scope, button :scope")) {
    matchedEvent = "tap";
  } else if (deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swiperight";
  } else if (-deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeleft";
  } else if (deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipedown";
  } else if (-deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeup";
  }
  if (matchedEvent) {
    __privateGet(this, _domElement).dispatchEvent(new CustomEvent(matchedEvent, { bubbles: true, composed: true, detail: { originalEvent: event } }));
  }
};

// js/common/behavior/height-observer.js
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateCustomProperties.bind(this)).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${this.clientHeight.toFixed(1)}px`);
    }
  }
  _updateCustomProperties(entries) {
    requestAnimationFrame(() => {
      entries.forEach((entry) => {
        if (entry.target === this) {
          const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
          document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${Math.round(height)}px`);
        }
      });
    });
  }
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

// js/common/behavior/safe-sticky.js
import { inView as inView2 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var _resizeObserver, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _recalculateStyles, recalculateStyles_fn, _checkPosition, checkPosition_fn;
var SafeSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _recalculateStyles);
    __privateAdd(this, _checkPosition);
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateMethod(this, _recalculateStyles, recalculateStyles_fn).bind(this)));
    __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _checkPosition, checkPosition_fn).bind(this)));
    __privateAdd(this, _initialTop, 0);
    __privateAdd(this, _lastKnownY, 0);
    /* we could initialize it to window.scrollY but this avoids a costly reflow */
    __privateAdd(this, _currentTop, 0);
    __privateAdd(this, _position, "relative");
  }
  connectedCallback() {
    inView2(this, () => {
      __privateGet(this, _resizeObserver).observe(this);
      window.addEventListener("scroll", __privateGet(this, _checkPositionListener));
      return () => {
        __privateGet(this, _resizeObserver).unobserve(this);
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
      };
    }, { margin: "500px" });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
  }
};
_resizeObserver = new WeakMap();
_checkPositionListener = new WeakMap();
_initialTop = new WeakMap();
_lastKnownY = new WeakMap();
_currentTop = new WeakMap();
_position = new WeakMap();
_recalculateStyles = new WeakSet();
recalculateStyles_fn = function() {
  this.style.removeProperty("top");
  const computedStyles = getComputedStyle(this);
  __privateSet(this, _initialTop, parseInt(computedStyles.top));
  __privateSet(this, _position, computedStyles.position);
  __privateMethod(this, _checkPosition, checkPosition_fn).call(this);
};
_checkPosition = new WeakSet();
checkPosition_fn = function() {
  if (__privateGet(this, _position) !== "sticky") {
    return this.style.removeProperty("top");
  }
  let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop), minTop = this.clientHeight - window.innerHeight + 20;
  if (window.scrollY < __privateGet(this, _lastKnownY)) {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)));
  } else {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY));
  }
  __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -minTop), maxTop, __privateGet(this, _initialTop)));
  __privateSet(this, _lastKnownY, window.scrollY);
  this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`;
};
if (!window.customElements.get("safe-sticky")) {
  window.customElements.define("safe-sticky", SafeSticky);
}

// js/common/behavior/scroll-area.js
var ScrollArea = class {
  constructor(element, abortController2 = null) {
    this._element = element;
    this._allowTriggerNearingStartEvent = false;
    this._allowTriggerLeavingStartEvent = true;
    this._allowTriggerNearingEndEvent = true;
    this._allowTriggerLeavingEndEvent = false;
    new ResizeObserver(this._checkIfScrollable.bind(this)).observe(element);
    this._element.addEventListener("scroll", throttle(this._onScroll.bind(this)), { signal: abortController2?.signal });
  }
  get scrollNearingThreshold() {
    return 125;
  }
  get scrollDirection() {
    if (this._element.scrollWidth > this._element.clientWidth) {
      return "inline";
    } else if (this._element.scrollHeight > this._element.clientHeight) {
      return "block";
    } else {
      return "none";
    }
  }
  _checkIfScrollable() {
    this._element.classList.toggle("is-scrollable", this.scrollDirection !== "none");
  }
  _onScroll() {
    clearTimeout(this._scrollTimeout);
    this._lastScrollPosition = this._lastScrollPosition ?? (this.scrollDirection === "inline" ? Math.abs(this._element.scrollLeft) : Math.abs(this._element.scrollTop));
    let direction;
    if (this.scrollDirection === "inline") {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollLeft) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollLeft);
    } else {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollTop) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollTop);
    }
    const scrollPosition = Math.round(Math.abs(this.scrollDirection === "inline" ? this._element.scrollLeft : this._element.scrollTop)), scrollMinusSize = Math.round(this.scrollDirection === "inline" ? this._element.scrollWidth - this._element.clientWidth : this._element.scrollHeight - this._element.clientHeight);
    if (direction === "start" && this._allowTriggerNearingStartEvent && scrollPosition <= this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "start" } }));
    } else if (direction === "end" && scrollPosition > this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = true;
      if (this._allowTriggerLeavingStartEvent) {
        this._allowTriggerLeavingStartEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "start" } }));
      }
    }
    if (direction === "end" && this._allowTriggerNearingEndEvent && scrollMinusSize <= scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = false;
      this._allowTriggerLeavingEndEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "end" } }));
    } else if (direction === "start" && scrollMinusSize > scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = true;
      if (this._allowTriggerLeavingEndEvent) {
        this._allowTriggerLeavingEndEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "end" } }));
      }
    }
    if (window.onscrollend === void 0) {
      this._scrollTimeout = setTimeout(() => {
        this._element.dispatchEvent(new CustomEvent("scrollend", { bubbles: true, composed: true }));
      }, 75);
    }
  }
};

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
  connectedCallback() {
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
if (!window.customElements.get("scroll-progress")) {
  window.customElements.define("scroll-progress", ScrollProgress);
}

// js/common/behavior/scroll-shadow.js
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, linear-gradient(to bottom, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-bottom, linear-gradient(to top, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-left, linear-gradient(to right, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-right, linear-gradient(to left, rgb(var(--background)), rgb(var(--background) / 0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
var Updater = class {
  constructor(targetElement) {
    this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
  }
  start(element) {
    if (this.element) {
      this.stop();
    }
    if (element) {
      element.addEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }
  stop() {
    if (!this.element) {
      return;
    }
    this.element.removeEventListener("scroll", this.scheduleUpdate);
    this.resizeObserver.unobserve(this.element);
    this.element = null;
  }
  update(targetElement, style) {
    if (!this.element) {
      return;
    }
    const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
    const scroll = {
      top: Math.max(this.element.scrollTop, 0),
      bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
      left: Math.max(this.element.scrollLeft, 0),
      right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
    };
    requestAnimationFrame(() => {
      for (const position of ["top", "bottom", "left", "right"]) {
        targetElement.style.setProperty(
          `--${position}`,
          `${scroll[position] > maxSize ? maxSize : scroll[position]}px`
        );
      }
    });
  }
};
var ScrollShadow = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).innerHTML = template;
    this.updater = new Updater(this.shadowRoot.lastElementChild);
  }
  connectedCallback() {
    this.shadowRoot.querySelector("slot").addEventListener("slotchange", this.start);
    this.start();
  }
  disconnectedCallback() {
    this.updater.stop();
  }
  start() {
    if (this.firstElementChild) {
      this.updater.start(this.firstElementChild);
    }
  }
};
if ("ResizeObserver" in window && !window.customElements.get("scroll-shadow")) {
  window.customElements.define("scroll-shadow", ScrollShadow);
}

// js/common/behavior/split-lines.js
var _requireSplit, _lastScreenWidth, _split, split_fn, _onWindowResized, onWindowResized_fn;
var SplitLines = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _split);
    __privateAdd(this, _onWindowResized);
    __privateAdd(this, _requireSplit, true);
    __privateAdd(this, _lastScreenWidth, window.innerWidth);
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment("<slot></slot>"));
    window.addEventListener("resize", throttle(__privateMethod(this, _onWindowResized, onWindowResized_fn).bind(this)));
    new MutationObserver(__privateMethod(this, _split, split_fn).bind(this, true)).observe(this, { characterData: true, attributes: false, childList: false, subtree: true });
  }
  connectedCallback() {
    __privateMethod(this, _split, split_fn).call(this);
  }
  get lines() {
    return Array.from(this.shadowRoot.children);
  }
};
_requireSplit = new WeakMap();
_lastScreenWidth = new WeakMap();
_split = new WeakSet();
split_fn = function(force = false) {
  if (!__privateGet(this, _requireSplit) && !force) {
    return;
  }
  this.shadowRoot.innerHTML = this.textContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
  const bounds = /* @__PURE__ */ new Map();
  Array.from(this.shadowRoot.children).forEach((letter) => {
    const key = Math.round(letter.getBoundingClientRect().top);
    bounds.set(key, (bounds.get(key) || "").concat(letter.textContent));
  });
  this.shadowRoot.replaceChildren(...Array.from(bounds.values(), (line) => document.createRange().createContextualFragment(`
      <span style="display: inline-block;">
        <span style="display: block">${line}</span>
      </span>
    `)));
  __privateSet(this, _requireSplit, false);
};
_onWindowResized = new WeakSet();
onWindowResized_fn = function() {
  if (__privateGet(this, _lastScreenWidth) === window.innerWidth) {
    return;
  }
  __privateMethod(this, _split, split_fn).call(this, true);
  __privateSet(this, _lastScreenWidth, window.innerWidth);
};
if (!window.customElements.get("split-lines")) {
  window.customElements.define("split-lines", SplitLines);
}

// js/common/carousel/effect-carousel.js
import { timeline as timeline3, inView as inView3 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";

// js/common/carousel/base-carousel.js
var BaseCarousel = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this._reloaded = false;
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.closest(".shopify-section")?.addEventListener("shopify:section:select", (event) => this._reloaded = event.detail.load);
    }
    if (this.items.length > 1) {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target), { animate: !event.detail.load }));
      }
      if (this.hasAttribute("adaptive-height")) {
        this.addEventListener("carousel:settle", this._adjustHeight);
        this._adjustHeight();
      }
      this.addEventListener("carousel:select", this._preloadImages, { signal: this._abortController.signal });
      this.addEventListener("carousel:filter", this._filterItems, { signal: this._abortController.signal });
      this.addEventListener("control:prev", this.previous, { signal: this._abortController.signal });
      this.addEventListener("control:next", this.next, { signal: this._abortController.signal });
      this.addEventListener("control:select", (event) => this.select(event.detail.index), { signal: this._abortController.signal });
    }
    if (this.selectedIndex === 0) {
      if (this.selectedSlide) {
        this.selectedSlide.classList.add("is-selected");
      }
      this._dispatchEvent("carousel:select", 0);
    } else {
      this.select(this.selectedIndex, { animate: false, force: true });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get items() {
    if (this.hasAttribute("reversed")) {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children).reverse();
    } else {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children);
    }
  }
  get visibleItems() {
    return this.items.filter((item) => item.offsetParent !== null);
  }
  get selectedIndex() {
    return this._selectedIndex = this._selectedIndex ?? parseInt(this.getAttribute("initial-index") || 0);
  }
  get selectedIndexAmongVisible() {
    return this.visibleItems.indexOf(this.selectedSlide);
  }
  get loop() {
    return true;
  }
  get selectedSlide() {
    return this.items[this.selectedIndex];
  }
  get previousSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible - 1 + this.visibleItems.length) % this.visibleItems.length : Math.max(this.selectedIndexAmongVisible - 1, 0)];
  }
  get nextSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible + 1 + this.visibleItems.length) % this.visibleItems.length : Math.min(this.selectedIndexAmongVisible + 1, this.visibleItems.length - 1)];
  }
  previous(animate11 = true) {
    this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate11 });
  }
  next(animate11 = true) {
    this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate11 });
  }
  _transitionTo(fromSlide, toSlide, options = {}) {
  }
  _adjustHeight() {
    if (this.hasAttribute("adaptive-height") && this.selectedSlide.clientHeight !== this.clientHeight) {
      this.style.maxHeight = `${this.selectedSlide.clientHeight}px`;
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => {
      item.hidden = event.detail.filteredIndexes.includes(index) || event.detail.marketExcludeIndexes.includes(index) || event.detail.marketSpecificIndexes.includes(index);
    });
  }
  _preloadImages() {
    [this.previousSlide, this.nextSlide].forEach((item) => {
      if (item) {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
      }
    });
  }
  _dispatchEvent(eventName, index) {
    this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { slide: this.items[index], index } }));
  }
};

// js/common/carousel/effect-carousel.js
var EffectCarousel = class extends BaseCarousel {
  connectedCallback() {
    if (this.items.length > 1 && this.hasAttribute("autoplay")) {
      this._player = new Player(this.getAttribute("autoplay"));
      this._player.addEventListener("player:end", this.next.bind(this));
      inView3(this, () => this._player.resume(true));
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.addEventListener("shopify:block:select", () => this._player.stop(), { signal: this._abortController.signal });
        this.addEventListener("shopify:block:deselect", () => this._player.start(), { signal: this._abortController.signal });
      }
    }
    super.connectedCallback();
    if (this.items.length > 1) {
      if (this.swipeable) {
        new GestureArea(this, { signal: this._abortController.signal });
        this.addEventListener("swipeleft", this.next, { signal: this._abortController.signal });
        this.addEventListener("swiperight", this.previous, { signal: this._abortController.signal });
      }
    }
  }
  get player() {
    return this._player;
  }
  get loop() {
    return true;
  }
  get swipeable() {
    return this.getAttribute("swipeable") !== "false";
  }
  async select(index, { direction, animate: animate11 = true } = {}) {
    const indexBeforeChange = this.selectedIndex;
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (!direction) {
      direction = index > indexBeforeChange ? "next" : "previous";
    }
    if (index !== indexBeforeChange) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this.player?.pause();
      await this._transitionTo(fromSlide, toSlide, { direction, animate: animate11 });
      this.player?.resume(true);
      this._dispatchEvent("carousel:settle", index);
    }
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    const timelineControls = timeline3([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { at: "<", zIndex: { easing: "step-end" } }]
    ], { duration: animate11 ? 0.3 : 0 });
    return timelineControls.finished;
  }
};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", EffectCarousel);
}

// js/common/carousel/scroll-carousel.js
var ScrollCarousel = class extends BaseCarousel {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(this._adjustHeight.bind(this))).observe(this);
    }
  }
  connectedCallback() {
    this._hasPendingProgrammaticScroll = false;
    this._scrollArea = new ScrollArea(this, this._abortController);
    super.connectedCallback();
    this.addEventListener("scroll", throttle(this._onCarouselScroll.bind(this)), { signal: this._abortController.signal });
    this.addEventListener("scrollend", this._onScrollSettled, { signal: this._abortController.signal });
  }
  get itemOffset() {
    return this.visibleItems.length < 2 ? 0 : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
  }
  get slidesPerPage() {
    return this.visibleItems.length < 2 ? 1 : Math.floor((this.clientWidth - this.visibleItems[0].offsetLeft) / (Math.abs(this.itemOffset) - (parseInt(getComputedStyle(this).gap) || 0)));
  }
  get totalPages() {
    return this.visibleItems.length < 2 ? 1 : this.visibleItems.length - this.slidesPerPage + 1;
  }
  select(index, { animate: animate11 = true, force = false } = {}) {
    const indexBeforeChange = this.selectedIndex;
    if (!this.offsetParent || this._scrollArea.scrollDirection === "none") {
      return this._selectedIndex = index;
    }
    const indexAmongVisible = this.visibleItems.indexOf(this.items[index]);
    const maxScroll = this.scrollWidth - this.clientWidth;
    let lastReachableIndex = this.visibleItems.findIndex((item) => Math.abs(item.offsetLeft - this.visibleItems[0].offsetLeft) >= maxScroll);
    if (lastReachableIndex === -1) {
      lastReachableIndex = this.visibleItems.length - 1;
    }
    index = this.items.indexOf(this.visibleItems[Math.min(lastReachableIndex, indexAmongVisible)]);
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (index !== indexBeforeChange || force) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this._transitionTo(fromSlide, toSlide, { animate: animate11 });
    }
  }
  /**
   * Transition using the scrollTo method. To prevent the intersection observer to caught up the change, we set up
   * a "hasPendingProgrammaticScroll" variable to true, that is set back to false once the scroll has settled
   */
  _transitionTo(fromSlide, toSlide, { animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let slideAlign = this._extractSlideAlign(toSlide), scrollAmount = 0;
    switch (slideAlign) {
      case "start":
        scrollAmount = toSlide.offsetLeft - this.visibleItems[0].offsetLeft;
        break;
      case "center":
        scrollAmount = toSlide.offsetLeft - (this.clientWidth / 2 - (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) + toSlide.clientWidth / 2;
        break;
    }
    this._hasPendingProgrammaticScroll = animate11;
    this.scrollTo({ left: scrollAmount, behavior: animate11 ? "smooth" : "auto" });
  }
  /**
   * Update the index when manually scrolling (which allows to update the controls)
   */
  _onCarouselScroll() {
    if (this._hasPendingProgrammaticScroll || this._scrollArea.scrollDirection === "none" || this.visibleItems.length === 0) {
      return;
    }
    const scrollOffset = Math.abs(this.scrollLeft), firstItemOffset = this.visibleItems[0].offsetLeft;
    const distances = this.visibleItems.map((item) => Math.abs(Math.abs(item.offsetLeft - firstItemOffset) - scrollOffset));
    const newIndex = this.items.indexOf(this.visibleItems[distances.indexOf(Math.min(...distances))]);
    if (newIndex !== this.selectedIndex) {
      this._selectedIndex = newIndex;
      this._dispatchEvent("carousel:select", this.selectedIndex);
      this._dispatchEvent("carousel:change", this.selectedIndex);
    }
  }
  /**
   * On the scroll has settled we dispatch the event (which covers both programmatic scroll and swipe)
   */
  _onScrollSettled() {
    this.items.forEach((item) => item.classList.remove("is-selected"));
    this.selectedSlide.classList.add("is-selected");
    this._hasPendingProgrammaticScroll = false;
    this._dispatchEvent("carousel:settle", this.selectedIndex);
  }
  _adjustHeight() {
    this.style.maxHeight = null;
    if (this._scrollArea && this._scrollArea.scrollDirection !== "none") {
      super._adjustHeight();
    }
  }
  _extractSlideAlign(slide) {
    return getComputedStyle(slide).scrollSnapAlign === "center" ? "center" : "start";
  }
};
if (!window.customElements.get("scroll-carousel")) {
  window.customElements.define("scroll-carousel", ScrollCarousel);
}

// js/common/cart/cart-count.js
import { animate as animate3 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";

// js/common/cart/fetch-cart.js
var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${shopifyRoot}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});
// cart:refresh means the cart moved without a cart:change to describe it — a gift line added or removed
// by cart-thresholds, a routine bundle add, a failed add-to-cart. Every other listener re-reads the
// server (the drawer re-fetches its whole section), so the cart cached from the last cart:change is
// stale and must not be handed out again, or the header count keeps the old number while the drawer
// shows the new one. Registered here, before cart-count is defined, so it always runs first; replacing
// the promise (rather than fetching per element) keeps it to one request for all the counts on the page.
document.addEventListener("cart:refresh", () => {
  fetchCart = createCartPromise();
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});

// js/common/cart/cart-count.js
var CartCount = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<span><slot></slot></span>"));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener("cart:change", (event) => this.itemCount = event.detail["cart"]["item_count"], { signal: this._abortController.signal });
    document.addEventListener("cart:refresh", this._updateFromServer.bind(this), { signal: this._abortController.signal });
    // Signalled like the others: the drawer replaces its children on every refresh, so its cart-count is
    // discarded and re-created each time, and an unsignalled listener would pile up on window for good.
    window.addEventListener("pageshow", this._updateFromServer.bind(this), { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    const pending = fetchCart;
    const cart = await pending;
    // A cart:change (or a newer refresh) that landed while this request was in flight describes a more
    // recent cart, and has already set the count — don't overwrite it with this older snapshot.
    if (pending !== fetchCart) {
      return;
    }
    this.itemCount = cart["item_count"];
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    if (this.itemCount === count) {
      return;
    }
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.innerText = count;
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.innerText = count;
    } else {
      (async () => {
        await animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(-50%)"], opacity: 0 }, { duration: 0.25, easing: [1, 0, 0, 1] }).finished;
        this.innerText = count;
        animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 }, { duration: 0.25, easing: [1, 0, 0, 1] });
      })();
    }
  }
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// js/common/cart/cart-drawer.js
import { animate as animate4 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";

// js/common/overlay/dialog-element.js
import { FocusTrap, Delegate } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var _lockLayerCount, _isLocked;
var _DialogElement = class _DialogElement extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _isLocked, false);
    this.addEventListener("dialog:force-close", (event) => {
      this.hide();
      event.stopPropagation();
    });
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  connectedCallback() {
    if (this.id) {
      this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
    }
    this._abortController = new AbortController();
    this.setAttribute("role", "dialog");
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
      this.addEventListener("shopify:block:deselect", this.hide, { signal: this._abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("handle-section-events")) {
          this._shopifySection.addEventListener("shopify:section:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
          this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), { signal: this._abortController.signal });
        }
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), { signal: this._abortController.signal });
      }
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
    this.delegate.off();
    this.focusTrap?.deactivate({ onDeactivate: false });
    if (__privateGet(this, _isLocked)) {
      __privateSet(this, _isLocked, false);
      document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
    }
  }
  show(animate11 = true) {
    if (this.open) {
      return;
    }
    this.setAttribute("open", animate11 ? "" : "immediate");
    return waitForEvent(this, "dialog:after-show");
  }
  hide() {
    if (!this.open) {
      return;
    }
    this.removeAttribute("open");
    return waitForEvent(this, "dialog:after-hide");
  }
  get delegate() {
    return this._delegate = this._delegate || new Delegate(document.body);
  }
  get controls() {
    return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
  }
  get open() {
    return this.hasAttribute("open");
  }
  get shouldTrapFocus() {
    return true;
  }
  get shouldLock() {
    return false;
  }
  /**
   * Sometimes (especially for drawer) we need to ensure that an element is on top of everything else. To do that,
   * we need to move the element to the body. We are doing that on open, and then restore the initial position on
   * close
   */
  get shouldAppendToBody() {
    return false;
  }
  get initialFocus() {
    return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") : this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || false;
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  get focusTrap() {
    return this._focusTrap = this._focusTrap || new FocusTrap.createFocusTrap([this, this.shadowRoot], {
      onDeactivate: this.hide.bind(this),
      allowOutsideClick: this._allowOutsideClick.bind(this),
      initialFocus: window.matchMedia("screen and (pointer: fine)").matches ? this.initialFocus : false,
      fallbackFocus: this,
      preventScroll: this.preventScrollWhenTrapped
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "id":
        if (newValue) {
          this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
        }
        break;
      case "open":
        this.controls.forEach((toggle) => toggle.setAttribute("aria-expanded", newValue === null ? "false" : "true"));
        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          this.removeAttribute("inert");
          this._originalParentBeforeAppend = null;
          if (this.shouldAppendToBody && this.parentElement !== document.body && this.getAttribute("append-to-body") !== "false") {
            this._originalParentBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const showTransitionPromise = this._showTransition(newValue !== "immediate") || Promise.resolve();
          showTransitionPromise.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:after-show", { bubbles: true }));
          });
          if (this.shouldTrapFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => showTransitionPromise
            });
          }
          if (this.shouldLock) {
            __privateSet(_DialogElement, _lockLayerCount, __privateGet(_DialogElement, _lockLayerCount) + 1);
            __privateSet(this, _isLocked, true);
            document.documentElement.classList.add("lock");
          }
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute("inert", "");
          const hideTransitionPromise = this._hideTransition() || Promise.resolve();
          hideTransitionPromise.then(() => {
            if (this.parentElement === document.body && this._originalParentBeforeAppend) {
              this._originalParentBeforeAppend.appendChild(this);
              this._originalParentBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent("dialog:after-hide", { bubbles: true }));
          });
          this.focusTrap?.deactivate({
            checkCanReturnFocus: () => hideTransitionPromise
          });
          if (this.shouldLock) {
            __privateSet(this, _isLocked, false);
            document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }
  /* Those methods are used to perform custom show/hide transition, and must return a promise */
  _showTransition(animate11 = true) {
  }
  _hideTransition() {
  }
  /* By default, a focus element is deactivated when you click outside it */
  _allowOutsideClick(event) {
    if ("TouchEvent" in window && event instanceof TouchEvent) {
      return this._allowOutsideClickTouch(event);
    } else {
      return this._allowOutsideClickMouse(event);
    }
  }
  _allowOutsideClickTouch(event) {
    event.target.addEventListener("touchend", (subEvent) => {
      const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
      if (!this.contains(endTarget)) {
        this.hide();
      }
    }, { once: true });
    return false;
  }
  _allowOutsideClickMouse(event) {
    if (event.type !== "click") {
      return false;
    }
    if (!this.contains(event.target)) {
      // Check if the click target is inside another dialog element that might be layered on top
      const targetDialog = event.target.closest('.drawer, .popover, [role="dialog"]');
      if (targetDialog && targetDialog !== this) {
        // If clicking inside another dialog element, don't close this one
        // This prevents parent dialogs from closing when interacting with child/overlapping dialogs
        return false;
      }
      this.hide();
    }
    let target = event.target, closestControl = event.target.closest("[aria-controls]");
    if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
      target = closestControl;
    }
    return this.id !== target.getAttribute("aria-controls");
  }
  _onToggleClicked(event) {
    event?.preventDefault();
    this.open ? this.hide() : this.show();
  }
};
_lockLayerCount = new WeakMap();
_isLocked = new WeakMap();
__privateAdd(_DialogElement, _lockLayerCount, 0);
var DialogElement = _DialogElement;
var CloseButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true })));
  }
};
if (!window.customElements.get("dialog-element")) {
  window.customElements.define("dialog-element", DialogElement);
}
if (!window.customElements.get("close-button")) {
  window.customElements.define("close-button", CloseButton, { extends: "button" });
}

// js/common/overlay/drawer.js
import { animate as motionAnimate, timeline as motionTimeline } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var reduceDrawerAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches || JSON.parse("false");
var Drawer = class extends DialogElement {
  constructor() {
    super();
    const template2 = document.getElementById(this.template).content.cloneNode(true);
    this.attachShadow({ mode: "open" }).appendChild(template2);
    this.shadowRoot.addEventListener("slotchange", (event) => this._updateSlotVisibility(event.target));
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => this._updateSlotVisibility(slot));
  }
  get template() {
    return this.getAttribute("template") || "drawer-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : this.getAttribute("open-from") || "right";
  }
  _getClipPathProperties() {
    switch (this.openFrom) {
      case "left":
        return document.dir === "ltr" ? ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"] : ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "right":
        return document.dir === "ltr" ? ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm)"] : ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "bottom":
        return ["inset(100% 0 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "center":
        return ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"]; 
      case "top":
        return ["inset(0 0 100% 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
    }
  }
  _setInitialPosition() {
    this.style.left = document.dir === "ltr" && this.openFrom === "left" || document.dir === "rtl" && this.openFrom === "right" ? "0px" : null;
    this.style.right = this.style.left === "" ? "0px" : null;
    this.style.bottom = this.openFrom === "bottom" ? "0px" : null;
    this.style.top = this.style.bottom === "" ? "0px" : null;
  }
  _showTransition(animate11 = true) {
    let animationControls;
    this._setInitialPosition();
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    let animationControls;
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties().reverse() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    }
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  _updateSlotVisibility(slot) {
    if (!["header", "footer", "body"].includes(slot.name)) {
      return;
    }
    slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
  }
};
if (!window.customElements.get("x-drawer")) {
  window.customElements.define("x-drawer", Drawer);
}

// js/common/overlay/modal.js
// A centered modal dialog. Reuses the Drawer machinery (overlay, focus trap, show/hide, shadow
// template) but covers the viewport and centers its content panel via CSS (see .x-modal styles).
var XModal = class extends Drawer {
  get _isMobile() {
    return window.matchMedia(window.themeVariables.breakpoints["sm-max"]).matches;
  }
  get openFrom() {
    // Bottom sheet on mobile (like x-drawer), centered modal on desktop.
    return this._isMobile ? "bottom" : "center";
  }
  _setInitialPosition() {
    if (this._isMobile) {
      super._setInitialPosition();
      return;
    }
    this.style.top = "0px";
    this.style.right = "0px";
    this.style.bottom = "0px";
    this.style.left = "0px";
  }
  _getClipPathProperties() {
    if (this._isMobile) {
      return super._getClipPathProperties();
    }
    // Desktop: no clipping — the centered content just fades in via the shared transition.
    return ["inset(0 0 0 0 round 8px)", "inset(0 0 0 0 round 8px)"];
  }
  _showTransition(animate11 = true) {
    if (this._isMobile) {
      return super._showTransition(animate11);
    }
    // Desktop: fade the panel and its content in together (the drawer transition runs an empty
    // clip-path step for 0.4s first, which would delay the content long after the panel appears).
    this._setInitialPosition();
    const content = this.shadowRoot.querySelector('[part="content"]');
    const controls = motionTimeline([
      [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
      [content.children, { opacity: [0, 1] }, { at: "<", duration: 0.2 }]
    ]);
    animate11 ? controls.play() : controls.finish();
    return controls.finished;
  }
  _hideTransition() {
    if (this._isMobile) {
      return super._hideTransition();
    }
    const content = this.shadowRoot.querySelector('[part="content"]');
    const controls = motionTimeline([
      [content.children, { opacity: [null, 0] }, { duration: 0.1 }],
      [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { at: "<", duration: 0.15 }]
    ]);
    return controls.finished;
  }
};
if (!window.customElements.get("x-modal")) {
  window.customElements.define("x-modal", XModal);
}

// js/common/overlay/popover.js
import { animate as motionAnimate2, timeline as motionTimeline2 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var Popover = class extends DialogElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.template).content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.hasAttribute("close-on-listbox-select")) {
      this.addEventListener("listbox:select", this.hide, { signal: this._abortController.signal });
    }
  }
  get template() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldTrapFocus() {
    // Opt-out used when this popover lives inside another dialog (e.g. the cart drawer). Nesting a
    // focus trap inside the drawer's trap corrupts the focus-trap stack and can freeze the drawer.
    return this.hasAttribute("no-focus-trap") ? false : super.shouldTrapFocus;
  }
  get shouldLock() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get shouldAppendToBody() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get anchor() {
    return {
      vertical: this.getAttribute("anchor-vertical") || "start",
      horizontal: this.getAttribute("anchor-horizontal") || "end"
    };
  }
  _showTransition(animate11 = true) {
    let animationControls, content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    this.style.display = "block";
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      this.style.left = "0px";
      this.style.right = null;
      this.style.bottom = "0px";
      this.style.top = null;
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    } else {
      let spacingBlockValue = "var(--popover-anchor-block-spacing)", spacingInlineValue = "var(--popover-anchor-inline-spacing)";
      this.style.left = this.anchor.horizontal === "start" ? spacingInlineValue : null;
      this.style.right = this.anchor.horizontal === "end" ? spacingInlineValue : null;
      if (this.anchor.vertical === "center") {
        this.style.top = `calc(50% - ${parseInt(this.clientHeight / 2)}px)`;
        this.style.bottom = null;
      } else {
        this.style.top = this.anchor.vertical === "end" ? `calc(100% + ${spacingBlockValue})` : null;
        this.style.bottom = this.anchor.vertical === "start" ? `calc(100% + ${spacingBlockValue})` : null;
      }
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: "none" }, { at: "<", duration: 0 }],
        [content.children, { opacity: 1 }, { at: "<", duration: 0 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished;
  }
  _hideTransition() {
    let animationControls;
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline2([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: [null, "inset(100% 0 0 0 round 8px)"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    } else {
      animationControls = motionAnimate2(this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 });
    }
    return animationControls.finished.then(() => this.style.display = "none");
  }
};
if (!window.customElements.get("x-popover")) {
  window.customElements.define("x-popover", Popover);
}

// js/common/overlay/privacy-bar.js
import { Delegate as Delegate2 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";

var PrivacyBar = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    if (typeof Shopify !== 'undefined') {
      window.Shopify.loadFeatures([{
        name: "consent-tracking-api",
        version: "0.1"
      }]);
    };
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      const section = this.closest(".shopify-section");
      section.addEventListener("shopify:section:select", this.show.bind(this));
      section.addEventListener("shopify:section:deselect", this.hide.bind(this));
    }
  }
  connectedCallback() {
    if (typeof Shopify !== 'undefined') {
      window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide.bind(this));
    }
    this._delegate.on("click", '[data-action="close"]', this.hide.bind(this));
    if (localStorage.getItem("privacy-bar") === "hidden") {
      this.hide();
    } else {
      this.show();
    }
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  show() {
    this.hidden = false;
  }
  hide() {
    this.hidden = true;
    localStorage.setItem("privacy-bar", "hidden");
  }
};
if (!window.customElements.get("privacy-bar")) {
  window.customElements.define("privacy-bar", PrivacyBar);
}

// js/common/cart/cart-drawer.js
var CartDrawer = class extends Drawer {
  constructor() {
    super();
    this._onPrepareBundledSectionsListener = this._onPrepareBundledSections.bind(this);
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onCartRefreshListener = this._onCartRefresh.bind(this);
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    window.addEventListener("pageshow", this._onPageShow.bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartRefreshListener);
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return "right";
  }
  _onPrepareBundledSections(event) {
    event.detail.sections.push(extractSectionId(this));
  }
  /**
   * Update the cart drawer content when cart content changes.
   */
  async _onCartChanged(event) {
    const updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"][extractSectionId(this)], "text/html");
    if (event.detail.cart["item_count"] > 0) {
      const currentInner = this.querySelector(".cart-drawer__inner"), updatedInner = updatedDrawerContent.querySelector(".cart-drawer__inner");
      if (!currentInner) {
        this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
      } else {
        setTimeout(() => {
          currentInner.innerHTML = updatedInner.innerHTML;
        }, event.detail.baseEvent === "variant:add" ? 0 : 1250);
        this.querySelector('[slot="footer"]').replaceChildren(...updatedDrawerContent.querySelector('[slot="footer"]').childNodes);
      }
    } else {
      await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
      this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
      animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
    }
  }
  /**
   * Handle the case when the page is served from BF cache
   */
  _onPageShow(event) {
    if (!event.persisted) {
      return;
    }
    this._onCartRefresh();
  }
  /**
   * Listeners called when a new variant has been added
   */
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "drawer" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    this.show();
  }
  /**
   * Force a complete refresh of the cart drawer (this is called by dispatching the 'cart:refresh' on the document)
   */
  async _onCartRefresh() {
    // Parse with DOMParser (as _onCartChanged does), NOT `document.createElement("div").innerHTML`. The fetched
    // section markup contains a <cart-drawer> element of its own, and a div created from this document upgrades
    // custom elements as it parses — running that throwaway drawer's constructor and its
    // attributeChangedCallback("id"), which registers a click delegate on the REAL document.body pointing at a
    // detached ghost drawer. The ghost then opens alongside the real one on every toggle and activates a
    // focus trap on a detached node, which swallows the overlay click that should dismiss the drawer.
    // A DOMParser document has no browsing context, so nothing in it is upgraded; the nodes upgrade normally
    // once they are inserted here.
    const parsedSection = new DOMParser().parseFromString(await (await fetch(`${shopifyRoot}?section_id=${extractSectionId(this)}`)).text(), "text/html");
    const updatedDrawer = parsedSection.querySelector("#cart-drawer");
    if (updatedDrawer) {
      this.replaceChildren(...updatedDrawer.children);
    }
  }
};
var CartNotificationDrawer = class extends Drawer {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  async hide() {
    super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "popover" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    this.replaceChildren(...tempContent.querySelector(".shopify-section").children);
    this.show();
  }
};
var LineItem = class extends HTMLElement {
  connectedCallback() {
    this.pillLoaderElement = this.querySelector("pill-loader");
    this.addEventListener("line-item:will-change", this._onWillChange.bind(this));
    this.addEventListener("line-item:change", this._onChanged.bind(this));
  }
  _onWillChange() {
    this.pillLoaderElement.setAttribute("aria-busy", "true");
  }
  async _onChanged(event) {
    this.pillLoaderElement.removeAttribute("aria-busy");
    if (event.detail.cart["item_count"] === 0 || event.detail.quantity !== 0) {
      return;
    }
    // If this is the last line in its group, collapse the whole group card (heading + border) instead of just the line.
    const group = this.closest(".cart-drawer__group");
    const linesContainer = this.closest(".cart-drawer__line-items");
    const isLastInGroup = group && linesContainer && linesContainer.querySelectorAll("line-item").length === 1;
    const target = isLastInGroup ? group : this;
    let marginCompensation = 0;
    if (!isLastInGroup && this.nextElementSibling) {
      marginCompensation = `-${getComputedStyle(this.nextElementSibling).paddingTop}`;
    }
    await animate4(target, { height: [`${target.clientHeight}px`, 0], marginBottom: [0, marginCompensation], overflow: "hidden", opacity: [1, 0] }, { duration: 0.2, easing: "ease" }).finished;
    target.remove();
  }
};
if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}
if (!window.customElements.get("cart-notification-drawer")) {
  window.customElements.define("cart-notification-drawer", CartNotificationDrawer);
}
if (!window.customElements.get("line-item")) {
  window.customElements.define("line-item", LineItem);
}

// js/common/cart/cart-note.js
var CartNote = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.getAttribute("name") !== "note") {
      return;
    }
    fetch(`${shopifyRoot}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: event.target.value }),
      keepalive: true
      // Allows to make sure the request is fired even when submitting the form
    });
  }
};
var CartNoteDialog = class extends DialogElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.value === "") {
      this.controls.forEach((control) => control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.addOrderNote}</span>`);
    } else {
      this.controls.forEach((control) => control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.editOrderNote}</span>`);
    }
  }
};
if (!window.customElements.get("cart-note")) {
  window.customElements.define("cart-note", CartNote);
}
if (!window.customElements.get("cart-note-dialog")) {
  window.customElements.define("cart-note-dialog", CartNoteDialog);
}

// js/common/cart/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message");
    } else {
      const replacement = `<span class="bold text-accent">${formatMoney(this.threshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
      messageElement.innerHTML = this.getAttribute("unreached-message").replace(new RegExp("({{.*}})", "g"), replacement);
    }
  }
  _onCartChanged(event) {
    const priceForItems = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0), cartDiscount = event.detail["cart"]["cart_level_discount_applications"].reduce((sum, discountAllocation) => sum + discountAllocation["total_allocated_amount"], 0);
    this.totalPrice = priceForItems - cartDiscount;
  }
};
if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// js/common/cart/free-gift-bar.js
var FreeGiftBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message");
    } else {
      messageElement.innerHTML = this.getAttribute("unreached-message");
      const amountElement = messageElement.querySelector("[data-amount-left]");
      if (amountElement) {
        amountElement.innerHTML = formatMoney(this.threshold - this.totalPrice).replace(/[.,]00$/, "");
      }
    }
  }
  _onCartChanged(event) {
    const cartData = event.detail["cart"];
    const excludedIds = (this.getAttribute("excluded-product-ids") || "").split(",").filter(Boolean);
    const priceForItems = cartData["items"]
      .filter((item) => item["requires_shipping"] && !excludedIds.includes(String(item["product_id"])))
      .reduce((sum, item) => sum + item["final_line_price"], 0);
    const cartDiscount = (cartData["cart_level_discount_applications"] || [])
      .reduce((sum, discount) => sum + discount["total_allocated_amount"], 0);
    this.totalPrice = priceForItems - cartDiscount;
    this._updateMessage();
  }
};
if (!window.customElements.get("free-gift-bar")) {
  window.customElements.define("free-gift-bar", FreeGiftBar);
}

// js/common/cart/free-shipping-threshold-bar.js
var FreeShippingThresholdBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message");
    } else {
      messageElement.innerHTML = this.getAttribute("unreached-message");
      const amountElement = messageElement.querySelector("[data-amount-left]");
      if (amountElement) {
        amountElement.innerHTML = formatMoney(this.threshold - this.totalPrice).replace(/[.,]00$/, "");
      }
    }
  }
  _onCartChanged(event) {
    const cartData = event.detail["cart"];
    const priceForItems = cartData["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
    const cartDiscount = (cartData["cart_level_discount_applications"] || []).reduce((sum, discountAllocation) => sum + discountAllocation["total_allocated_amount"], 0);
    this.totalPrice = priceForItems - cartDiscount;
    this._updateMessage();
  }
};
if (!window.customElements.get("free-shipping-threshold-bar")) {
  window.customElements.define("free-shipping-threshold-bar", FreeShippingThresholdBar);
}

// js/common/cart/cart-thresholds.js
// Multi-tier threshold / gift-with-purchase progress bar. Recomputes the qualifying spend on cart:change
// (each gift variant already in the cart counts as £0 for one unit, since it becomes free once its
// threshold is met) and updates the segmented fill, node states, and message.
// A tier can also carry a gift card (tier.giftCard): it is auto-added when the tier is met, swapped for a
// higher met tier's card, and removed like any gift when the spend drops. Only one is ever in the cart.
// Module-level lock so the outgoing + incoming elements (the drawer re-renders on a delay) never run two
// concurrent gift mutations.
var cartThresholdsGiftBusy = false;
// Line-item property that marks a tier's auto-added gift card (value: gwp_tier_N, same as the threshold
// attribute it also carries). Only one GWP gift card is ever in the cart — the highest met tier's.
var cartThresholdsGiftCardKey = "_gwp_gift_card_tier";
var CartThresholds = class extends HTMLElement {
  connectedCallback() {
    try {
      this.thresholds = JSON.parse(this.querySelector("[data-thresholds]")?.textContent || "[]");
    } catch (error) {
      this.thresholds = [];
    }
    this.giftIds = new Set((this.getAttribute("data-gift-variant-ids") || "").split(",").filter(Boolean).map(Number));
    this.totalPrice = parseFloat(this.getAttribute("data-total-price")) || 0;
    this._abortController = new AbortController();
    this._onCartChanged = this._onCartChanged.bind(this);
    document.addEventListener("cart:change", this._onCartChanged);
    // Delegated: the gift lines' "Remove" buttons live outside this element (in the gifts group), and the
    // "re-add" link is injected into the message HTML, so neither can be bound directly at render time.
    document.addEventListener("click", this._onGiftActionClick.bind(this), { signal: this._abortController.signal });
    this._bindModals();
    this._render();
    // Fetch the live cart so we can sync gifts against the current state (this element is re-created on every
    // re-render and misses the cart:change that triggered it).
    this._fetchAndSync();
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChanged);
    this._abortController?.abort();
  }
  _onCartChanged(event) {
    const cart = event.detail?.cart;
    if (!cart) {
      return;
    }
    this._cart = cart;
    this.totalPrice = this._computeTotal(cart);
    this._render();
    // Sync gifts immediately — the drawer re-renders .cart-drawer__inner on a 1.25s delay, so relying only on
    // the incoming element's connect would leave a dropped gift in the cart for over a second. Modal opening
    // is left to connect (allowModal false here) to avoid a flicker as this element is replaced.
    this._syncGifts(cart, false);
  }
  _computeTotal(cart) {
    let total = 0;
    for (const item of cart.items || []) {
      if (this.giftIds.has(item.variant_id)) {
        // One unit of a gift is (or will be) free — count only the extra paid units at full price.
        total += Math.max(0, item.quantity - 1) * (item.original_price ?? item.price);
      } else {
        total += item.final_line_price;
      }
    }
    const cartDiscount = (cart.cart_level_discount_applications || []).reduce((sum, discount) => sum + discount.total_allocated_amount, 0);
    return Math.max(0, total - cartDiscount);
  }
  // A tier is only usable when its configured amount is a real number. A blank/malformed monetary_threshold
  // serialises to null, and `total >= null` is `total >= 0` in JS — i.e. every tier would read as MET and the
  // gift would be added (and never removed) at any spend, including an empty cart. Never compare raw.
  _tierAmount(tier) {
    const amount = typeof tier?.amount === "string" ? parseFloat(tier.amount) : tier?.amount;
    if (Number.isFinite(amount)) {
      return amount;
    }
    // Unusable amount — the tier is inert here (never met, so it can neither add nor keep a gift). Surface it:
    // it means monetary_threshold didn't resolve to a number in this market, which is a data problem to fix.
    if (!this._warnedTiers) {
      this._warnedTiers = new Set();
    }
    if (tier && !this._warnedTiers.has(tier.index)) {
      this._warnedTiers.add(tier.index);
      console.warn("[cart-thresholds] threshold", tier.index, "(" + (tier.label || "unlabelled") + ") has no usable monetary_threshold in this market — got", tier.amount, "— tier disabled.");
    }
    return null;
  }
  _isMet(tier, total) {
    const amount = this._tierAmount(tier);
    return amount !== null && total >= amount;
  }
  _render() {
    const total = this.totalPrice;
    const thresholds = this.thresholds;
    if (!thresholds.length) {
      return;
    }
    this.querySelectorAll("[data-threshold-node]").forEach((node, i) => {
      if (thresholds[i]) {
        node.classList.toggle("is-met", this._isMet(thresholds[i], total));
      }
    });
    const fillEl = this.querySelector("[data-thresholds-fill]");
    if (fillEl) {
      fillEl.style.setProperty("--fill", this._fillPosition(total, thresholds));
    }
    this._renderMessage(total, thresholds);
  }
  // Fill fraction (0-1) across the evenly-spaced nodes: full segments for met thresholds, partial for the
  // segment currently in progress.
  _fillPosition(total, thresholds) {
    const n = thresholds.length;
    if (n <= 1) {
      // Single threshold: the node sits at the far right, so fill proportionally towards it.
      const amount = this._tierAmount(thresholds[0]);
      if (amount === null) {
        return 0;
      }
      return amount > 0 ? Math.min(1, total / amount) : 1;
    }
    let pos = 0;
    for (let i = 0; i < n - 1; i++) {
      const a = this._tierAmount(thresholds[i]);
      const b = this._tierAmount(thresholds[i + 1]);
      // An unusable amount can't place the fill — stop at the last position we could measure.
      if (a === null || b === null || b <= a) {
        break;
      }
      if (total >= b) {
        pos = i + 1;
      } else if (total >= a) {
        pos = i + (total - a) / (b - a);
        break;
      } else {
        break;
      }
    }
    return pos / (n - 1);
  }
  _renderMessage(total, thresholds) {
    const el = this.querySelector("[data-thresholds-message]");
    if (!el) {
      return;
    }
    let lastMet = null;
    let nextUnmet = null;
    for (const threshold of thresholds) {
      if (this._isMet(threshold, total)) {
        lastMet = threshold;
      } else if (!nextUnmet && this._tierAmount(threshold) !== null) {
        nextUnmet = threshold;
      }
    }
    const dismissed = this._dismissedTiers();
    const parts = [];
    // Any met gift tier the user manually removed gets its own line, replacing that tier's met message.
    for (const threshold of thresholds) {
      if (this._isMet(threshold, total) && threshold.giftTier > 0 && dismissed.has(threshold.giftTier)) {
        const label = this._escapeHtml(threshold.label || "Gift");
        parts.push(`${label} manually removed - <button type="button" class="link bold text-accent" data-gift-readd data-gift-tier="${threshold.giftTier}">re-add</button>`);
      }
    }
    // Same for a manually removed gift card (dismissed separately from its tier's gift).
    const cardTier = this._giftCardTier(total);
    if (cardTier && dismissed.has(this._giftCardDismissKey(cardTier))) {
      const label = this._escapeHtml(cardTier.giftCard.title || "Gift card");
      parts.push(`${label} manually removed - <button type="button" class="link bold text-accent" data-gift-card-readd data-gift-tier="${cardTier.giftTier}">re-add</button>`);
    }
    if (lastMet?.metMessage && !(lastMet.giftTier > 0 && dismissed.has(lastMet.giftTier))) {
      parts.push(this._formatMessage(lastMet.metMessage, lastMet, total));
    }
    if (nextUnmet?.notMetMessage) {
      parts.push(this._formatMessage(nextUnmet.notMetMessage, nextUnmet, total));
    }
    el.innerHTML = parts.join(" ") || "&nbsp;";
  }
  _formatMessage(message, threshold, total) {
    const money = (cents) => formatMoney(cents).replace(/[.,]00$/, "");
    const remaining = Math.max(0, threshold.amount - total);
    return (message || "")
      .replace(/\[remaining\]/g, `<span class="bold text-accent">${money(remaining)}</span>`)
      .replace(/\[variant_amount\]/g, `<span class="bold">${money(threshold.giftWorth)}</span>`);
  }
  _escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }
  // --- Manual gift dismissal ---
  // Stored in sessionStorage (as gift tier numbers) because this element is torn down and re-created on
  // every drawer re-render; without it the sync pass would immediately re-add a manually removed gift.
  _dismissedTiers() {
    try {
      return new Set(JSON.parse(sessionStorage.getItem("cart-thresholds:dismissed") || "[]"));
    } catch (error) {
      return new Set();
    }
  }
  _setTierDismissed(giftTier, dismissed) {
    const tiers = this._dismissedTiers();
    if (dismissed) {
      tiers.add(giftTier);
    } else {
      tiers.delete(giftTier);
    }
    try {
      sessionStorage.setItem("cart-thresholds:dismissed", JSON.stringify([...tiers]));
    } catch (error) {
      // Storage unavailable — dismissal simply won't survive the next re-render.
    }
  }
  _onGiftActionClick(event) {
    const removeButton = event.target.closest("[data-gift-remove]");
    if (removeButton) {
      const line = removeButton.closest("[data-gift-line]");
      const lineKey = line?.getAttribute("data-line-key");
      if (!lineKey) {
        return;
      }
      const variantId = parseInt(line.getAttribute("data-gift-variant-id"), 10);
      if (line.hasAttribute("data-gift-card")) {
        const cardTier = this.thresholds.find((t) => t.giftCard && t.giftCard.id === variantId);
        if (cardTier) {
          this._setTierDismissed(this._giftCardDismissKey(cardTier), true);
        }
      } else {
        const tier = this.thresholds.find((t) => (t.giftVariantIds || []).includes(variantId));
        if (tier) {
          this._setTierDismissed(tier.giftTier, true);
        }
      }
      this._removeGift(lineKey);
      this._render();
      return;
    }
    const cardReaddButton = event.target.closest("[data-gift-card-readd]");
    if (cardReaddButton && this.contains(cardReaddButton)) {
      const tier = this._tierByGiftTier(cardReaddButton.getAttribute("data-gift-tier"));
      if (!tier || !tier.giftCard) {
        return;
      }
      this._setTierDismissed(this._giftCardDismissKey(tier), false);
      this._addGift(tier, tier.giftCard.id, undefined, true);
      this._render();
      return;
    }
    const readdButton = event.target.closest("[data-gift-readd]");
    if (readdButton && this.contains(readdButton)) {
      const tier = this._tierByGiftTier(readdButton.getAttribute("data-gift-tier"));
      if (!tier) {
        return;
      }
      this._setTierDismissed(tier.giftTier, false);
      if (tier.multiChoice) {
        this._openModal(tier);
      } else {
        this._addGift(tier, tier.giftVariantIds[0]);
      }
      this._render();
    }
  }
  // --- Gift-with-purchase syncing ---
  _bindModals() {
    this.querySelectorAll("[data-threshold-modal]").forEach((modal) => {
      modal.querySelector(".threshold-modal__add")?.addEventListener("click", () => {
        this._resolveModal(modal, this._selectedVariant(modal));
      }, { signal: this._abortController.signal });
      // Dismissed (close / outside / esc) after an auto-open on a crossing — add the first pre-selected gift.
      modal.addEventListener("dialog:after-hide", () => {
        if (modal._autoOpen && !modal._resolved) {
          const tier = this._tierByGiftTier(modal.getAttribute("data-gift-tier"));
          if (tier) {
            this._resolveModal(modal, tier.giftVariantIds[0]);
          }
        }
        modal._autoOpen = false;
        modal._resolved = false;
      }, { signal: this._abortController.signal });
    });
  }
  _selectedVariant(modal) {
    const checked = modal.querySelector("[data-threshold-gift-input]:checked");
    return checked ? parseInt(checked.value, 10) : null;
  }
  _tierByGiftTier(giftTier) {
    return this.thresholds.find((tier) => String(tier.giftTier) === String(giftTier));
  }
  // The tier's chosen gift line — never its gift card, which carries the same tier attribute.
  _tierGiftLine(cart, tier) {
    const key = this.getAttribute("data-attribute-key");
    const want = `gwp_tier_${tier.giftTier}`;
    return (cart.items || []).find((item) => item.properties && item.properties[key] === want && !item.properties[cartThresholdsGiftCardKey]);
  }
  _tierGiftCardLine(cart, tier) {
    const want = `gwp_tier_${tier.giftTier}`;
    return (cart.items || []).find((item) => item.properties && item.properties[cartThresholdsGiftCardKey] === want);
  }
  // Gift card dismissals share the sessionStorage set with tier dismissals under a distinct string key, so
  // removing the card never dismisses the tier's gift (and vice versa).
  _giftCardDismissKey(tier) {
    return `gift-card:${tier.giftTier}`;
  }
  // The single tier whose gift card belongs in the cart right now: the highest met GWP tier that offers one
  // in this market. Null when no met tier has a gift card.
  _giftCardTier(total) {
    let best = null;
    for (const tier of this.thresholds) {
      if (tier.type !== "GWP" || !tier.giftCard || !this._isMet(tier, total)) {
        continue;
      }
      if (!best || this._tierAmount(tier) > this._tierAmount(best)) {
        best = tier;
      }
    }
    return best;
  }
  // A market switch reloads the page and re-renders this element with the active market's thresholds/gifts,
  // Every cart line carrying the threshold attribute, whatever tier it claims — the authoritative list of
  // gifts to validate. Driven by the CART (not by the configured tiers) so a gift whose tier no longer exists
  // in this market is still seen: walking this.thresholds alone would skip it and leave it in the cart.
  _cartGiftLines(cart) {
    const key = this.getAttribute("data-attribute-key");
    return (cart.items || []).filter((item) => item.properties && item.properties[key]);
  }
  // Remove one or more gift lines by key, then reconcile the drawer authoritatively. change.js targets a
  // specific line by key regardless of its position, so removals are safe to apply sequentially.
  async _removeGiftLines(keys) {
    if (!keys.length || cartThresholdsGiftBusy) {
      return;
    }
    cartThresholdsGiftBusy = true;
    // Optimistically collapse + remove the lines (no full re-render, so they don't flash back in). Run the
    // collapse and the requests in parallel so the ease-out is allowed to finish.
    const lines = keys.map((k) => this._giftLineByKey(k)).filter(Boolean);
    lines.forEach((line) => line.classList.add("cart-gift-line--removing"));
    try {
      await Promise.all([
        (async () => {
          for (const key of keys) {
            await fetch(`${shopifyRoot}cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          }
        })(),
        lines.length ? new Promise((resolve) => setTimeout(resolve, 260)) : Promise.resolve()
      ]);
      lines.forEach((line) => line.remove());
      const list = this._giftsList();
      if (list && !list.querySelector("[data-gift-line]")) {
        this._giftsGroup()?.setAttribute("hidden", "");
      }
      // Reconcile authoritatively (correct total, collapsed group) and detach the stale delayed re-render.
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (error) {
      console.error(error);
      lines.forEach((line) => line.classList.remove("cart-gift-line--removing"));
    } finally {
      cartThresholdsGiftBusy = false;
    }
  }
  async _fetchAndSync() {
    try {
      const cart = await (await fetch(`${shopifyRoot}cart.js`)).json();
      this._cart = cart;
      this.totalPrice = this._computeTotal(cart);
      this._render();
      this._syncGifts(cart, true);
    } catch (error) {
      console.error(error);
    }
  }
  // Adds a gift when its GWP threshold is met (single-choice auto, multi-choice via modal) and removes it
  // when the threshold is no longer met. One operation at a time; the resulting re-render re-syncs.
  _syncGifts(cart, allowModal) {
    if (cartThresholdsGiftBusy || !cart) {
      return;
    }
    const dismissed = this._dismissedTiers();

    // Pass 1 — VALIDATE what's already in the cart, driven by the cart's own gift lines. A gift is kept only
    // while every condition that earned it still holds; anything else is dropped. This runs cart-first (not
    // tier-first) because the tier that justified a gift can vanish or change under the shopper: switching
    // market (UK -> US) re-renders this element with that market's thresholds and gift availability, and the
    // old logic skipped any tier offering no gifts here — leaving an orphaned gift that survived removing
    // every paid item and went through to checkout for free.
    const key = this.getAttribute("data-attribute-key");

    // The one gift card that belongs in the cart (if any): the highest met tier offering one, unless the
    // shopper removed it. Like tier dismissals, dropping back below that tier resets the dismissal.
    const cardTier = this._giftCardTier(this.totalPrice);
    for (const tier of this.thresholds) {
      const cardKey = tier.giftCard ? this._giftCardDismissKey(tier) : null;
      if (cardKey && dismissed.has(cardKey) && !this._isMet(tier, this.totalPrice)) {
        this._setTierDismissed(cardKey, false);
        dismissed.delete(cardKey);
      }
    }
    const wantCard = cardTier && !dismissed.has(this._giftCardDismissKey(cardTier)) ? cardTier : null;

    const staleKeys = [];
    let staleCardKey = null;
    for (const item of this._cartGiftLines(cart)) {
      if (item.properties[cartThresholdsGiftCardKey]) {
        // A gift card survives only while it is THE card: right variant, tagged with the highest met tier.
        // A lower tier's card (or a card from a tier this market doesn't run) is stale.
        const keepCard = !!wantCard
          && item.variant_id === wantCard.giftCard.id
          && item.properties[cartThresholdsGiftCardKey] === `gwp_tier_${wantCard.giftTier}`;
        if (!keepCard) {
          staleKeys.push(item.key);
          staleCardKey = item.key;
        }
        continue;
      }
      const giftTier = parseInt(String(item.properties[key]).replace("gwp_tier_", ""), 10);
      const tier = this._tierByGiftTier(giftTier);
      const keep = !!tier
        && (tier.giftVariantIds || []).includes(item.variant_id)
        && this._isMet(tier, this.totalPrice)
        && !dismissed.has(tier.giftTier);
      if (!keep) {
        staleKeys.push(item.key);
      }
      // Dropping back below the threshold resets the dismissal, so a fresh crossing re-adds as normal.
      if (tier && dismissed.has(tier.giftTier) && !this._isMet(tier, this.totalPrice)) {
        this._setTierDismissed(tier.giftTier, false);
        dismissed.delete(tier.giftTier);
      }
    }
    if (staleKeys.length) {
      // Moving the gift card up to a higher tier is a single swap (add the new card, then remove the old)
      // so it never visibly vanishes and reappears. Anything else is a plain removal.
      if (wantCard && staleKeys.length === 1 && staleCardKey && !this._tierGiftCardLine(cart, wantCard)) {
        this._addGift(wantCard, wantCard.giftCard.id, staleCardKey, true);
        return;
      }
      // The resulting cart:refresh re-runs this with a clean cart, so the add pass below fills in this
      // market's correct gift on the next tick.
      this._removeGiftLines(staleKeys);
      return;
    }

    // Pass 2a — ADD the gift card for the highest met tier. It needs no choice, so it goes in before any
    // gift modal opens; the resulting cart:refresh re-syncs and handles the tier's gift next.
    if (wantCard && !this._tierGiftCardLine(cart, wantCard)) {
      this._addGift(wantCard, wantCard.giftCard.id, undefined, true);
      return;
    }

    // Pass 2b — ADD a gift for any tier that is met, offers a gift here, and isn't already satisfied.
    for (const tier of this.thresholds) {
      if (tier.type !== "GWP" || !(tier.giftVariantIds || []).length) {
        continue;
      }
      if (!this._isMet(tier, this.totalPrice)) {
        // Below the threshold: reset a dismissal so a fresh crossing re-adds as normal.
        if (dismissed.has(tier.giftTier)) {
          this._setTierDismissed(tier.giftTier, false);
        }
        continue;
      }
      // Manually removed by the shopper — the message offers a "re-add" link instead.
      if (dismissed.has(tier.giftTier)) {
        continue;
      }
      if (this._tierGiftLine(cart, tier)) {
        continue;
      }
      if (tier.multiChoice) {
        if (allowModal) {
          this._openModal(tier);
        }
      } else {
        this._addGift(tier, tier.giftVariantIds[0]);
      }
      return;
    }
  }
  _openModal(tier) {
    const modal = this.querySelector(`[data-threshold-modal][data-gift-tier="${tier.giftTier}"]`);
    if (!modal || modal.open) {
      return;
    }
    modal._autoOpen = true;
    modal._resolved = false;
    modal.show();
  }
  async _resolveModal(modal, variantId) {
    if (!variantId) {
      return;
    }
    modal._resolved = true;
    const tier = this._tierByGiftTier(modal.getAttribute("data-gift-tier"));
    if (!tier) {
      return;
    }
    const existing = this._cart ? this._tierGiftLine(this._cart, tier) : null;
    if (existing && existing.variant_id === variantId) {
      if (modal.open) {
        modal.hide();
      }
      return;
    }
    // Spinner on the Add button (custom-button loader) while the cart updates, then reset + close. The modal
    // persists (no re-render), so the busy state must be cleared explicitly.
    const addButton = modal.querySelector(".threshold-modal__add");
    addButton?.setAttribute("aria-busy", "true");
    await this._addGift(tier, variantId, existing?.key);
    addButton?.removeAttribute("aria-busy");
    if (modal.open) {
      modal.hide();
    }
  }
  _giftsGroup() {
    return document.querySelector('.cart-drawer__group[data-group="gifts"]');
  }
  _giftsList() {
    return this._giftsGroup()?.querySelector(".cart-drawer__line-items");
  }
  _giftLineByKey(lineKey) {
    const key = window.CSS && CSS.escape ? CSS.escape(lineKey) : lineKey;
    return document.querySelector(`[data-gift-line][data-line-key="${key}"]`);
  }
  _giftData(variantId) {
    for (const tier of this.thresholds) {
      const gift = (tier.gifts || []).find((g) => g.id === variantId);
      if (gift) {
        return gift;
      }
      if (tier.giftCard && tier.giftCard.id === variantId) {
        return tier.giftCard;
      }
    }
    return null;
  }
  // Builds a gift line matching cart-gift-line.liquid so the optimistic insert survives the eventual re-render.
  _buildGiftLine(tier, gift, isGiftCard) {
    const line = document.createElement("div");
    line.className = "cart-gift-line cart-gift-line--entering";
    line.setAttribute("data-gift-line", "");
    line.setAttribute("data-gift-variant-id", gift.id);
    if (isGiftCard) {
      line.setAttribute("data-gift-card", "");
    }
    if (gift.image) {
      const img = document.createElement("img");
      img.className = "cart-gift-line__image";
      img.src = gift.image;
      img.alt = "";
      img.loading = "lazy";
      img.width = 64;
      img.height = 64;
      line.appendChild(img);
    }
    const info = document.createElement("div");
    info.className = "cart-gift-line__info v-stack gap-1";
    const title = document.createElement(gift.url ? "a" : "p");
    title.className = "subheading-3";
    if (gift.url) {
      title.href = gift.url;
    }
    const titleSpan = document.createElement("span");
    if (gift.url) {
      titleSpan.className = "reversed-link hover:show";
    }
    titleSpan.textContent = decodeEntities(gift.title);
    title.appendChild(titleSpan);
    info.appendChild(title);
    // Mimic price-list, applying this tier's real discount (percentage, fixed amount off, or fixed price)
    // so the optimistic price is correct — not assumed free. cart:refresh reconciles against the server.
    const worth = gift.worth || 0;
    let finalCents = worth;
    if (tier.discountType === "percentage") {
      finalCents = Math.round(worth * (1 - (tier.discountValue || 0) / 100));
    } else if (tier.discountType === "fixed_amount") {
      finalCents = Math.max(0, worth - (tier.discountValue || 0));
    } else if (tier.discountType === "fixed_price") {
      finalCents = Math.max(0, tier.discountValue || 0);
    }
    const priceList = document.createElement("price-list");
    priceList.className = "price-list";
    priceList.innerHTML = giftPriceMarkup(finalCents, finalCents < worth ? worth : 0);
    info.appendChild(priceList);
    line.appendChild(info);
    const actions = document.createElement("div");
    actions.className = "cart-gift-line__actions h-stack gap-2 align-center";
    if (tier.multiChoice && !isGiftCard) {
      const change = document.createElement("button");
      change.type = "button";
      change.className = "link light text-xs cart-gift-line__change";
      change.setAttribute("aria-controls", `threshold-modal-${tier.giftTier}`);
      change.textContent = "Change";
      actions.appendChild(change);
      const separator = document.createElement("span");
      separator.className = "text-xs text-subdued";
      separator.textContent = "/";
      actions.appendChild(separator);
    }
    const remove = document.createElement("button");
    remove.type = "button";
    remove.className = "link light text-xs cart-gift-line__remove";
    remove.setAttribute("data-gift-remove", "");
    remove.textContent = "Remove";
    actions.appendChild(remove);
    line.appendChild(actions);
    return line;
  }
  // isGiftCard adds the tier's gift card instead of a chosen gift: same tier attribute (so it groups, renders
  // and is discounted like a gift) plus the gift-card marker property.
  async _addGift(tier, variantId, removeKey, isGiftCard) {
    if (cartThresholdsGiftBusy) {
      return;
    }
    cartThresholdsGiftBusy = true;
    // Optimistically insert (or swap in) the real gift line — no full re-render, so no flash.
    const gift = this._giftData(variantId);
    const list = this._giftsList();
    const oldLine = removeKey ? this._giftLineByKey(removeKey) : null;
    let optimisticLine = null;
    if (gift && list) {
      optimisticLine = this._buildGiftLine(tier, gift, isGiftCard);
      this._giftsGroup().removeAttribute("hidden");
      if (oldLine) {
        oldLine.replaceWith(optimisticLine);
      } else {
        // Prepend so higher tiers (crossed later) sit above lower ones — matches the reversed server order.
        list.prepend(optimisticLine);
      }
    } else if (oldLine) {
      oldLine.remove();
    }
    try {
      const properties = {};
      properties[this.getAttribute("data-attribute-key")] = `gwp_tier_${tier.giftTier}`;
      if (isGiftCard) {
        properties[cartThresholdsGiftCardKey] = `gwp_tier_${tier.giftTier}`;
      }
      const added = await (await fetch(`${shopifyRoot}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
      })).json();
      const key = (added.items ? added.items[0] : added)?.key;
      if (key && optimisticLine) {
        optimisticLine.setAttribute("data-line-key", key);
      }
      if (removeKey) {
        await fetch(`${shopifyRoot}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: removeKey, quantity: 0 })
        });
      }
      // Reconcile authoritatively: cart:refresh re-fetches the section and replaceChildren()s the whole drawer,
      // which also detaches the old .cart-drawer__inner so any pending delayed re-render writes to a dead node.
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (error) {
      console.error(error);
      optimisticLine?.remove();
    } finally {
      cartThresholdsGiftBusy = false;
    }
  }
  async _removeGift(lineKey) {
    return this._removeGiftLines([lineKey]);
  }
};
if (!window.customElements.get("cart-thresholds")) {
  window.customElements.define("cart-thresholds", CartThresholds);
}

var CartRecommendations = class extends HTMLElement {
  connectedCallback() {
    if (this._loaded) {
      return;
    }
    this._loaded = true;
    const url = this.getAttribute("data-url");
    if (!url) {
      return;
    }
    fetch(url, { priority: "low" })
      .then((response) => response.text())
      .then((responseText) => {
        const fetchedDocument = new DOMParser().parseFromString(responseText, "text/html");
        const root = fetchedDocument.querySelector(".shopify-section") || fetchedDocument.body;
        const rendered = root.querySelector("cart-recommendations");
        if (rendered && rendered.innerHTML.trim().length) {
          this.innerHTML = rendered.innerHTML;
          this.dispatchEvent(new CustomEvent("recommendations:loaded", { bubbles: true }));
        } else {
          this.setAttribute("hidden", "");
        }
      })
      .catch((error) => console.error(error));
  }
};
if (!window.customElements.get("cart-recommendations")) {
  window.customElements.define("cart-recommendations", CartRecommendations);
}

// Reviews.io rating snippets (.ruk_rating_snippet[data-sku]) are populated by a DOM scan that marks each node
// processed. The cart drawer keeps producing fresh, unprocessed nodes its scan misses — recommendations load
// over AJAX, and the drawer inner re-renders on every cart change (replacing populated stars with empty
// nodes), a re-render that is deliberately delayed ~1.25s for non-"variant:add" changes. Rather than guess
// that timing, watch the drawer subtree and re-init Reviews.io whenever a rating-snippet node is inserted;
// reinitialiseRatingSnippet only touches unprocessed nodes, so populated snippets elsewhere aren't disturbed.
(function reinitCartRatingSnippets() {
  let reinitTimer = null;
  const reload = () => {
    if (typeof window.reinitialiseRatingSnippet === "function") {
      window.reinitialiseRatingSnippet();
    }
  };
  const schedule = () => {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(reload, 150);
  };
  const hasSnippet = (node) =>
    node.nodeType === 1 && (node.matches?.(".ruk_rating_snippet") || node.querySelector?.(".ruk_rating_snippet"));
  const observeDrawer = () => {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer || drawer._ratingObserver) {
      return;
    }
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (hasSnippet(node)) {
            schedule();
            return;
          }
        }
      }
    });
    observer.observe(drawer, { childList: true, subtree: true });
    drawer._ratingObserver = observer;
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeDrawer);
  } else {
    observeDrawer();
  }
  // Initial open: the snippets exist but were unprocessed while the drawer was hidden during the page scan.
  document.addEventListener("dialog:after-show", (event) => {
    if (event.target?.closest?.("#cart-drawer")) {
      schedule();
    }
  });
})();

// Open the cart drawer once on arrival when flagged: either by the standalone cart page's redirect
// (see sections/main-cart.liquid — sessionStorage flag), or by a ?cart=open URL param on any page
// (for links from emails/SMS that should land with the drawer open, without leaving the page).
(function openCartDrawerOnArrival() {
  const open = () => {
    let flagged = null;
    try {
      flagged = sessionStorage.getItem("open-cart-drawer");
    } catch (error) {
      flagged = null;
    }
    const params = new URLSearchParams(window.location.search);
    const fromParam = params.get("cart") === "open";
    if (!flagged && !fromParam) {
      return;
    }
    try {
      sessionStorage.removeItem("open-cart-drawer");
    } catch (error) {}
    if (fromParam) {
      // Strip the param so a refresh (or copied/shared URL) doesn't reopen the drawer.
      params.delete("cart");
      const query = params.toString();
      history.replaceState(history.state, "", window.location.pathname + (query ? `?${query}` : "") + window.location.hash);
    }
    customElements.whenDefined("cart-drawer").then(() => {
      const drawer = document.getElementById("cart-drawer");
      if (drawer && typeof drawer.show === "function") {
        drawer.show();
      }
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", open);
  } else {
    open();
  }
})();

// js/common/cart/line-item-quantity.js
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onQuantityChanged);
    this.addEventListener("click", this._onRemoveLinkClicked);
  }
  _onQuantityChanged(event) {
    if (!event.target.hasAttribute("data-line-key")) {
      return;
    }
    this._changeLineItemQuantity(event.target.getAttribute("data-line-key"), parseInt(event.target.value));
  }
  _onRemoveLinkClicked(event) {
    if (event.target.tagName !== "A" || !event.target.href.includes("/cart/change")) {
      return;
    }
    event.preventDefault();
    const url = new URL(event.target.href);
    this._changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")));
  }
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${shopifyRoot}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${shopifyRoot}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        })
      })).json();
      // An error response (e.g. a stale line key after a selling-plan change re-keyed the line) has no
      // items array. Re-sync the drawer instead of throwing.
      if (!cartContent || !Array.isArray(cartContent["items"])) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        return;
      }
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
    }
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// Decodes HTML entities (e.g. &amp; -> &) so values from JSON/attributes render correctly via textContent,
// which — unlike the browser's HTML parsing the server output relies on — does not decode them itself.
function decodeEntities(value) {
  if (!value) {
    return value;
  }
  const el = document.createElement("textarea");
  el.innerHTML = value;
  return el.value;
}

// Price markup mirroring snippets/price-list.liquid (line-item case) for an optimistic gift line. When the
// server-computed final price is 0 the discount has applied, so it reads "Free" with the original struck.
function giftPriceMarkup(finalCents, compareCents) {
  const onSale = compareCents > finalCents;
  const label = finalCents === 0 ? "FREE" : formatMoney(finalCents);
  let markup = `<sale-price class="text-sm${onSale ? " text-on-sale" : ""}">${label}</sale-price>`;
  if (onSale) {
    markup += `<compare-at-price class="text-sm text-subdued line-through">${formatMoney(compareCents)}</compare-at-price>`;
  }
  return markup;
}

// Rewrites a line's <price-list> to show the new price (cents), striking the compare price when higher.
// Shared by the bulk upgrade/downgrade and the single-line frequency picker optimistic updates.
function renderOptimisticPrice(priceList, priceCents, compareCents) {
  const sale = priceList.querySelector("sale-price");
  if (!sale) {
    return;
  }
  const onSale = compareCents > priceCents;
  sale.innerHTML = `${sale.querySelector(".sr-only")?.outerHTML || ""}${formatMoney(priceCents)}`;
  sale.classList.toggle("text-on-sale", onSale);
  let compare = priceList.querySelector("compare-at-price");
  if (onSale) {
    if (!compare) {
      compare = document.createElement("compare-at-price");
      compare.className = "text-sm text-subdued line-through";
      sale.after(compare);
    }
    compare.innerHTML = `${compare.querySelector(".sr-only")?.outerHTML || ""}${formatMoney(compareCents)}`;
  } else if (compare) {
    compare.remove();
  }
}

// Optimistically reflects a plan change on one cart line: dims/shimmers it, updates the trigger label,
// highlight, and price, and moves it to the matching group (with visibility). Returns a single undo fn.
function applyOptimisticLine(line, subscription, { becomingSubscription, name, price, compare, subscribeLabel }) {
  const rollbacks = [];
  const drawer = line.closest("cart-drawer");
  line.classList.add("is-updating");
  rollbacks.push(() => line.classList.remove("is-updating"));
  const label = subscription?.querySelector('[id$="-value"]');
  if (label) {
    const original = label.textContent;
    label.textContent = becomingSubscription ? decodeEntities(name) : subscribeLabel;
    rollbacks.push(() => { label.textContent = original; });
  }
  // Highlight prompts a one-time line to subscribe — on (one-time) / off (subscription).
  const trigger = subscription?.querySelector(".line-item-subscription__trigger");
  if (trigger && trigger.classList.contains("highlight") === becomingSubscription) {
    trigger.classList.toggle("highlight", !becomingSubscription);
    rollbacks.push(() => trigger.classList.toggle("highlight", becomingSubscription));
  }
  const priceList = line.querySelector("price-list");
  if (priceList && !Number.isNaN(price)) {
    const originalHTML = priceList.innerHTML;
    renderOptimisticPrice(priceList, price, compare);
    rollbacks.push(() => { priceList.innerHTML = originalHTML; });
  }
  // Move to the matching group if the subscription state changed.
  const destGroup = drawer?.querySelector(`.cart-drawer__group[data-group="${becomingSubscription ? "subscription" : "onetime"}"]`);
  const destList = destGroup?.querySelector(".cart-drawer__line-items");
  const sourceGroup = line.closest(".cart-drawer__group");
  if (destList && destGroup !== sourceGroup) {
    const parent = line.parentElement;
    const nextSibling = line.nextElementSibling;
    rollbacks.push(() => nextSibling ? parent.insertBefore(line, nextSibling) : parent.appendChild(line));
    destList.appendChild(line);
    [sourceGroup, destGroup].filter(Boolean).forEach((g) => {
      const hasLines = !!g.querySelector(".cart-drawer__line-items")?.children.length;
      const wasHidden = g.hasAttribute("hidden");
      if (hasLines === wasHidden) {
        g.toggleAttribute("hidden", !hasLines);
        rollbacks.push(() => g.toggleAttribute("hidden", wasHidden));
      }
    });
  }
  return () => rollbacks.forEach((fn) => fn());
}

// js/common/cart/line-item-subscription.js
// Switches a cart line item between one-time and a subscription selling plan (and between frequencies).
// Skio uses native Shopify selling plans, so we change the line's selling_plan via /cart/change.js, then
// force a full cart drawer refresh.
var LineItemSubscription = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    // NB: `popover` is a reserved property on HTMLElement (native Popover API), so use `_popover`.
    this._popover = this.querySelector("x-popover");
    // Skio plan names can arrive HTML-encoded, so the server output leaves a stray &amp; after the browser
    // decodes one level. Decode the trigger + option labels once more so "&" renders correctly.
    this.querySelectorAll('[id$="-value"], .popover-listbox__option .reversed-link').forEach((el) => {
      const decoded = decodeEntities(el.textContent);
      if (decoded !== el.textContent) {
        el.textContent = decoded;
      }
    });
    this._onDocumentPointerDown = this._onDocumentPointerDown.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    // The x-listbox in the frequency popover fires a bubbling listbox:select with the chosen
    // selling plan id (empty string for one-time); the popover closes itself.
    this.addEventListener("listbox:select", (event) => this._switch(event.detail.value), { signal: this._abortController.signal });
    // The popover uses no-focus-trap (to avoid corrupting the cart drawer's focus trap), so we provide
    // outside-click and Escape dismissal ourselves while it is open.
    this._popover?.addEventListener("toggle", () => this._syncDismiss(), { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController?.abort();
    this._removeDismiss();
  }
  _syncDismiss() {
    if (this._popover?.open) {
      // Defer so the click that opened the popover isn't immediately treated as an outside click.
      requestAnimationFrame(() => {
        if (!this._popover?.open) {
          return;
        }
        document.addEventListener("pointerdown", this._onDocumentPointerDown);
        document.addEventListener("keydown", this._onKeydown);
      });
    } else {
      this._removeDismiss();
    }
  }
  _removeDismiss() {
    document.removeEventListener("pointerdown", this._onDocumentPointerDown);
    document.removeEventListener("keydown", this._onKeydown);
  }
  _onDocumentPointerDown(event) {
    if (this._popover && !this._popover.contains(event.target) && !event.target.closest(`[aria-controls="${this._popover.id}"]`)) {
      this._popover.hide();
    }
  }
  _onKeydown(event) {
    if (event.key === "Escape") {
      this._popover?.hide();
    }
  }
  async _switch(sellingPlan) {
    if (this._busy) {
      return;
    }
    this._busy = true;
    // The CSS swaps the chevron for a spinner via [aria-busy].
    this.setAttribute("aria-busy", "true");
    // Lock the whole line so no concurrent /cart/change.js can race the switch. Removed on error; on success
    // the re-render replaces the line.
    const lineItem = this.closest("line-item");
    lineItem?.setAttribute("inert", "");
    const trigger = this.querySelector(".line-item-subscription__trigger");
    if (trigger) {
      trigger.disabled = true;
    }
    // Optimistically reflect the chosen plan on this line (dim/shimmer, label, price, highlight, group).
    const optionKey = window.CSS && CSS.escape ? CSS.escape(sellingPlan) : sellingPlan;
    const option = this._popover?.querySelector(`.popover-listbox__option[value="${optionKey}"]`);
    const rollback = lineItem ? applyOptimisticLine(lineItem, this, {
      becomingSubscription: sellingPlan !== "",
      name: option?.getAttribute("data-frequency-name") || "",
      price: parseInt(option?.getAttribute("data-price"), 10),
      compare: parseInt(option?.getAttribute("data-compare"), 10) || 0,
      subscribeLabel: "Click to Auto-Replenish \u0026amp; Save 20%"
    }) : () => {};
    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${shopifyRoot}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: this.getAttribute("data-line-key"),
          quantity: parseInt(this.getAttribute("data-quantity")) || 1,
          selling_plan: sellingPlan === "" ? null : sellingPlan,
          sections: sectionsToBundle
        })
      })).json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart: cartContent } }));
    } catch (error) {
      console.error(error);
      this._busy = false;
      this.removeAttribute("aria-busy");
      lineItem?.removeAttribute("inert");
      rollback();
      if (trigger) {
        trigger.disabled = false;
      }
    }
  }
};
if (!window.customElements.get("line-item-subscription")) {
  window.customElements.define("line-item-subscription", LineItemSubscription);
}

// js/common/cart/cart-bulk-subscription.js
// Bulk "upgrade all to Auto-Replenish" / "downgrade to one-time" CTA. Applies a list of selling-plan
// changes (by line index) sequentially via /cart/change.js — highest index first, since a selling-plan
// change re-adds the line at the end, so lower (unprocessed) indices stay valid. The last change.js
// bundles the cart sections, and the result re-renders through the theme's cart:change flow. The group is
// held inert during the run so no concurrent /cart/change.js can race it.
var CartBulkSubscription = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.button = this.querySelector("button");
    this.button?.addEventListener("click", () => this._run(), { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  async _run() {
    if (this._busy) {
      return;
    }
    let targets;
    try {
      targets = JSON.parse(this.getAttribute("data-targets") || "[]");
    } catch (error) {
      targets = [];
    }
    if (!targets.length) {
      return;
    }
    this._busy = true;
    // Loading state — the optimistic pass morphs this into the disabled opposite-action button; [aria-busy]
    // keeps the spinner alongside its label. The cart re-renders on success and replaces it (enabled).
    this.setAttribute("aria-busy", "true");
    if (this.button) {
      this.button.setAttribute("disabled", "true");
    }
    // Lock BOTH groups (quantity steppers, remove links, per-line subscription toggles) so the customer can't
    // fire a concurrent /cart/change.js — those race with our sequential line changes — and so lines we
    // optimistically move into the destination group stay locked too.
    const groups = Array.from(this.closest("cart-drawer")?.querySelectorAll(".cart-drawer__group") || []);
    groups.forEach((g) => g.setAttribute("inert", ""));
    // Optimistically move/relabel/reprice the affected lines and update the total so it feels instant.
    const rollback = this._applyOptimistic();
    // Apply highest line index first: if a selling-plan change re-adds the line at the end of the cart,
    // the lower (still-unprocessed) indices stay valid.
    targets.sort((a, b) => b.line - a.line);
    // Bundle the cart sections into the final change.js so we skip a separate /cart/update.js round-trip.
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    try {
      let cartContent = null;
      for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        // Pass quantity explicitly: changing selling_plan re-keys the line, and Shopify resets it to qty 1
        // unless we send the current quantity.
        const body = { line: target.line, selling_plan: target.plan || null };
        if (target.quantity != null) {
          body.quantity = target.quantity;
        }
        // Only the last change.js needs to render sections (against the final cart state).
        if (i === targets.length - 1 && sectionsToBundle.length) {
          body.sections = sectionsToBundle;
        }
        cartContent = await (await fetch(`${shopifyRoot}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        })).json();
      }
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart: cartContent } }));
    } catch (error) {
      console.error(error);
      this._busy = false;
      this.removeAttribute("aria-busy");
      groups.forEach((g) => g.removeAttribute("inert"));
      rollback();
      if (this.button) {
        this.button.removeAttribute("disabled");
      }
    }
  }
  // Optimistically reflects the whole operation — total, plus each affected line moved to the destination
  // group with its subscription label and price updated — and returns a single undo fn.
  _applyOptimistic() {
    const rollbacks = [this._applyOptimisticTotal()];
    const undo = () => rollbacks.forEach((fn) => fn());
    const drawer = this.closest("cart-drawer");
    if (!drawer) {
      return undo;
    }
    const isUpgrade = this.getAttribute("data-action") === "upgrade";
    const sourceGroup = this.closest(".cart-drawer__group");
    const destGroup = drawer.querySelector(`.cart-drawer__group[data-group="${isUpgrade ? "subscription" : "onetime"}"]`);
    const destList = destGroup?.querySelector(".cart-drawer__line-items");
    let targets;
    try {
      targets = JSON.parse(this.getAttribute("data-targets") || "[]");
    } catch (error) {
      targets = [];
    }
    for (const target of targets) {
      if (!target.key) {
        continue;
      }
      const key = window.CSS && CSS.escape ? CSS.escape(target.key) : target.key;
      const subscription = drawer.querySelector(`line-item-subscription[data-line-key="${key}"]`);
      const line = subscription?.closest("line-item");
      if (!line) {
        continue;
      }
      // Remember the original position so rollback can restore it, then move to the destination group.
      const parent = line.parentElement;
      const nextSibling = line.nextElementSibling;
      rollbacks.push(() => nextSibling ? parent.insertBefore(line, nextSibling) : parent.appendChild(line));
      // Flag this line as updating so its quantity + frequency controls dim and shimmer.
      line.classList.add("is-updating");
      rollbacks.push(() => line.classList.remove("is-updating"));
      const becomingSubscription = !!(target.name && target.name.length);
      // Trigger label → the target frequency, or the one-time "Subscribe" default.
      const label = subscription.querySelector('[id$="-value"]');
      if (label) {
        const original = label.textContent;
        label.textContent = becomingSubscription ? decodeEntities(target.name) : "Click to Auto-Replenish \u0026amp; Save 20%";
        rollbacks.push(() => { label.textContent = original; });
      }
      // Highlight prompts a one-time line to subscribe — on (one-time) / off (subscription).
      const trigger = subscription.querySelector(".line-item-subscription__trigger");
      if (trigger && trigger.classList.contains("highlight") === becomingSubscription) {
        trigger.classList.toggle("highlight", !becomingSubscription);
        rollbacks.push(() => trigger.classList.toggle("highlight", becomingSubscription));
      }
      // Price → discounted with the one-time price struck (upgrade), or plain one-time (downgrade).
      const priceList = line.querySelector("price-list");
      if (priceList) {
        const originalHTML = priceList.innerHTML;
        renderOptimisticPrice(priceList, target.price, target.compare);
        rollbacks.push(() => { priceList.innerHTML = originalHTML; });
      }
      if (destList) {
        destList.appendChild(line);
      }
    }
    // Move the button (still showing its own "Upgrading…/Downgrading…" spinner) to where the opposite action
    // will render, so it enables in place after the re-render rather than the source group hiding it and the
    // opposite button popping in elsewhere. If the destination already has a bulk button, or the opposite
    // action is disabled, just hide this one instead.
    const existingDestButton = destGroup?.querySelector("cart-bulk-subscription");
    const oppositeWillRender = this.getAttribute("data-show-opposite") === "true";
    if (destGroup && !existingDestButton && oppositeWillRender) {
      const parent = this.parentElement;
      const nextSibling = this.nextElementSibling;
      rollbacks.push(() => nextSibling ? parent.insertBefore(this, nextSibling) : parent.appendChild(this));
      destGroup.appendChild(this);
    } else {
      // Nothing lands here — hide this button so it doesn't linger in the group the products left.
      const wasHidden = this.hasAttribute("hidden");
      this.setAttribute("hidden", "");
      rollbacks.push(() => this.toggleAttribute("hidden", wasHidden));
    }
    // Show/hide each group depending on whether it still has any lines.
    [sourceGroup, destGroup].filter(Boolean).forEach((g) => {
      const hasLines = !!g.querySelector(".cart-drawer__line-items")?.children.length;
      const wasHidden = g.hasAttribute("hidden");
      if (hasLines === wasHidden) {
        g.toggleAttribute("hidden", !hasLines);
        rollbacks.push(() => g.toggleAttribute("hidden", wasHidden));
      }
    });
    return undo;
  }
  // Applies the data-total-delta to the checkout total (cents on data-cart-total) and returns an undo fn.
  _applyOptimisticTotal() {
    const delta = parseInt(this.getAttribute("data-total-delta"), 10) || 0;
    const totalEl = this.closest("cart-drawer")?.querySelector(".cart-drawer__checkout-total");
    const currentCents = totalEl ? parseInt(totalEl.getAttribute("data-cart-total"), 10) : NaN;
    if (!delta || !totalEl || Number.isNaN(currentCents)) {
      return () => {};
    }
    const originalText = totalEl.textContent;
    const originalCents = totalEl.getAttribute("data-cart-total");
    const newCents = Math.max(0, currentCents + delta);
    totalEl.textContent = formatMoney(newCents);
    totalEl.setAttribute("data-cart-total", newCents);
    return () => {
      totalEl.textContent = originalText;
      totalEl.setAttribute("data-cart-total", originalCents);
    };
  }
};
if (!window.customElements.get("cart-bulk-subscription")) {
  window.customElements.define("cart-bulk-subscription", CartBulkSubscription);
}

// js/common/cart/shipping-estimator.js
var ShippingEstimator = class extends HTMLElement {
  constructor() {
    super();
    this._estimateShippingListener = this._estimateShipping.bind(this);
  }
  connectedCallback() {
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;
    this.submitButton.addEventListener("click", this._estimateShippingListener);
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener("click", this._estimateShippingListener);
  }
  /**
   * @doc https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   */
  async _estimateShipping(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value, country = this.querySelector('[name="address[country]"]').value, province = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(`${shopifyRoot}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(zip, country, province);
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    this.resultsElement.hidden = false;
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(`${shopifyRoot}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
    const responseAsText = await response.text();
    if (responseAsText === "null") {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)["shipping_rates"];
    }
  }
  _formatShippingRates(shippingRates) {
    let formattedShippingRates = shippingRates.map((shippingRate) => {
      return `<li>${shippingRate["presentment_name"]}: ${shippingRate["currency"]} ${shippingRate["price"]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${formattedShippingRates === "" ? "" : `<ul class="list-disc" role="list">${formattedShippingRates.join("")}</ul>`}
      </div>
    `;
  }
  _formatError(errors) {
    let formattedShippingRates = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${formattedShippingRates}</ul>
      </div>
    `;
  }
};
if (!window.customElements.get("shipping-estimator")) {
  window.customElements.define("shipping-estimator", ShippingEstimator);
}

// js/common/facets/facet-apply-button.js
var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._closeDrawer);
    this.form.addEventListener("change", this._updateCount.bind(this));
    this.filterCountElement = document.createElement("span");
    this.appendChild(this.filterCountElement);
  }
  connectedCallback() {
    this._updateCount();
  }
  _updateCount() {
    const form = new FormData(this.form);
    this.filterCountElement.innerText = ` (${Array.from(form.values()).filter((item) => item !== "").length})`;
  }
  async _closeDrawer() {
    this.closest("facet-drawer").hide();
  }
};
if (!window.customElements.get("facet-apply-button")) {
  window.customElements.define("facet-apply-button", FacetApplyButton, { extends: "button" });
}

// js/common/facets/facet-dialog.js
var FacetDialog = class extends DialogElement {
  get initialFocus() {
    return false;
  }
};
if (!window.customElements.get("facet-dialog")) {
  window.customElements.define("facet-dialog", FacetDialog);
}

// js/common/facets/facet-drawer.js
var FacetDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    const form = this.querySelector("#facet-form");
    if (HTMLFormElement.prototype.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event("submit", { cancelable: true }));
    }
  }
};
if (!window.customElements.get("facet-drawer")) {
  window.customElements.define("facet-drawer", FacetDrawer);
}

// js/common/facets/facet-floating-filter.js
import { animate as animate5 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var FacetFloatingFilter = class extends HTMLElement {
  connectedCallback() {
    new IntersectionObserver(this._onFooterVisibilityChanged.bind(this), { rootMargin: "50px 0px" }).observe(document.querySelector(".shopify-section--footer"));
  }
  _onFooterVisibilityChanged(entries) {
    if (entries[0].isIntersecting) {
      animate5(this, { opacity: 0, transform: [null, "translateY(15px)"], visibility: "hidden" }, { duration: 0.15 });
    } else {
      animate5(this, { opacity: 1, transform: [null, "translateY(0)"], visibility: "visible" }, { duration: 0.15 });
    }
  }
};
if (!window.customElements.get("facet-floating-filter")) {
  window.customElements.define("facet-floating-filter", FacetFloatingFilter);
}

// js/klaviyo-back-in-stock.js
var KlaviyoBackInStock = class extends HTMLElement {
  constructor() {
    super();
    this.apiKey = this.getAttribute('data-api-key');
    this.setupDOM();
    this.setEventListeners();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }

  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }

  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }

  setupDOM() {
    this.wrapper = this.querySelector('.back-in-stock__wrapper');
    this.successWrapper = this.querySelector('.back-in-stock__success-wrapper');
    this.error = this.querySelector('.back-in-stock__error');
    this.email = this.querySelector('input[id="bis-email"]');
    this.variantId = this.querySelector('input[name="bis-variant"]');
    this.productId = this.querySelector('input[name="bis-product"]');
    this.submit = this.querySelector('button.back-in-stock__button[type="submit"]');
  }

  setEventListeners() {
    this.submit.addEventListener('click', () => {
      const variant = Number(this.variantId.value);
      const product = Number(this.productId.value);
      const email = this.email.value;
      this.handleSubmit(variant, email);
    });
  }

  _onVariantChanged(event) {
    const newVariantId = event.detail.variant.id;
    const newVariantTitleSelector = this.querySelector('span.variant-title');
    const newVariantTitle = event.detail.variant.title;
    this.variantId.value = newVariantId;

    if (event.detail.variant.available) {
      this.setAttribute('hidden', true);
    } else {
      this.removeAttribute('hidden');
      newVariantTitleSelector.textContent = newVariantTitle;
    }
  }

  handleSubmit(variant, email) {
    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'revision': '2024-07-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: String(email)
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variant}`
              }
            }
          }
        }
      })
    };
    
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.apiKey}`, options)
      .then(response => {
        // Check for specific status codes
        if (response.status === 204) {
          return { success: true, message: 'Subscription successful' };
        }
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Try to get the response as text first
        return response.text().then(text => {
          if (!text) {
            return { success: true, message: 'Subscription may have been successful' };
          }
          try {
            return JSON.parse(text);
          } catch (error) {
            console.error('[KlaviyoBackInStock] Failed to parse JSON:', text);
            throw new Error('Invalid JSON in response');
          }
        });
      })
      .then(data => {
        this.handleSuccess();
      })
      .catch(error => {
        console.error('[KlaviyoBackInStock] Error:', error.message);
        this.handleError('An error occurred: ' + error.message);
      });
  }

  handleSuccess() {
    this.wrapper.setAttribute('hidden', true);
    this.successWrapper.removeAttribute('hidden');
  }

  handleError(message) {
    this.error.removeAttribute('hidden');
  }
}

if (!window.customElements.get("klaviyo-back-in-stock")) {
  window.customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);
}


// js/common/facets/facet-form.js
var abortController = null;
var openElements = /* @__PURE__ */ new Set();
document.addEventListener("facet:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url,
        shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  shopifySection.classList.add("is-loading");
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  try {
    const response = await cachedFetch(url.toString(), { signal: abortController.signal });
    const tempContent = new DOMParser().parseFromString(await response.text(), "text/html");

    Array.from(tempContent.querySelectorAll("details, facet-dialog")).forEach((item) => {
      if (openElements.has(item.id)) {
        item.setAttribute("open", "");
      }
    }); 

    if (event.detail.pagination && event.detail.paginationType === "load-more" ) {
      // Logic for appending 'product-card' elements
      const newProductCards = tempContent.querySelectorAll("product-card, blog-post-card");
      const lastProductCard = shopifySection.querySelector("product-card:last-of-type, blog-post-card:last-of-type");
      const fragment = document.createDocumentFragment(); // Create a temporary container
      const existingHandles = new Set(Array.from(shopifySection.querySelectorAll("product-card, blog-post-card")).map(card => card.getAttribute('handle')));

      Array.from(newProductCards).forEach(card => {
        const cardHandle = card.getAttribute('handle');
        if (!existingHandles.has(cardHandle)) {
          fragment.appendChild(card);
          existingHandles.add(cardHandle); // Add the handle to the set
        }
      });      

      // If there's a last product card, insert the fragment after this card to maintain order.
      if (lastProductCard) {
        lastProductCard.parentNode.insertBefore(fragment, lastProductCard.nextSibling);
      } else {
        // If no product cards are initially present, just append the fragment to the shopifySection.
        shopifySection.appendChild(fragment);
      }

      // Find and replace the existing pagination with the new one
      const newPagination = tempContent.querySelector('nav.collection__pagination');
      const currentPagination = document.querySelector('nav.collection__pagination');
      if (currentPagination && newPagination) {
        currentPagination.replaceWith(newPagination.cloneNode(true));
      }
      shopifySection.classList.remove("is-loading");
    } else {
      // Replace the entire section content if not paginating
      shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      shopifySection.classList.remove("is-loading");

      const scrollToElement = window.matchMedia("(min-width: 700px) and (max-width: 9999px)").matches ? shopifySection.querySelector(".collection__results") : shopifySection.querySelector(".collection__results product-list"),
            scrollToBoundingRect = scrollToElement.getBoundingClientRect();
      if (scrollToBoundingRect.top < parseInt(getComputedStyle(scrollToElement).scrollPaddingTop || 0)) {
        scrollToElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  } catch (e) {
  }
});
var FacetForm = class extends HTMLFormElement {
  constructor() {
    super();
    this._isDirty = false;
    this.addEventListener("change", this._onFormChanged);
    this.addEventListener("submit", this._onFormSubmitted);
  }
  connectedCallback() {
    Array.from(this.querySelectorAll("details, facet-dialog")).forEach((disclosureElement) => {
      if (disclosureElement.open) {
        openElements.add(disclosureElement.id);
      }
      disclosureElement.addEventListener("toggle", () => {
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      });
    });
  }
  _buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this)), url = new URL(this.action);
    url.search = "";
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
      if (url.searchParams.get(optionToClear) === "") {
        url.searchParams.delete(optionToClear);
      }
    });
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    return url;
  }
  _onFormChanged() {
    this._isDirty = true;
    if (this.hasAttribute("update-on-change")) {
      if (HTMLFormElement.prototype.requestSubmit) {
        this.requestSubmit();
      } else {
        this.dispatchEvent(new Event("submit", { cancelable: true }));
      }
    } else {
      cachedFetch(this._buildUrl().toString());
    }
  }
  _onFormSubmitted(event) {
    event.preventDefault();
    if (!this._isDirty) {
      return;
    }
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url: this._buildUrl()
      }
    }));
    this._isDirty = false;
  }
};
if (!window.customElements.get("facet-form")) {
  window.customElements.define("facet-form", FacetForm, { extends: "form" });
}

// js/common/facets/facet-link.js
var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onFacetUpdate);
  }
  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", ""), url = new URL(this.href);
    const isPaginationItem = event.target.matches('.pagination__item.group'); 
    const paginationType = this.getAttribute("data-pagination-type");
  
    url.searchParams.set("section_id", sectionId);
    this.dispatchEvent(new CustomEvent("facet:update", {      
      bubbles: true,
      detail: {
        url,
        pagination: isPaginationItem ? true : undefined,
        paginationType: paginationType
      }
    }));
  }
};
if (!window.customElements.get("facet-link")) {
  window.customElements.define("facet-link", FacetLink, { extends: "a" });
}

// js/common/facets/facet-sort-by.js
var FacetSortBy = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("listbox:change", this._onValueChanged);
  }
  _onValueChanged(event) {
    const url = new URL(location.href), sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", "");
    url.searchParams.set("sort_by", event.detail.value);
    url.searchParams.set("section_id", sectionId);
    url.searchParams.delete("page");
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facet-sort-by")) {
  window.customElements.define("facet-sort-by", FacetSortBy);
}

// js/common/feedback/pill-loader.js
import { animate as animate6, timeline as timeline4, stagger as stagger4 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var PillLoader = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  connectedCallback() {
    this.innerHTML = `
      <div class="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
        <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timeline4([
        [this, { opacity: [0, 1], visibility: "visible", transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.15 }],
        [this.firstElementChild, { opacity: 1, transform: ["translateY(0)"] }, { duration: 0.15, at: "<" }],
        [this.lastElementChild, { opacity: 0 }, { duration: 0, at: "<" }]
      ]);
      animate6(this.firstElementChild.querySelectorAll("span"), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger4(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timeline4([
        [this.firstElementChild, { opacity: 0, transform: ["translateY(0)", "translateY(-2px)"] }, { duration: 0.15 }],
        [this.lastElementChild, { opacity: 1, transform: ["translateY(2px)", "translateY(0)"] }, { duration: 0.15 }],
        [this, { opacity: 0, transform: ["translateY(0)", "translateY(-5px)"], visibility: "hidden" }, { duration: 0.15, at: "+0.8" }]
      ]);
    }
  }
};
if (!window.customElements.get("pill-loader")) {
  window.customElements.define("pill-loader", PillLoader);
}

// js/common/feedback/progress-bar.js
var ProgressBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    this.style.setProperty("--progress", `${Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"))}`);
  }
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    this.rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    this.textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]');
    this.textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select(), { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select(), { signal: this._abortController.signal });
    this.textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
    }, { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// js/common/form/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector("input");
    this.querySelector("button:first-of-type").addEventListener("click", () => this._step(-1), { signal: this._abortController.signal });
    this.querySelector("button:last-of-type").addEventListener("click", () => this._step(1), { signal: this._abortController.signal });
  }
  _step(delta) {
    // In the cart (line-item inputs carry data-line-key) the quantity setter alone doesn't update the
    // cart, so emit the same change event a manual edit would, which LineItemQuantity listens for.
    if (this.inputElement.hasAttribute("data-line-key")) {
      const target = this.inputElement.quantity + delta;
      if (target < 1) {
        // Dropping below 1 removes the line item (quantity 0 → /cart/change removes it).
        this.inputElement.value = "0";
      } else {
        this.inputElement.quantity = target;
      }
      this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    this.inputElement.quantity = this.inputElement.quantity + delta;
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
var QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    this.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("focus", this.select);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
    this.size = Math.max(this.value.length + 1, 2);
    this._updateAtcPriceQtyValue()
  }
  _onValueInput() {
    this.quantity = this.value;
    this._updateAtcPriceQtyValue()
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = 1;
      this._updateAtcPriceQtyValue()
    }
  }
  _onKeyDown(event) {
    event.stopPropagation();
    const originalQuantity = this.quantity;
    if (event.key === "ArrowUp") {
      this.quantity = this.quantity + 1;
    } else if (event.key === "ArrowDown") {
      this.quantity = this.quantity - 1;
    }
    if (originalQuantity !== this.quantity) {
      this._abortController = new AbortController();
      this.addEventListener("blur", () => this.dispatchEvent(new Event("change", { bubbles: true })), { once: true, signal: this._abortController.signal });
      this._updateAtcPriceQtyValue()
    }
  }
  _updateAtcPriceQtyValue() {
    this.setAttribute('data-qty', this.value);

    // This "buy X for £Y" running total only applies to the product form's add-to-cart
    // button. Cart line-item quantity inputs live inside <line-item> and have no matching
    // buy-buttons, so skip them (otherwise this throws and breaks cart quantity updates).
    if (this.closest('line-item')) {
      return;
    }

    const currentFormAttribute = this.getAttribute('form');
    const atcButton = document.querySelector('buy-buttons[form="' + currentFormAttribute + '"]');
    if (!atcButton) {
      return;
    }
    const quickAtcButtons = document.querySelectorAll('buy-buttons[form="' + currentFormAttribute + '"]');
    const unitPrice = atcButton.getAttribute('data-unit-cost');
    const activeQty = this.value;
    var combinedPrice = formatMoney(activeQty * unitPrice, window.themeVariables.moneyFormat);
    const totalPriceElement = atcButton.querySelector('#totalPrice');
    if (totalPriceElement) {
      totalPriceElement.textContent = combinedPrice;
    }
    quickAtcButtons.forEach(button => {
      const buttonTotalPrice = button.querySelector('#totalPrice');
      if (buttonTotalPrice) {
        buttonTotalPrice.textContent = combinedPrice;
      }
    });
  }
};
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}

// js/common/form/resizable-textarea.js
var ResizableTextarea = class extends HTMLTextAreaElement {
  constructor() {
    super();
    this.addEventListener("input", this._onInput);
  }
  _onInput() {
    this.style.height = "auto";
    this.style.height = this.scrollHeight + 2 + "px";
  }
};
if (!window.customElements.get("resizable-textarea")) {
  window.customElements.define("resizable-textarea", ResizableTextarea, { extends: "textarea" });
}

// js/common/list/listbox.js
var _accessibilityInitialized, _hiddenInput, _onOptionClicked, onOptionClicked_fn, _onInputChanged, onInputChanged_fn, _onKeyDown, onKeyDown_fn;
var Listbox = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onOptionClicked);
    __privateAdd(this, _onInputChanged);
    __privateAdd(this, _onKeyDown);
    __privateAdd(this, _accessibilityInitialized, false);
    __privateAdd(this, _hiddenInput, void 0);
    this.addEventListener("keydown", __privateMethod(this, _onKeyDown, onKeyDown_fn));
  }
  static get observedAttributes() {
    return ["aria-activedescendant"];
  }
  connectedCallback() {
    if (!__privateGet(this, _accessibilityInitialized)) {
      this.setAttribute("role", "listbox");
      __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]'));
      __privateGet(this, _hiddenInput)?.addEventListener("change", __privateMethod(this, _onInputChanged, onInputChanged_fn).bind(this));
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        option.addEventListener("click", __privateMethod(this, _onOptionClicked, onOptionClicked_fn).bind(this));
        option.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
        if (option.getAttribute("aria-selected") === "true") {
          this.setAttribute("aria-activedescendant", option.id);
        }
      });
      __privateSet(this, _accessibilityInitialized, true);
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-activedescendant" && oldValue !== null && newValue !== oldValue) {
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        if (option.id === newValue) {
          option.setAttribute("aria-selected", "true");
          if (__privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== option.value) {
            __privateGet(this, _hiddenInput).value = option.value;
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (this.hasAttribute("aria-owns")) {
            this.getAttribute("aria-owns").split(" ").forEach((boundId) => {
              document.getElementById(boundId).textContent = option.getAttribute("title") || option.innerText || option.value;
            });
          }
          option.dispatchEvent(new CustomEvent("listbox:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }
};
_accessibilityInitialized = new WeakMap();
_hiddenInput = new WeakMap();
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  this.setAttribute("aria-activedescendant", event.currentTarget.id);
  event.currentTarget.dispatchEvent(new CustomEvent("listbox:select", {
    bubbles: true,
    detail: {
      value: event.currentTarget.value
    }
  }));
};
_onInputChanged = new WeakSet();
onInputChanged_fn = function(event) {
  this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(event.target.value)}"]`).id);
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
if (!window.customElements.get("x-listbox")) {
  window.customElements.define("x-listbox", Listbox);
}

// js/common/media/image.js
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(imageOrArray.map((image) => {
    return new Promise((resolve) => {
      if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }));
}
function generateSrcset(imageObject, widths = []) {
  const imageUrl = new URL(imageObject["src"]);
  return widths.filter((width) => width <= imageObject["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}
function createMediaImg(media, widths = [], properties = {}) {
  const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]), featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const propertyKey in properties) {
    image.setAttribute(propertyKey, properties[propertyKey]);
  }
  image.alt = media["alt"];
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}

// js/common/product/gift-card-recipient.js
var _recipientCheckbox, _recipientOtherProperties, _recipientSendOnProperty, _offsetProperty, _recipientFieldsContainer, _synchronizeProperties, synchronizeProperties_fn, _formatDate, formatDate_fn;
var GiftCardRecipient = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _synchronizeProperties);
    __privateAdd(this, _formatDate);
    __privateAdd(this, _recipientCheckbox, void 0);
    __privateAdd(this, _recipientOtherProperties, []);
    __privateAdd(this, _recipientSendOnProperty, void 0);
    __privateAdd(this, _offsetProperty, void 0);
    __privateAdd(this, _recipientFieldsContainer, void 0);
  }
  connectedCallback() {
    const properties = Array.from(this.querySelectorAll('[name*="properties"]')), checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";
    __privateSet(this, _recipientCheckbox, properties.find((input) => input.name === checkboxPropertyName));
    __privateSet(this, _recipientOtherProperties, properties.filter((input) => input.name !== checkboxPropertyName));
    __privateSet(this, _recipientFieldsContainer, this.querySelector(".gift-card-recipient__fields"));
    __privateSet(this, _offsetProperty, this.querySelector('[name="properties[__shopify_offset]"]'));
    if (__privateGet(this, _offsetProperty)) {
      __privateGet(this, _offsetProperty).value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
    }
    __privateSet(this, _recipientSendOnProperty, this.querySelector('[name="properties[Send on]"]'));
    const minDate = /* @__PURE__ */ new Date();
    const maxDate = /* @__PURE__ */ new Date();
    maxDate.setDate(minDate.getDate() + 90);
    __privateGet(this, _recipientSendOnProperty)?.setAttribute("min", __privateMethod(this, _formatDate, formatDate_fn).call(this, minDate));
    __privateGet(this, _recipientSendOnProperty)?.setAttribute("max", __privateMethod(this, _formatDate, formatDate_fn).call(this, maxDate));
    __privateGet(this, _recipientCheckbox)?.addEventListener("change", __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).bind(this));
    __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).call(this);
  }
};
_recipientCheckbox = new WeakMap();
_recipientOtherProperties = new WeakMap();
_recipientSendOnProperty = new WeakMap();
_offsetProperty = new WeakMap();
_recipientFieldsContainer = new WeakMap();
_synchronizeProperties = new WeakSet();
synchronizeProperties_fn = function() {
  __privateGet(this, _recipientOtherProperties).forEach((property) => property.disabled = !__privateGet(this, _recipientCheckbox).checked);
  __privateGet(this, _recipientFieldsContainer).classList.toggle("js:hidden", !__privateGet(this, _recipientCheckbox).checked);
};
_formatDate = new WeakSet();
formatDate_fn = function(date) {
  const offset = date.getTimezoneOffset();
  const offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
  return offsetDate.toISOString().split("T")[0];
};
if (!window.customElements.get("gift-card-recipient")) {
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
}

// js/common/product/product-loader.js
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (this.loadedProducts[productHandle]) {
      return this.loadedProducts[productHandle];
    }
    this.loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${shopifyRoot}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return this.loadedProducts[productHandle];
  }
};
__publicField(ProductLoader, "loadedProducts", {});

// js/common/product/product-card.js
import { Delegate as Delegate3 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate3(this);
    this.addEventListener("pointerover", () => ProductLoader.load(this.getAttribute("handle")), { once: true });
  }
  connectedCallback() {
    this._delegate.on("change", '[type="radio"]', this._onSwatchChanged.bind(this));
    this._delegate.on("pointerover", '[type="radio"] + label', this._onSwatchHovered.bind(this), true);
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  async _onSwatchHovered(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target.control), primaryMediaElement = this.querySelector(".product-card__image--primary");
    if (firstMatchingVariant.hasOwnProperty("featured_media")) {
      this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    }
  }
  async _onSwatchChanged(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target);
    this.querySelectorAll(`a[href^="${this.product["url"]}"`).forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set("variant", firstMatchingVariant["id"]);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
    if (!firstMatchingVariant.hasOwnProperty("featured_media")) {
      return;
    }
    const primaryMediaElement = this.querySelector(".product-card__image--primary"), secondaryMediaElement = this.querySelector(".product-card__image--secondary");
    const newPrimaryMediaElement = this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
      secondaryMediaElement ? secondaryMediaElement.replaceWith(this._createImageElement(this.product["media"][firstMatchingVariant["featured_media"]["position"]] || this.product["media"][1], secondaryMediaElement.className, secondaryMediaElement.sizes)) : null;
      await primaryMediaElement.animate({ opacity: [1, 0] }, { duration: 250, easing: "ease-in", fill: "forwards" }).finished;
      await new Promise((resolve) => newPrimaryMediaElement.complete ? resolve() : newPrimaryMediaElement.onload = () => resolve());
      primaryMediaElement.replaceWith(newPrimaryMediaElement);
      newPrimaryMediaElement.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease-in" });
    }
  }
  _createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"], image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(previewImage, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800]);
    return image;
  }
  async _getMatchingVariant(target) {
    this.product = await ProductLoader.load(this.getAttribute("handle"));
    return this.product["variants"].find((variant) => variant[`option${target.closest("[data-option-position]").getAttribute("data-option-position")}`] === target.value);
  }
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

// js/common/product/product-form.js
var ProductForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }
  connectedCallback() {
    this.id.disabled = false;
  }
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${shopifyRoot}variants/${this.id.value}`);
    const response = await fetch(`${shopifyRoot}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${shopifyRoot}cart`;
      }
      const cartContent = await (await fetch(`${shopifyRoot}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));

      var _learnq = window._learnq || [];
      // The add.js response is either the single added line item or { items: [...] }.
      var addedItem = responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson;
      function addedToCart(item) {
        fetch(`${window.location.origin}/cart.js`)
        .then(res => res.json().then(data => {
          var cart = {
            total_price: data.total_price/100,
            $value: data.total_price/100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price/100,
            items: data.items
          }
          if (item) {
            cart = Object.assign(cart, item)
          }
          _learnq.push(['track', 'Added to Cart', cart]);
        }))
      };

      addedToCart(addedItem);

    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
};
if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm, { extends: "form" });
}

// js/common/product/product-upsell.js
// Intercepts add-to-cart for variants that have a connected upsell. When such a variant is added, it
// shows the upsell modal instead of adding immediately. Accepting swaps the line for the upsell
// variant; declining adds the original. Both then submit the product form (bypassing the intercept).

// The trigger rules (cart value / excluded items) are checked synchronously on submit, so the cart is
// cached. A collection page holds one <product-upsell> per quick add, and they all read the same cart,
// so it is fetched once for the page instead of once per element.
var upsellCart = null;
var upsellCartWatched = false;
var fetchUpsellCart = async () => {
  try {
    upsellCart = await (await fetch(`${shopifyRoot}cart.js`)).json();
  } catch (error) {
    /* keep the previous cart */
  }
};
var watchUpsellCart = () => {
  if (upsellCartWatched) {
    return;
  }
  upsellCartWatched = true;
  fetchUpsellCart();
  document.addEventListener("cart:change", (event) => {
    if (event.detail?.cart) upsellCart = event.detail.cart;
  });
  document.addEventListener("cart:refresh", () => fetchUpsellCart());
};

// The "Upsells > Trigger limit" theme setting caps how many upsell modals a shopper sees per browsing
// session, across all upsells and page loads. Each modal shown counts once, accepted or declined. The
// count lives in sessionStorage, so it resets when the session ends; if storage is unavailable it stays at 0.
var UPSELL_TRIGGER_COUNT_KEY = "theme:upsell-trigger-count";
var getUpsellTriggerCount = () => {
  try {
    return parseInt(sessionStorage.getItem(UPSELL_TRIGGER_COUNT_KEY), 10) || 0;
  } catch (error) {
    return 0;
  }
};
var incrementUpsellTriggerCount = () => {
  try {
    sessionStorage.setItem(UPSELL_TRIGGER_COUNT_KEY, String(getUpsellTriggerCount() + 1));
  } catch (error) {
    /* Safari private mode etc. — silently fail */
  }
};
var isUpsellTriggerLimitReached = () => {
  const limit = window.themeVariables?.settings?.upsellTriggerLimit;
  // Blank setting = no limit.
  if (limit === null || limit === undefined || limit === "") {
    return false;
  }
  return getUpsellTriggerCount() >= parseInt(limit, 10);
};
var ProductUpsell = class extends HTMLElement {
  connectedCallback() {
    const dataScript = this.querySelector("[data-product-upsells]");
    this.form = this.querySelector('form[is="product-form"]');
    this.modal = this.querySelector("[data-upsell-modal]");
    if (!dataScript || !this.form || !this.modal) {
      return;
    }
    try {
      this.upsells = JSON.parse(dataScript.textContent);
    } catch (error) {
      this.upsells = {};
    }
    this._abortController = new AbortController();
    this._boundOnSubmit = this._onSubmit.bind(this);
    // Capture phase so we run before ProductForm's own (bubble-phase) submit handler.
    this.form.addEventListener("submit", this._boundOnSubmit, { capture: true, signal: this._abortController.signal });
    // The modal is pre-rendered (in Liquid) for the current variant; only re-populate when it changes.
    this.form.addEventListener("variant:change", (event) => this._onVariantChange(event), { signal: this._abortController.signal });
    this.acceptButton = this.modal.querySelector(".upsell-modal__accept");
    this.declineButton = this.modal.querySelector(".upsell-modal__decline");
    this.acceptButton?.addEventListener("click", () => this._resolve(true), { signal: this._abortController.signal });
    this.declineButton?.addEventListener("click", () => this._resolve(false), { signal: this._abortController.signal });
    // Closing the modal any other way (close button, outside click, Esc) counts as a decline — add the original.
    this.modal.addEventListener("dialog:after-hide", () => {
      if (this._resolved) {
        this._resolved = false;
        return;
      }
      this._resolve(false);
    }, { signal: this._abortController.signal });
    watchUpsellCart();
  }
  get _cart() {
    return upsellCart;
  }
  _shouldTrigger(upsell) {
    if (isUpsellTriggerLimitReached()) {
      return false;
    }
    const now = Math.floor(Date.now() / 1000);
    // Schedule window (empty = immediate / indefinite).
    if (upsell.scheduleStart && now < parseInt(upsell.scheduleStart, 10)) {
      return false;
    }
    if (upsell.scheduleEnd && now > parseInt(upsell.scheduleEnd, 10)) {
      return false;
    }
    // Subscription requirement — based on whether the trigger product is being added with a selling plan.
    const isSubscription = !!this.form.querySelector('[name="selling_plan"]')?.value;
    if (upsell.triggerRequirementSubscription === "subscription-only" && !isSubscription) {
      return false;
    }
    if (upsell.triggerRequirementSubscription === "non-subscription-only" && isSubscription) {
      return false;
    }
    // Minimum cart value (cents).
    if (upsell.triggerRequirementCartValue && (this._cart?.total_price || 0) < upsell.triggerRequirementCartValue) {
      return false;
    }
    // Excluded URL paths — skip if the current path contains any of them.
    if (Array.isArray(upsell.triggerExceptionUrlPaths) && upsell.triggerExceptionUrlPaths.some((path) => path && window.location.pathname.includes(path))) {
      return false;
    }
    // Excluded cart items — skip if any of these variants is already in the cart.
    if (Array.isArray(upsell.triggerExceptionCartItemIds) && this._cart?.items) {
      const cartVariantIds = this._cart.items.map((item) => item.variant_id);
      if (upsell.triggerExceptionCartItemIds.some((id) => cartVariantIds.includes(id))) {
        return false;
      }
    }
    return true;
  }
  _onVariantChange(event) {
    const upsell = event.detail?.variant ? this.upsells[event.detail.variant.id] : null;
    if (upsell) {
      this._populateModal(upsell);
    }
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get variantInput() {
    return this.form.querySelector('[name="id"]');
  }
  _onSubmit(event) {
    const variantId = this.variantInput?.value;
    const upsell = variantId ? this.upsells[variantId] : null;
    if (!upsell || !this._shouldTrigger(upsell)) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    this._pendingUpsell = upsell;
    this._resolved = false;
    this.modal.show();
    incrementUpsellTriggerCount();
  }
  _populateModal(upsell) {
    const image = this.modal.querySelector("[data-upsell-image]");
    const title = this.modal.querySelector("[data-upsell-title]");
    const price = this.modal.querySelector("[data-upsell-price]");
    const description = this.modal.querySelector("[data-upsell-description]");
    if (image) {
      if (upsell.image) {
        image.src = upsell.image;
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.alt = upsell.productTitle || "";
        image.hidden = false;
      } else {
        image.hidden = true;
      }
    }
    if (title) {
      title.textContent = upsell.title || upsell.productTitle || "";
    }
    // Product link — swap the href and its inner product-title on variant change.
    const link = this.modal.querySelector("[data-upsell-url]");
    if (link) {
      if (upsell.url) link.href = upsell.url;
      const linkTitle = link.querySelector("[data-upsell-title]");
      if (linkTitle) linkTitle.textContent = upsell.productTitle || "";
    }
    if (price) {
      price.textContent = upsell.price || "";
    }
    if (description) {
      description.innerHTML = upsell.description || "";
    }
    // Set the label on the inner span (not the button itself — custom-button wraps its content).
    const acceptText = this.modal.querySelector("[data-upsell-accept-text]");
    const declineText = this.modal.querySelector("[data-upsell-decline-text]");
    if (acceptText) {
      acceptText.textContent = upsell.acceptText || "Yes, add this";
    }
    if (declineText) {
      declineText.textContent = upsell.declineText || "No thanks";
    }
  }
  _resolve(accepted) {
    // Mark as handled so the dialog:after-hide from this hide() doesn't re-trigger a decline.
    this._resolved = true;
    const upsell = this._pendingUpsell;
    this.modal.hide();
    // Each entry restores the form to its original state after the (synchronous) submit captures FormData.
    const restore = [];
    if (accepted && upsell) {
      // Swap to the upsell variant. The original product's selling plan doesn't apply to it.
      if (this.variantInput) {
        const original = this.variantInput.value;
        this.variantInput.value = upsell.upsellVariantId;
        restore.push(() => { this.variantInput.value = original; });
      }
      const sellingPlan = this.form.querySelector('[name="selling_plan"]');
      if (sellingPlan) {
        const original = sellingPlan.value;
        sellingPlan.value = "";
        restore.push(() => { sellingPlan.value = original; });
      }
      // Tag the upsell line item with where it came from.
      restore.push(this._addTempProperty("_upsell_source_title", this.getAttribute("data-source-title")));
      restore.push(this._addTempProperty("_upsell_source_path", this.getAttribute("data-source-path")));
    }
    this.form.removeEventListener("submit", this._boundOnSubmit, { capture: true });
    try {
      this.form.requestSubmit();
    } finally {
      this.form.addEventListener("submit", this._boundOnSubmit, { capture: true, signal: this._abortController.signal });
      restore.forEach((fn) => fn && fn());
    }
  }
  // Adds a hidden line-item property input to the form; returns a function that removes it again.
  _addTempProperty(name, value) {
    if (!value) {
      return null;
    }
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${name}]`;
    input.value = value;
    this.form.appendChild(input);
    return () => input.remove();
  }
};
if (!window.customElements.get("product-upsell")) {
  window.customElements.define("product-upsell", ProductUpsell);
}

// js/common/product/product-form-listeners.js
var BuyButtons = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onCartErrorListener = this._onCartError.bind(this);
  }
  connectedCallback() {
    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.addEventListener("cart:error", this._onCartErrorListener);
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.removeEventListener("cart:error", this._onCartErrorListener);
  }
  _onVariantChanged(event) {
    const addToCartButton = this.querySelector('button[type="submit"]'), paymentButton = this.querySelector(".shopify-payment-button");
    const variant = event.detail.variant;
    const currentFormAttribute = this.getAttribute('form');
    var runningQtyValue = 1;
    var isRecurring = false;
    var price = variant["price"];
    const runningQtyAttr = document.querySelector(`input[type="text"][is="quantity-input"][data-qty][form="${currentFormAttribute}"]`);
    const addToCartButtonText = addToCartButton.getAttribute("is") === "custom-button" ? addToCartButton.firstElementChild : addToCartButton;
    addToCartButton.classList.remove("button--secondary", "button--subdued");
    addToCartButton.disabled = !event.detail.variant || !event.detail.variant["available"];
    const recurringOption = document.querySelector('subscription-option[data-purchase-type="recurring"] input[type="radio"]');
    
    if (recurringOption && recurringOption.checked) {
      var price = variant.selling_plan_allocations[0]["price"];
      var isRecurring = true;
    }

    this.setAttribute("data-unit-cost", price);

    if (runningQtyAttr) {
      runningQtyValue = runningQtyAttr.getAttribute('data-qty');
    }

    var runningTotal = (runningQtyValue * price);
    var price = formatMoney(runningTotal, window.themeVariables.settings.moneyFormat);

    if (!event.detail.variant) {
      addToCartButtonText.innerHTML = window.themeVariables.strings.unavailableButton;
      addToCartButton.classList.add("button--subdued");
      if (paymentButton) {
        paymentButton.style.display = "none";
      }
    } else {
      addToCartButton.classList.add(event.detail.variant["available"] ? paymentButton || this.hasAttribute("force-secondary-button") ? "button--secondary" : "button" : "button--subdued");
      if (isRecurring) {
        addToCartButtonText.innerHTML = event.detail.variant["available"] 
          ? this.getAttribute("template").includes("pre-order") 
            ? window.themeVariables.strings.preOrderButton 
            : window.themeVariables.strings.addToCartReplenishButton.replace("@@", price)
          : this.getAttribute("data-oos-status") === 'Coming Soon'
            ? window.themeVariables.strings.comingSoonButton.replace("@@", price)
            : window.themeVariables.strings.soldOutButton.replace("@@", price);
      } else {
        addToCartButtonText.innerHTML = event.detail.variant["available"]
          ? this.getAttribute("template").includes("pre-order")
            ? window.themeVariables.strings.preOrderButton
            : window.themeVariables.strings.addToCartButton.replace("@@", price)
          : this.getAttribute("data-oos-status") === 'Coming Soon'
            ? window.themeVariables.strings.comingSoonButton.replace("@@", price)
            : window.themeVariables.strings.soldOutButton.replace("@@", price);
      }
      if (paymentButton) {
        paymentButton.style.display = event.detail.variant["available"] ? "block" : "none";
      }
    }
  }
  _onCartError(event) {
    const errorBanner = document.createElement("div");
    errorBanner.classList.add("banner", "banner--error", "justify-center");
    errorBanner.setAttribute("role", "alert");
    errorBanner.style.gridColumn = "1/-1";
    errorBanner.style.marginBottom = "1rem";
    errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p>${event.detail.error}</p>
    `;
    const formControlElement = this.closest('div.form-control');
    if (formControlElement) {
      formControlElement.prepend(errorBanner);
    }
    setTimeout(async () => {
      await errorBanner.animate({ opacity: [1, 0] }, { duration: 250, fill: "forwards" }).finished;
      errorBanner.remove();
    }, 5e3);
  }
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (event.detail.variant) {
      const element = this.querySelector('[name="id"]');
      element.value = event.detail.variant["id"];
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  async _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      const element = document.createElement("div");
      element.innerHTML = await (await fetch(`${shopifyRoot}variants/${event.detail.variant["id"]}?section_id=pickup-availability`)).text();
      this.replaceChildren(...element.querySelector("pickup-availability").childNodes);
    }
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var SalePrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
    this.classList.toggle("text-on-sale", variant["compare_at_price"] > variant["price"]);
    this.setAttribute("data-cents", variant["price"]);
  }
};
var SellingPlanPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    let firstSellingPlanAllocation = variant.selling_plan_allocations[0];
    let price = firstSellingPlanAllocation.price;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(price, currencyFormat)));
    this.setAttribute("data-cents", price);
  }
};
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat)));
    this.hidden = !(variant["compare_at_price"] > variant["price"]);
    if (variant["compare_at_price"] !== null) {
      this.setAttribute("data-cents", variant["compare_at_price"]);
    }
  }
};
var UnitPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant["unit_price"]) {
      return this.hidden = true;
    }
    const referenceValue = variant["unit_price_measurement"]["reference_value"] !== 1 ? variant["unit_price_measurement"]["reference_value"] : "";
    const node = document.createRange().createContextualFragment(
      `${formatMoney(variant["unit_price"])}/${referenceValue}${variant["unit_price_measurement"]["reference_unit"]}`
    );
    this.lastChild.replaceWith(node);
    this.hidden = false;
  }
};
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("selling-plan-price")) {
  window.customElements.define("selling-plan-price", SellingPlanPrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
var _onVariantChanged, onVariantChanged_fn;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged = new WeakSet();
onVariantChanged_fn = function(event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChanged2, onVariantChanged_fn2;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged2);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged2 = new WeakSet();
onVariantChanged_fn2 = function(event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const savings = this.getAttribute("discount-mode") === "percentage" ? `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%` : formatMoney(variant["compare_at_price"] - variant["price"]);
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace("@@", savings)}`;
    }
  } else {
    this.hidden = true;
  }
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
var VariantInventory = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variantId = event.detail.variant ? event.detail.variant["id"] : null;
    Array.from(this.children).forEach((item) => item.toggleAttribute("hidden", variantId !== parseInt(item.getAttribute("data-variant-id"))));
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var VariantMedia = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    this.sizesAttribute = this.querySelector("img").sizes;
    this.classAttribute = this.querySelector("img").className;
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get widths() {
    return this.getAttribute("widths").split(",").map((width) => parseInt(width));
  }
  _onVariantChanged(event) {
    if (!event.detail.variant || !event.detail.variant["featured_media"]) {
      return;
    }
    this.replaceChildren(createMediaImg(event.detail.variant["featured_media"], this.widths, { "class": this.classAttribute, "sizes": this.sizesAttribute }));
  }
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var VariantSku = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.hidden = true;
    } else {
      this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
      this.hidden = !event.detail.variant["sku"];
    }
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}

// js/common/product/product-gallery.js
import { PhotoSwipeLightbox } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
    this._carousels = Array.from(this.querySelectorAll("media-carousel"));
    this._pageDots = Array.from(this.querySelectorAll("page-dots"));
    this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
    this._customCursor = this.querySelector(".product-gallery__cursor");
    this.addEventListener("carousel:change", this._onCarouselChanged);
    if (this._viewInSpaceButton) {
      this.addEventListener("carousel:settle", this._updateViewInSpaceButton);
    }
    if (this.hasAttribute("allow-zoom")) {
      this.addEventListener("lightbox:open", (event) => this.openZoom(event.detail.index));
    }
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get photoswipe() {
    if (this._photoswipe) {
      return this._photoswipe;
    }
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("//drsambunting.com/cdn/shop/t/306/assets/photoswipe.min.js?v=20290624223189769891787686342"),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      // UX
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: false,
      closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`
    });
    photoswipe.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
    photoswipe.on("uiRegister", () => {
      photoswipe.pswp.ui.registerElement({
        name: "bottom-bar",
        order: 5,
        appendTo: "wrapper",
        html: `
          <div class="pagination">
            <button class="pagination__item group" rel="prev">
              <span class="animated-arrow animated-arrow--reverse"></span>
            </button>
            
            <span class="pagination__current text-sm">
              <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
            </span>
            
            <button class="pagination__item group" rel="next">
              <span class="animated-arrow"></span>
            </button>
          </div>
        `,
        onInit: (el, pswp) => {
          el.querySelector(".pagination__page-count").innerText = pswp.getNumItems();
          el.querySelector('[rel="prev"]')?.addEventListener("click", () => pswp.prev());
          el.querySelector('[rel="next"]')?.addEventListener("click", () => pswp.next());
          pswp.on("change", () => {
            el.querySelector(".pagination__current-page").innerText = pswp.currIndex + 1;
          });
        }
      });
    });
    photoswipe.init();
    return this._photoswipe = photoswipe;
  }
  /**
   * Open the zoom by dynamically creating a data source based on the filtered items
   */
  openZoom(index = 0) {
    const dataSource = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img')).map((image) => {
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.photoswipe.loadAndOpen(index, dataSource);
  }
  _updateViewInSpaceButton(event) {
    if (event.detail.slide.getAttribute("data-media-type") === "model") {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", event.detail.slide.getAttribute("data-media-id"));
    } else {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", this._viewInSpaceButton.getAttribute("data-shopify-model3d-default-id"));
    }
  }
  _onCarouselChanged(event) {
    if (this._customCursor) {
      this._customCursor.toggleAttribute("hidden", event.detail.slide.getAttribute("data-media-type") !== "image");
    }
  }
  _onVariantChanged(event) {
    const filteredIndexes = this._getFilteredMediaIndexes(event.detail.product, event.detail.variant);
    const marketExcludeIndexes = this._getMarketExcludeIndexes(event.detail.product, event.detail.variant);
    const marketSpecificIndexes = this._getMarketSpecificIndexes(event.detail.product, event.detail.variant);
    this._carousels.forEach((carousel) => carousel.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes, marketExcludeIndexes, marketSpecificIndexes } })));
    this._pageDots.forEach((pageDots) => pageDots.dispatchEvent(new CustomEvent("control:filter", { detail: { filteredIndexes, marketExcludeIndexes, marketSpecificIndexes } })));
    if (event.detail.variant["featured_media"] && event.detail.previousVariant["featured_media"] && event.detail.previousVariant["featured_media"]["id"] !== event.detail.variant["featured_media"]["id"] || !event.detail.previousVariant["featured_media"] && event.detail.variant["featured_media"]) {
      this._carousels.forEach((carousel) => carousel.select(event.detail.variant["featured_media"]["position"] - 1, { animate: false }));
    }
  }
  _getFilteredMediaIndexes(product, variant) {
    const filteredMediaIds = [];
    product["media"].forEach((media) => {
      let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
      if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
        if (!matchMedia) {
          const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
          product["options"].forEach((option) => {
            if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
              if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                filteredMediaIds.push(media["position"] - 1);
              }
            }
          });
        }
      }
    });
    return filteredMediaIds;
  }
  _getMarketExcludeIndexes(product, variant) {
    const marketExcludeIndexes = [];
    const activeMarket = this.getAttribute("active-market");
    product["media"].forEach((media) => {
      if (media["alt"]?.includes("!!") && media["alt"] !== product["title"]) {
        const altParts = media["alt"].split("!!"), mediaGroupParts = altParts.pop().split("_");
        if (mediaGroupParts[1].trim().toLowerCase() === activeMarket && mediaGroupParts[0] === "market-exclude") {
          marketExcludeIndexes.push(media["position"] - 1);
        }
      }
    });
    return marketExcludeIndexes;
  }
  _getMarketSpecificIndexes(product, variant) {
    const marketSpecificIndexes = [];
    const activeMarket = this.getAttribute("active-market");
    product["media"].forEach((media) => {
      if (media["alt"]?.includes("!!") && media["alt"] !== product["title"]) {
        const altParts = media["alt"].split("!!"), mediaGroupParts = altParts.pop().split("_");
        if (mediaGroupParts[1].trim().toLowerCase() !== activeMarket && mediaGroupParts[0] === "market-include") {
          marketSpecificIndexes.push(media["position"] - 1);
        }
      }
    });
    return marketSpecificIndexes;
  }
};

var MediaCarousel = class extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();
    this._onGestureChangedListener = this._onGestureChanged.bind(this);
    this.addEventListener("gesturestart", this._onGestureStart, { capture: false, signal: this._abortController.signal });
    this.addEventListener("carousel:settle", this._onMediaSettled, { signal: this._abortController.signal });
    this.addEventListener("click", this._onGalleryClick);
  }
  _onMediaSettled(event) {
    const media = event.detail.slide;
    this.items.filter((item) => ["video", "external_video", "model"].includes(item.getAttribute("data-media-type"))).forEach((item) => item.firstElementChild.pause());
    switch (media.getAttribute("data-media-type")) {
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay")) {
          media.firstElementChild.play();
        }
        break;
      case "model":
        if (window.matchMedia("(min-width: 1000px)").matches) {
          media.firstElementChild.play();
        }
        break;
    }
  }
  _onGalleryClick(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    if (this.selectedSlide.getAttribute("data-media-type") !== "image") {
      return;
    }
    const rect = event.currentTarget.getBoundingClientRect(), offsetX = event.clientX - rect.left;
    offsetX > this.clientWidth / 2 ? this.next() : this.previous();
  }
  _onGestureStart(event) {
    event.preventDefault();
    this.addEventListener("gesturechange", this._onGestureChangedListener, { capture: false, signal: this._abortController.signal });
  }
  _onGestureChanged(event) {
    event.preventDefault();
    if (event.scale > 1.5) {
      const visibleImages = this.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image"), openIndex = visibleImages.indexOf(this.selectedSlide);
      this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: openIndex } }));
      this.removeEventListener("gesturechange", this._onGestureChangedListener);
    }
  }
};
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
  }
  _onButtonClicked() {
    let media = this.closest(".product-gallery__media"), openIndex;
    if (media) {
      const visibleImages = this.closest("media-carousel").visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(media);
    } else {
      const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel"), visibleImages = carousel.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(carousel.selectedSlide);
    }
    this.dispatchEvent(new CustomEvent("lightbox:open", {
      bubbles: true,
      detail: {
        index: openIndex
      }
    }));
  }
};
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
if (!window.customElements.get("product-zoom-button")) {
  window.customElements.define("product-zoom-button", ProductZoomButton, { extends: "button" });
}
if (!window.customElements.get("media-carousel")) {
  window.customElements.define("media-carousel", MediaCarousel);
}

// js/common/product/quick-add.js
var _scopeFromPassed, _scopeToReached, _intersectionObserver;
var ProductQuickAdd = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _scopeFromPassed, false);
    __privateAdd(this, _scopeToReached, false);
    __privateAdd(this, _intersectionObserver, new IntersectionObserver(this._onObserved.bind(this)));
  }
  connectedCallback() {
    this._scopeFrom = document.getElementById(this.getAttribute("form"));
    this._scopeTo = document.querySelector(".footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    __privateGet(this, _intersectionObserver).observe(this._scopeFrom);
    __privateGet(this, _intersectionObserver).observe(this._scopeTo);
  }
  disconnectedCallback() {
    __privateGet(this, _intersectionObserver).disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (entry.target === this._scopeFrom) {
        __privateSet(this, _scopeFromPassed, entry.boundingClientRect.bottom < 0);
      }
      if (entry.target === this._scopeTo) {
        __privateSet(this, _scopeToReached, entry.isIntersecting);
      }
    });
    this.classList.toggle("is-visible", __privateGet(this, _scopeFromPassed) && !__privateGet(this, _scopeToReached));
  }
};
_scopeFromPassed = new WeakMap();
_scopeToReached = new WeakMap();
_intersectionObserver = new WeakMap();
if (!window.customElements.get("product-quick-add")) {
  window.customElements.define("product-quick-add", ProductQuickAdd);
}

// js/common/product/quick-buy-drawer.js
var QuickBuyDrawer = class extends Drawer {
  constructor() {
    super();
    this._hasLoaded = false;
    this.addEventListener("variant:add", this._onVariantAdded.bind(this));
  }
  async show() {
    this.style.display = "block";
    if (!this._hasLoaded) {
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "true"));
      const responseContent = await (await fetch(`${shopifyRoot}products/${this.getAttribute("handle")}`)).text();
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "false"));
      const quickBuyContent = new DOMParser().parseFromString(responseContent, "text/html").getElementById("quick-buy-content").content;
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      this.replaceChildren(quickBuyContent);
      Shopify.PaymentButton?.init();
      this._hasLoaded = true;
    }
    return super.show();
  }
  async hide() {
    return super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded() {
    // Don't show the in-drawer "added" confirmation. Close the quick-buy drawer and let the cart drawer open
    // itself — CartDrawer opens on variant:add for the drawer cart type (a no-op if it's already open) because
    // we no longer set blockCartDrawerOpening. Reset so the next open re-fetches fresh product content.
    this._hasLoaded = false;
    this.hide();
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
}

// js/common/product/variant-picker.js
var VariantPicker = class extends HTMLElement {
  async connectedCallback() {
    this._abortController = new AbortController();
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    // Variants at/below their minimum stock level are forced sold out: the /products/{handle}.js payload has
    // no inventory counts, so the server hands us the id list and we neutralise `available` at the source.
    // Every downstream variant:change listener (buy button, sold-out badge, swatch disabling) then respects
    // it with no further changes.
    this._applyMinStockSoldOut();
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", this._onOptionChanged.bind(this), { signal: this._abortController.signal });
    });
    this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this), { signal: this._abortController.signal });
    this._updateDisableSelectors();
    this.selectVariant(this.selectedVariant["id"]);
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  // Force variants at/below their minimum stock threshold to read as unavailable. The server renders their
  // ids into data-min-stock-sold-out (the product JSON carries no inventory), and every consumer of
  // variant.available then treats them as sold out.
  _applyMinStockSoldOut() {
    let ids;
    try {
      ids = JSON.parse(this.getAttribute("data-min-stock-sold-out") || "[]");
    } catch (error) {
      ids = [];
    }
    if (!ids.length || !this.product) {
      return;
    }
    const soldOut = new Set(ids.map(Number));
    (this.product.variants || []).forEach((variant) => {
      if (soldOut.has(variant.id)) {
        variant.available = false;
      }
    });
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  /**
   * Select a new variant by its ID
   */
  selectVariant(id) {
    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    this._updateDisableSelectors();
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        previousVariant
      }
    }));
  }
  _onOptionChanged(event) {
    if (!event.target.name.startsWith("option")) {
      return;
    }
    this.selectVariant(this._getVariantFromOptions()?.id);
  }
  _onMasterSelectorChanged() {
    const options = this.selectedVariant?.options || [];
    options.forEach((value, index) => {
      let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option${index + 1}"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
      if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
        triggerChangeEvent = input.value !== value;
        input.value = value;
      } else if (input.tagName === "INPUT" && input.type === "radio") {
        triggerChangeEvent = !input.checked && input.value === value;
        input.checked = input.value === value;
      }
      if (triggerChangeEvent) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  /**
   * Get the product variant by its ID
   */
  _getVariantById(id) {
    return this.product["variants"].find((variant) => variant["id"] === id);
  }
  /**
   * Get the variant based on the options
   */
  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues();
    return this.product["variants"].find((variant) => {
      return variant["options"].every((value, index) => value === options[index]);
    });
  }
  /**
   * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
   * returning true only if the variant is actually available
   */
  _isVariantSelectable(variant) {
    if (!variant) {
      return false;
    } else {
      return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
    }
  }
  /**
   * This method is used internally to select an available or selectable variant, when the current choice does not
   * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
   * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
   * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
   *
   * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
   * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
   * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
   * is found we return the first available variant independently of any choice.
   */
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(), matchedVariant = null, slicedCount = 0;
    do {
      options.pop();
      slicedCount += 1;
      matchedVariant = this.product["variants"].find((variant) => {
        if (this.hideSoldOutVariants) {
          return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        } else {
          return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        }
      });
    } while (!matchedVariant && options.length > 0);
    return matchedVariant;
  }
  _getSelectedOptionValues() {
    return this.optionSelectors.map((optionSelector) => {
      return optionSelector.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]').value;
    });
  }
  /**
   * We add specific class to sold out variants based on the selectors
   */
  _updateDisableSelectors() {
    const selectedVariant = this.selectedVariant;
    if (!selectedVariant) {
      return;
    }
    this._updateDisableSelectorsForOptionLevel(0, selectedVariant);
  }
  _updateDisableSelectorsForOptionLevel(level, selectedVariant) {
    if (!this.optionSelectors[level]) {
      return;
    }
    const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
      const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
      optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        optionValue.toggleAttribute("hidden", !available);
      } else {
        optionValue.classList.toggle("is-disabled", !available);
      }
    };
    const hasCombination = (variant, level2, value, selectedVariant2) => {
      return Array.from({ length: level2 + 1 }, (_, i) => {
        if (i === level2) {
          return variant[`option${level2 + 1}`] === value;
        } else {
          return variant[`option${i + 1}`] === selectedVariant2[`option${i + 1}`];
        }
      }).every((condition) => condition);
    };
    this.product["options"][level]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = this.product["variants"].some(
        (variant) => hasCombination(variant, level, value, selectedVariant) && variant
      );
      const hasAvailableVariant = this.product["variants"].some(
        (variant) => hasCombination(variant, level, value, selectedVariant) && variant["available"]
      );
      applyClassToSelector(this.optionSelectors[level], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      this._updateDisableSelectorsForOptionLevel(level + 1, selectedVariant);
    });
  }
};
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    this.innerHTML = event.detail.variant[this.getAttribute("for")];
  }
};

var VariantOptionDescription = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const selectedVariantbyName = event.detail.variant[this.getAttribute("for")];
    const formID = this.getAttribute("form")
    const variantInput = document.querySelector(`input[form="${formID}"][value="${selectedVariantbyName}"]`);
    const variantDescription = variantInput.getAttribute("data-description");
    if (variantDescription) {
      this.innerHTML = variantDescription;
      if (this.hasAttribute("hidden")) {
        this.removeAttribute("hidden");
      }
    } else {
      this.setAttribute("hidden", "");
    }
  };
};

if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}
if (!window.customElements.get("variant-option-description")) {
  window.customElements.define("variant-option-description", VariantOptionDescription);
}

// js/common/media/base-media.js
import { inView as inView4 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView4(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};

// js/common/media/model.js
var ModelMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _playerTarget() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = this.querySelector("model-viewer");
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            this.setAttribute("can-play", "");
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerHandler(target, prop) {
    target[prop]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const models = (await ProductLoader.load(this.getAttribute("handle")))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
if (!window.customElements.get("model-media")) {
  window.customElements.define("model-media", ModelMedia);
}

// js/common/media/video.js
var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
var VideoMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
        <slot></slot>
        
        <svg part="play-button" fill="none" width="48" height="48" viewBox="0 0 48 48">
          <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="#ffffff" style="opacity: 0.5;"/>
          <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="#000000"/>
          <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="#000000" stroke-opacity=".12" style="opacity: 0.5;"/>
        </svg>
      `));
    }
  }
  play({ restart = false } = {}) {
    if (restart && !this.hasAttribute("host")) {
      this.querySelector("video").currentTime = 0;
    }
    super.play();
  }
  _playerTarget() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute("autoplay") || window.matchMedia("screen and (max-width: 999px)").matches;
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          this.setAttribute("can-play", "");
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          this.setAttribute("can-play", "");
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = this.querySelector("video");
      this.setAttribute("loaded", "");
      this.setAttribute("can-play", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
        this.removeAttribute("suspended");
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerHandler(target, prop) {
    if (this.getAttribute("host") === "youtube") {
      prop === "play" ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === "play" && !this.hasAttribute("host")) {
        target.play().catch((error) => {
          if (error.name === "NotAllowedError") {
            this.setAttribute("suspended", "");
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
};
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}

// js/common/navigation/accordion-disclosure.js
import { timeline as timeline6 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";

// js/common/navigation/animated-details.js
var AnimatedDetails = class extends HTMLDetailsElement {
  constructor() {
    super();
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;
    this._open = this.hasAttribute("open");
    this.summaryElement.addEventListener("click", this._onSummaryClicked.bind(this));
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.addEventListener("shopify:block:select", () => this.open = true);
      this.addEventListener("shopify:block:deselect", () => this.open = false);
    }
  }
  set open(value) {
    if (value !== this._open) {
      this._open = value;
      if (this.isConnected) {
        this._transition(value);
      } else {
        value ? this.setAttribute("open", "") : this.removeAttribute("open");
      }
    }
  }
  get open() {
    return this._open;
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.open = !this.open;
  }
  _transition(value) {
  }
};

// js/common/navigation/accordion-disclosure.js
var AccordionDisclosure = class extends AnimatedDetails {
  static get observedAttributes() {
    return ["open"];
  }
  constructor() {
    super();
    this.setAttribute("aria-expanded", this._open ? "true" : "false");
  }
  set open(value) {
    super.open = value;
    this.setAttribute("aria-expanded", value ? "true" : "false");
  }
  get open() {
    return super.open;
  }
  async _transition(value) {
    this.style.overflow = "hidden";
    if (value) {
      this.setAttribute("open", "");
      await timeline6([
        [this, { height: [`${this.summaryElement.clientHeight}px`, `${this.scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
        [this.contentElement, { opacity: [0, 1], transform: ["translateY(0)", "translateY(-4px)"] }, { duration: 0.15, at: "-0.1" }]
      ]).finished;
    } else {
      await timeline6([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this, { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
      ]).finished;
      this.removeAttribute("open");
    }
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      this.setAttribute("aria-expanded", newValue === "" ? "true" : "false");
    }
  }
};
if (!window.customElements.get("accordion-disclosure")) {
  window.customElements.define("accordion-disclosure", AccordionDisclosure, { extends: "details" });
}

// js/common/navigation/tabs.js
import { animate as animate8 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var Tabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => this.selectedIndex = index, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transition(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transition(fromPanel, toPanel) {
    await animate8(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate8(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("x-tabs")) {
  window.customElements.define("x-tabs", Tabs);
}

// js/common/search/predictive-search.js
import { animate as animate9 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="idle"></slot>`));
  }
  connectedCallback() {
    this._searchForm = this.closest("form");
    this._queryInput = this._searchForm.elements["q"];
    this._searchForm.addEventListener("submit", this._onFormSubmitted.bind(this));
    this._searchForm.addEventListener("reset", this._onSearchCleared.bind(this));
    this._queryInput.addEventListener("input", debounce(this._onInputChanged.bind(this), this.autoCompleteDelay));
  }
  /**
   * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
   * refresh too often, so we recommend to keep the default one
   */
  get autoCompleteDelay() {
    return 280;
  }
  /**
   * Check if the store supports the predictive API (some languages do not). When not supported, the predictive
   * search is simply disabled and only the standard search is used
   */
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)["predictiveSearch"];
  }
  /**
   * Check if the input is not empty, and if so, trigger the predictive search
   */
  _onInputChanged() {
    if (this._queryInput.value === "") {
      return this._onSearchCleared();
    }
    this._abortController?.abort();
    this._abortController = new AbortController();
    try {
      return this.supportsPredictiveApi() ? this._doPredictiveSearch() : this._doFallbackSearch();
    } catch (e) {
      if (e.name !== "AbortError") {
        throw e;
      }
    }
  }
  /**
   * Prevent the form submission if the query is empty
   */
  _onFormSubmitted(event) {
    if (this._queryInput.value === "") {
      return event.preventDefault();
    }
  }
  /**
   * Do the actual predictive search
   */
  async _doPredictiveSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,tag,body`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${shopifyRoot}search/suggest?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * For merchants using store that do not support the predictive search, we have to fallback to standard search. Unfortunately,
   * the standard search is less convenient, and we have to simulate one request for each desired resource type
   */
  async _doFallbackSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,tag,body`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${shopifyRoot}search?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * If any search is pending, we abort them, and transition to the idle slot
   */
  _onSearchCleared() {
    this._abortController?.abort();
    this._queryInput.focus();
    return this._transitionToSlot("idle");
  }
  /**
   * Transition between different slot. To prevent useless animation, the slot does not transition if we go to the same slot
   */
  async _transitionToSlot(toSlotName) {
    if (this.shadowRoot.firstElementChild.name === toSlotName) {
      return;
    }
    await animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [1, 0] }, { duration: 0.1 }).finished;
    this.shadowRoot.firstElementChild.setAttribute("name", toSlotName);
    return animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [0, 1], transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.1 }).finished;
  }
};
if (!window.customElements.get("predictive-search")) {
  window.customElements.define("predictive-search", PredictiveSearch);
}

// js/common/search/search-drawer.js
var SearchDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "top" : this.getAttribute("open-from") || "right";
  }
};
if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

// js/common/text/section-header.js
import { animate as animate10, inView as inView5 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
var _reveal2, reveal_fn2;
var SectionHeader = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _reveal2);
  }
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, __privateMethod(this, _reveal2, reveal_fn2).bind(this), { margin: "0px 0px -100px 0px" });
    }
  }
};
_reveal2 = new WeakSet();
reveal_fn2 = function() {
  this.querySelectorAll('[reveal-on-scroll="true"]').forEach(heading => {
    const headingKeyframe = getHeadingKeyframe(heading);
    animate10(...headingKeyframe);
  });
};
if (!window.customElements.get("section-header")) {
  window.customElements.define("section-header", SectionHeader);
}

// js/common/ui/marquee-text.js
var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }

  connectedCallback() {
    this.addEventListener("change", this._handleSwitchChange.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("change", this._handleSwitchChange.bind(this));
  }

  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5), contentWidth = entries[0].contentRect.width, slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
    this.style.setProperty("--marquee-animation-duration", `${(scrollingSpeed * slowFactor * entries[0].target.querySelector("span").clientWidth / contentWidth).toFixed(3)}s`);
  }

  _handleSwitchChange(event) {
    const target = event.target;
    // Check if the event target is a checkbox inside the announcement-bar__switch
    if (target.matches(".announcement-bar__switch input[type='checkbox']") && target.checked) {
      // Find the nearest parent with class `h-stack gap-2` and look for a sibling <a> tag with an href
      const switchWrapper = target.closest(".h-stack");
      if (switchWrapper) {
        const anchor = switchWrapper.querySelector("a[href]");
        if (anchor) {
          const href = anchor.getAttribute("href");
          if (href) {
            window.location.href = href;
          }
        }
      }
    }
  }

};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

class RivoRewards extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.setEarningRatio = this.setEarningRatio.bind(this);
  }

  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this.handleVariantChange);
    document.addEventListener('sellingPlanUpdated', this.setEarningRatio);
  } 

  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this.handleVariantChange);
    document.removeEventListener('sellingPlanUpdated', this.setEarningRatio);
  }

  handleVariantChange(event) {
    let variant = event.detail.variant;
    const recurringOption = document.querySelector('subscription-option[data-purchase-type="recurring"] input[type="radio"]');
    let sellingPrice = document.querySelector('selling-plan-price[form="' + this.getAttribute("form") + '"]');
    if (!sellingPrice) {
      sellingPrice = document.querySelector('sale-price[form="' + this.getAttribute("form") + '"]');
    }
    const sellingPriceCents = sellingPrice.getAttribute('data-cents');
    const rewardsDisplaySpan = document.querySelector('rivo-rewards[form="' + this.getAttribute("form") + '"] span');

    if (variant && variant.price && rewardsDisplaySpan) {
      if (recurringOption && recurringOption.checked) {
        rewardsDisplaySpan.setAttribute('data-product-price', sellingPriceCents.toString());
        setTimeout(() => {
          const klarnaElement = document.querySelector("klarna-placement");
          if (klarnaElement) {
            klarnaElement.setAttribute("data-purchase-amount", sellingPriceCents);
          }
        }, 200);
      } else {
        rewardsDisplaySpan.setAttribute('data-product-price', variant.price.toString());
      }
      // Explicitly re-invoke setEarningRatio with the updated price
      this.setEarningRatio();
    }
  }

  setEarningRatio() {  
    // Define a default earning ratio
    const rewardsDisplaySpan = document.querySelector('rivo-rewards span');
    const earningRatio = this.getAttribute('data-earning-ratio');
    
    // Ensure the <span> element for displaying points is present
    if (!rewardsDisplaySpan) {
        return;
    }

    var productPrice = parseFloat(rewardsDisplaySpan.getAttribute('data-product-price'));
    if (isNaN(productPrice)) {
        return;
    }

    var pointsEarned = Math.round((productPrice * earningRatio) / 100); 
    rewardsDisplaySpan.innerHTML = pointsEarned; 
  }
}

if (!window.customElements.get("rivo-rewards")) {
  window.customElements.define("rivo-rewards", RivoRewards);
}


class FluidMetric extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }

  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }

  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.innerHTML = ' / ' + variant.public_title;
  }
}

if (!window.customElements.get("fluid-metric")) {
  window.customElements.define("fluid-metric", FluidMetric);
}


class SubscriptionPicker extends HTMLElement {
  constructor() {
    super();
    this.onListboxSelect = this.onListboxSelect.bind(this);
    this.updateSellingPlan = this.updateSellingPlan.bind(this);
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }

  connectedCallback() {
    this.addEventListener('listbox:select', this.onListboxSelect);
    this._onPurchaseTypeChange = this._onPurchaseTypeChange.bind(this);
    this.querySelectorAll('input[type="radio"][name="purchase_type"]').forEach(radio => {
      radio.addEventListener('change', this.updateSellingPlan);
      radio.addEventListener('change', this._onPurchaseTypeChange);
    });
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);

    this._onKitCardClick = this._onKitCardClick.bind(this);
    this.querySelectorAll('subscription-option.subscriptions__kit-option').forEach(option => {
      option.addEventListener('click', this._onKitCardClick);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('listbox:select', this.onListboxSelect);
    this.querySelectorAll('input[type="radio"][name="purchase_type"]').forEach(radio => {
      radio.removeEventListener('change', this.updateSellingPlan);
      if (this._onPurchaseTypeChange) {
        radio.removeEventListener('change', this._onPurchaseTypeChange);
      }
    });
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);

    if (this._onKitCardClick) {
      this.querySelectorAll('subscription-option.subscriptions__kit-option').forEach(option => {
        option.removeEventListener('click', this._onKitCardClick);
      });
    }
  }

  _onPurchaseTypeChange(event) {
    const radio = event.target;
    if (!radio || !radio.checked) return;
    const option = radio.closest('subscription-option');
    if (!option || option.dataset.purchaseType !== 'trial_kit') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Routine Upsells',
      routine_context: 'PDP Purchase Option',
      routine_name: option.getAttribute('data-trial-kit-name') || '',
      routine_id: option.getAttribute('data-trial-kit-variant-id') || ''
    });
  }

  _onKitCardClick(event) {
    if (event.target.closest('input, label, a, button')) return;
    const option = event.currentTarget;
    const radio = option.querySelector('input[type="radio"]');
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _getCheckedTrialKitOption() {
    const radio = this.querySelector('subscription-option[data-purchase-type="trial_kit"] input[type="radio"]:checked');
    return radio ? radio.closest('subscription-option') : null;
  }

  _getActiveTrialKitData() {
    const option = this._getCheckedTrialKitOption();
    if (!option) return null;
    const variantId = option.getAttribute('data-trial-kit-variant-id');
    const priceCents = parseInt(option.getAttribute('data-trial-kit-price-cents'), 10);
    if (!variantId || isNaN(priceCents)) return null;
    return { variantId, priceCents };
  }

  _applyTrialKitVariantOverride(variantId) {
    const form = document.forms[this.getAttribute("form")];
    if (!form) return;
    form.querySelectorAll('input[name="id"]').forEach(input => {
      if (input.dataset.trialKitOverride === 'true') return;
      if (input.dataset.trialKitOriginalDisabled === undefined) {
        input.dataset.trialKitOriginalDisabled = input.disabled ? 'true' : 'false';
      }
      input.disabled = true;
    });
    let overrideInput = form.querySelector('input[name="id"][data-trial-kit-override="true"]');
    if (!overrideInput) {
      overrideInput = document.createElement('input');
      overrideInput.type = 'hidden';
      overrideInput.name = 'id';
      overrideInput.dataset.trialKitOverride = 'true';
      form.appendChild(overrideInput);
    }
    overrideInput.value = variantId;
    overrideInput.disabled = false;

    let propInput = form.querySelector('input[data-trial-kit-property="true"]');
    if (!propInput) {
      propInput = document.createElement('input');
      propInput.type = 'hidden';
      propInput.name = 'properties[_Purchase Context]';
      propInput.value = 'PDP Purchase Option';
      propInput.dataset.trialKitProperty = 'true';
      form.appendChild(propInput);
    }
  }

  _clearTrialKitVariantOverride() {
    const form = document.forms[this.getAttribute("form")];
    if (!form) return;
    const overrideInput = form.querySelector('input[name="id"][data-trial-kit-override="true"]');
    if (overrideInput) overrideInput.remove();
    const propInput = form.querySelector('input[data-trial-kit-property="true"]');
    if (propInput) propInput.remove();
    form.querySelectorAll('input[name="id"]').forEach(input => {
      if (input.dataset.trialKitOriginalDisabled !== undefined) {
        input.disabled = input.dataset.trialKitOriginalDisabled === 'true';
        delete input.dataset.trialKitOriginalDisabled;
      }
    });
  }

  _onVariantChanged(event) {
    if (this._getCheckedTrialKitOption()) {
      requestAnimationFrame(() => this.updateSellingPlan());
      return;
    }
    const selectedVariantId = event.detail.variant.id;
    const skioSellingPlanGroupId = window.themeVariables.strings.skioSubsGroupID;
    const sellingPlanGroupIdsAvailable = event.detail.variant.selling_plan_allocations.some(plan => plan.selling_plan_group_id === skioSellingPlanGroupId);
    const frequencyDataElement = this.querySelector('#variantSubFrequencies');
    const frequencyData = frequencyDataElement ? JSON.parse(frequencyDataElement.textContent) : null;
    const variantData = frequencyData ? frequencyData.frequencies.find(variant => variant.variant_id === selectedVariantId) : null;
  
    if (variantData && sellingPlanGroupIdsAvailable === true ) {
      const preferredFrequency = variantData.preferred_frequency.toLowerCase();
      const mostPopularSuffix = " (Most Popular)";
      // Get form elements for selling plan and purchase type options
      const form = document.forms[this.getAttribute("form")];
      const sellingPlanInput = form.querySelector("input[name='selling_plan']");
      const recurringOption = this.querySelector('subscription-option[data-purchase-type="recurring"] input[type="radio"]');
      const recurringOptionWapper = this.querySelector('subscription-option[data-purchase-type="recurring"]');
      const singlePurchaseOption = this.querySelector('subscription-option[data-purchase-type="single_purchase"] input[type="radio"]');
  
      const updateText = (element) => {
        const originalText = element.textContent.replace(mostPopularSuffix, "");
        element.textContent = originalText.toLowerCase().includes(preferredFrequency) 
          ? originalText + mostPopularSuffix 
          : originalText;
      };

      recurringOptionWapper.hidden = false;
  
      this.querySelectorAll('x-listbox button span').forEach(updateText);
      updateText(this.querySelector('#subscription-frequency-selector-value'));
  
      // Find all buttons inside x-listbox
      const listboxButtons = this.querySelectorAll('x-listbox button');
  
      // Loop through all the buttons and manage aria-selected and bold class
      listboxButtons.forEach(button => {
        const isPreferredOption = button.textContent.toLowerCase().includes(preferredFrequency);
        if (isPreferredOption) {
          button.setAttribute('aria-selected', 'true');
          button.classList.add('bold');
          button.click();
        } else {
          button.removeAttribute('aria-selected');
          button.classList.remove('bold');
        }
      });
  
      // If it's a recurring purchase, update the sellingPlanInput with the correct plan ID
      if (recurringOption && recurringOption.checked && variantData.selling_plan_id) {
        sellingPlanInput.value = variantData.selling_plan_id;
      } else if (singlePurchaseOption && singlePurchaseOption.checked) {
        // Clear selling plan input if it's a single purchase
        sellingPlanInput.value = '';
      }
    } else {
      const singlePurchaseOption = this.querySelector('subscription-option[data-purchase-type="single_purchase"] input[type="radio"]');
      const recurringOption = this.querySelector('subscription-option[data-purchase-type="recurring"]');
      if (singlePurchaseOption) {
        singlePurchaseOption.click();
        recurringOption.hidden = true;
      }
    }
  }

  onListboxSelect(event) {
    const selectedOption = document.querySelector('button.subscriptions__frequency-options.default');
    selectedOption.value = event.detail.value;
    this.updateSellingPlan(selectedOption.value); 
  }

  updateSellingPlan(selectedPlanId) {
    const form = document.forms[this.getAttribute("form")];
    const recurringOption = this.querySelector('subscription-option[data-purchase-type="recurring"] input[type="radio"]');
    const singlePurchaseOption = this.querySelector('subscription-option[data-purchase-type="single_purchase"] input[type="radio"]');
    const checkedTrialKitOption = this._getCheckedTrialKitOption();
    const sellingPlanInput = form.querySelector("input[name='selling_plan']");
    const atcButton = document.querySelector('buy-buttons[form="' + this.getAttribute("form") + '"]');
    const quickAddAtcButtons = document.querySelectorAll('product-quick-add buy-buttons[form="' + this.getAttribute("form") + '"] button');
    const qtyValueSelector = document.querySelector('quantity-selector input[form="' + this.getAttribute("form") + '"]');
    const qtyValue = parseInt(qtyValueSelector.getAttribute('data-qty'), 10);
    const normalPrice = document.querySelector('sale-price[form="' + this.getAttribute("form") + '"]');
    const sellingPrice = document.querySelector('selling-plan-price[form="' + this.getAttribute("form") + '"]');
    const sellingPriceCents = parseInt(sellingPrice.getAttribute('data-cents'), 10);
    const normalPriceCents = parseInt(normalPrice.getAttribute('data-cents'), 10);
    const sellingPriceWithQty = sellingPriceCents * qtyValue;
    const normalPriceWithQty = normalPriceCents * qtyValue;
    const sellingPriceFormatted = formatMoney(sellingPriceWithQty, window.themeVariables.settings.moneyFormat);
    const normalPriceFormatted = formatMoney(normalPriceWithQty, window.themeVariables.settings.moneyFormat);
    const RivoRewardsElement = document.querySelector('rivo-rewards[form="' + this.getAttribute("form") + '"] span');

    // If the selectedPlanId value is an event object, use the default value
    var selectedPlanId = (selectedPlanId instanceof Event || typeof selectedPlanId === 'object')
      ? this.querySelector('button.subscriptions__frequency-options.default')?.value
      : selectedPlanId;

    // Clear any previously set 'is-active' class
    this.querySelectorAll('subscription-option').forEach(option => option.classList.remove('is-active'));

    const isRecurring = recurringOption && recurringOption.checked;
    const isSinglePurchase = singlePurchaseOption && singlePurchaseOption.checked;
    const isTrialKit = !!checkedTrialKitOption;

    if (!isTrialKit) {
      this._clearTrialKitVariantOverride();
    }

    if (isTrialKit) {
      this.handleTrialKitPurchase(checkedTrialKitOption, sellingPlanInput, normalPrice, sellingPrice, qtyValue, atcButton, quickAddAtcButtons, RivoRewardsElement);
    } else if (isSinglePurchase) {
      this.handleSinglePurchase(singlePurchaseOption, sellingPlanInput, normalPrice, sellingPrice, normalPriceCents, normalPriceFormatted, atcButton, quickAddAtcButtons, RivoRewardsElement);
    } else if (isRecurring) {
      this.handleRecurringPurchase(recurringOption, sellingPlanInput, normalPrice, sellingPrice, sellingPriceCents, sellingPriceFormatted, atcButton, quickAddAtcButtons, RivoRewardsElement, selectedPlanId);
    }

    // Update Klarna placement with the selected price
    let klarnaPriceCents;
    if (isTrialKit) {
      const tkData = this._getActiveTrialKitData();
      klarnaPriceCents = tkData ? tkData.priceCents : normalPriceCents;
    } else {
      klarnaPriceCents = isRecurring ? sellingPriceCents : normalPriceCents;
    }
    this.updateKlarnaPlacement(klarnaPriceCents);
  }

  handleTrialKitPurchase(checkedTrialKitOption, sellingPlanInput, normalPrice, sellingPrice, qtyValue, atcButton, quickAddAtcButtons, RivoRewardsElement) {
    checkedTrialKitOption.classList.add('is-active');
    sellingPlanInput.value = '';

    const tkData = this._getActiveTrialKitData();
    if (!tkData) return;

    this._applyTrialKitVariantOverride(tkData.variantId);

    const totalCents = tkData.priceCents * qtyValue;
    const formatted = formatMoney(totalCents, window.themeVariables.settings.moneyFormat);
    RivoRewardsElement.setAttribute("data-product-price", tkData.priceCents);
    this.updateButtonLabels(atcButton, quickAddAtcButtons, tkData.priceCents, formatted, false, 'Add Trial Kit to Bag');
    this.dispatchPriceEvent(tkData.priceCents);
  }

  handleSinglePurchase(singlePurchaseOption, sellingPlanInput, normalPrice, sellingPrice, normalPriceCents, normalPriceFormatted, atcButton, quickAddAtcButtons, RivoRewardsElement) {
    singlePurchaseOption.closest('subscription-option').classList.add('is-active');
    sellingPlanInput.value = '';
    normalPrice.hidden = false;
    sellingPrice.hidden = true;
    this.updatePriceVisibility(true);
    RivoRewardsElement.setAttribute("data-product-price", normalPriceCents);
    this.updateButtonLabels(atcButton, quickAddAtcButtons, normalPriceCents, normalPriceFormatted, false);
    this.dispatchPriceEvent(normalPriceCents);
  }

  handleRecurringPurchase(recurringOption, sellingPlanInput, normalPrice, sellingPrice, sellingPriceCents, sellingPriceFormatted, atcButton, quickAddAtcButtons, RivoRewardsElement, selectedPlanId) {
    recurringOption.closest('subscription-option').classList.add('is-active');
    normalPrice.hidden = true;
    sellingPrice.hidden = false;
    this.updatePriceVisibility(false);
    RivoRewardsElement.setAttribute("data-product-price", sellingPriceCents);
    this.updateButtonLabels(atcButton, quickAddAtcButtons, sellingPriceCents, sellingPriceFormatted, true);
    this.dispatchPriceEvent(sellingPriceCents);
    if (sellingPlanInput && selectedPlanId) {
      sellingPlanInput.value = selectedPlanId;
    } else {
      console.error("Selling plan input not found.");
    }
  }

  updatePriceVisibility(isSinglePurchase) {
    const quickAddNormalPrices = document.querySelectorAll('product-quick-add sale-price[form="' + this.getAttribute("form") + '"]');
    const quickAddSellingPrices = document.querySelectorAll('product-quick-add selling-plan-price[form="' + this.getAttribute("form") + '"]');
    quickAddNormalPrices.forEach(price => price.hidden = !isSinglePurchase);
    quickAddSellingPrices.forEach(price => price.hidden = isSinglePurchase);
  }

  updateButtonLabels(atcButton, quickAddAtcButtons, priceCents, priceFormatted, isRecurring, overrideLabel) {
    const label = overrideLabel || (isRecurring ? window.themeVariables.strings.addToCartReplenishButtonLabel : window.themeVariables.strings.addToCartButtonLabel);
    atcButton.setAttribute("data-unit-cost", priceCents);
    atcButton.querySelector('#totalPrice').textContent = priceFormatted;
    atcButton.querySelector('#atcLabel').textContent = label;
    quickAddAtcButtons.forEach(button => {
      button.querySelector('#totalPrice').textContent = priceFormatted;
      button.querySelector('#atcLabel').textContent = label;
    });
  }

  dispatchPriceEvent(priceCents) {
    const event = new CustomEvent('sellingPlanUpdated', {
      detail: priceCents,
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }

  updateKlarnaPlacement(priceCents) {
    setTimeout(() => {
      const klarnaElement = document.querySelector("klarna-placement");
      if (klarnaElement) {
        klarnaElement.setAttribute("data-purchase-amount", priceCents);
      }
    }, 200);
  }
}

if (!window.customElements.get("subscription-picker")) {
  window.customElements.define("subscription-picker", SubscriptionPicker);
}

document.addEventListener('variant:add', (event) => {
  const form = event.target;
  if (!form || typeof form.querySelector !== 'function') return;

  const trialKitProperty = form.querySelector('input[data-trial-kit-property="true"]');
  if (trialKitProperty) {
    const overrideInput = form.querySelector('input[name="id"][data-trial-kit-override="true"]');
    const variantId = overrideInput ? overrideInput.value : '';
    const checkedRadio = document.querySelector('subscription-option[data-purchase-type="trial_kit"] input[type="radio"]:checked');
    const option = checkedRadio ? checkedRadio.closest('subscription-option') : null;
    const name = option ? option.getAttribute('data-trial-kit-name') || '' : '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Routine Upsells',
      routine_context: 'PDP Purchase Option',
      routine_name: name,
      routine_id: variantId
    });
    return;
  }

  const upsellWrapper = form.closest('[data-routine-upsell-form]');
  if (upsellWrapper) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Routine Upsells',
      routine_context: 'PDP Block',
      routine_name: upsellWrapper.getAttribute('data-routine-name') || '',
      routine_id: upsellWrapper.getAttribute('data-routine-id') || ''
    });
  }
});

class GlowAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      this.fadeOutContent();
    }, 1500); 
  }

  fadeOutContent() {
    const content = this.querySelector(".glow-loading-state__content");
    if (content) {
      content.classList.add("fade-out-content");

      content.addEventListener(
        "animationend",
        () => {
          this.fadeOutBackground();
        },
        { once: true }
      );
    } else {
      this.fadeOutBackground();
    }
  }

  fadeOutBackground() {
    this.classList.add("fade-out");

    this.addEventListener(
      "animationend",
      () => {
        setTimeout(() => {
          this.remove();
        },2000);
      },
      { once: true }
    );
  }
}

if (!window.customElements.get("glow-animation")) {
  window.customElements.define("glow-animation", GlowAnimation);
}

var RoutineFinderPrimary = class extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('button[data-controls-group]');
    this.groups = this.querySelectorAll('.featured-collection__group');
    this.handleCollectionChange = this.handleCollectionChange.bind(this);
    this.updateSelectedProductsLog = this.updateSelectedProductsLog.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleCollectionChange);
    });
    this.addEventListener('product-selection-changed', this.updateSelectedProductsLog);
    this.updateSelectedProductsLog();
    
    // Add event listener for Add to Cart button
    const atcButton = this.querySelector('button[is="routine-finder-primary"]');
    if (atcButton) {
      atcButton.addEventListener('click', this.addToCart);
    }

    // Initialize enhanced sticky behavior
    this.initEnhancedSticky();
  }

  disconnectedCallback() {
    this.buttons.forEach(button => {
      button.removeEventListener('click', this.handleCollectionChange);
    });
    this.removeEventListener('product-selection-changed', this.updateSelectedProductsLog);
    
    // Remove ATC button listener
    const atcButton = this.querySelector('button[is="routine-finder-primary"]');
    if (atcButton) {
      atcButton.removeEventListener('click', this.addToCart);
    }

    // Clean up enhanced sticky behavior
    this.cleanupEnhancedSticky();
  }

  
  initEnhancedSticky() {
    this.stickyElement = this.querySelector('.featured-collection__group-list[data-sticky]');
    this.sectionHeader = this.querySelector('.section-header') || this.closest('.section-header');
    
    if (!this.stickyElement) return;

    // Store original width for fixed positioning
    this.originalWidth = 'calc(100vw - 2rem)';
    
    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    // Initial check
    this.handleScroll();
  }

  cleanupEnhancedSticky() {
    window.removeEventListener('scroll', this.handleScroll);
    
    if (this.stickyElement) {
      this.stickyElement.classList.remove('is-fixed-sticky');
      this.stickyElement.style.width = '';
    }
  }

  handleScroll() {
    if (!this.stickyElement) return;

    const stickyRect = this.stickyElement.getBoundingClientRect();
    const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const headerHeightPx = parseInt(headerHeight) || 0;

    // Check if section-header is out of viewport
    let sectionHeaderOutOfView = false;
    if (this.sectionHeader) {
      const sectionHeaderRect = this.sectionHeader.getBoundingClientRect();
      sectionHeaderOutOfView = sectionHeaderRect.bottom < headerHeightPx;
    }

    // If section header is out of view, use fixed positioning
    if (sectionHeaderOutOfView && !this.stickyElement.classList.contains('is-fixed-sticky')) {
      this.stickyElement.classList.add('is-fixed-sticky');
      this.stickyElement.style.width = this.originalWidth;
    } else if (!sectionHeaderOutOfView && this.stickyElement.classList.contains('is-fixed-sticky')) {
      this.stickyElement.classList.remove('is-fixed-sticky');
      this.stickyElement.style.width = '';
    }
  }

  generateUniqueId() {
    const getRegimenId = this.getAttribute('data-regimen-id');
    return 'skincare-hub__regimenID-' + getRegimenId;
  }

  addToCart(event) {
    event.preventDefault();
    
    const cartItems = [];
    const uniqueRoutineId = this.generateUniqueId(); // Generate one unique ID for all items

    // Get all selected checkboxes
    const selectedCheckboxes = this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]:checked');
    
    // Create a map to store unique products by name (handle duplicates)
    const uniqueProductsMap = new Map();
    
    selectedCheckboxes.forEach((checkbox) => {
      const productIdRaw = checkbox.name;
      const productId = parseInt(productIdRaw, 10); // Convert to number

      // Only add unique products (by product ID/name) to avoid duplicates
      if (!isNaN(productId) && productId > 0 && !uniqueProductsMap.has(productIdRaw)) {
        uniqueProductsMap.set(productIdRaw, {
          id: productId,
          quantity: 1, // Default quantity is 1 for routine products
          properties: {
            "_revieveSource": true,
            "_revieveSourceReference": uniqueRoutineId, // Use the same routine-id for all items
          },
        });
      }
    });

    // Convert map to array of unique cart items
    const uniqueCartItems = Array.from(uniqueProductsMap.values());
    cartItems.push(...uniqueCartItems);

    if (cartItems.length === 0) {
      console.warn("No valid products selected to add to cart.");
      return;
    }

    // Add loading state to button
    const button = event.currentTarget;
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Trigger the `variant:add` event
        const event = new CustomEvent("variant:add", {
          detail: {
            items: cartItems,
            cart: cart,
          },
        });
        document.documentElement.dispatchEvent(event);
        
        // Refresh cart
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch((error) => {
        console.error("Error adding routine items to the cart:", error);
      })
      .finally(() => {
        // Reset button state
        button.textContent = originalText;
        button.disabled = false;
      });
  }

  handleCollectionChange(event) {
    const targetGroup = event.currentTarget.getAttribute('data-controls-group');

    this.buttons.forEach(button => {
      if (button.getAttribute('data-controls-group') === targetGroup) {
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('aria-selected');
        button.removeAttribute('disabled');
      }
    });

    this.groups.forEach(group => {
      if (!group.hasAttribute('hidden')) {
        this.resetRevealItems(group);
        group.setAttribute('hidden', true);
      }
    });

    const selectedGroup = this.querySelector(`.featured-collection__group[data-group="${targetGroup}"]`);
    if (selectedGroup) {
      selectedGroup.removeAttribute('hidden');
      this.triggerRevealItems(selectedGroup);
    }
  }

  resetRevealItems(group) {
    const revealItems = group.querySelector('reveal-items');
    if (revealItems) {
      const elements = revealItems.hasAttribute('selector')
        ? revealItems.querySelectorAll(revealItems.getAttribute('selector'))
        : revealItems.children;

      elements.forEach(el => {
        el.style.opacity = "0";
        el.style.transform = "translateY(15px)";
      });

      setTimeout(() => {
        if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
          inView(revealItems, reveal_fn.bind(revealItems), {
            margin: revealItems.getAttribute("margin") ?? "-50px 0px"
          });
        }
      }, 50); 
    }
  }

  triggerRevealItems(group) {
    const revealItems = group.querySelector('reveal-items');
    if (revealItems) {
      if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
        inView(revealItems, reveal_fn.bind(revealItems), {
          margin: revealItems.getAttribute("margin") ?? "-50px 0px"
        });
      }
    }
  }

  updateSelectedProductsLog() {
    // Find all checked checkboxes within routine-finder-product-selector elements
    const selected = Array.from(this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]:checked'));
    const allProducts = selected.map(checkbox => {
      const name = checkbox.name || '';
      const price = checkbox.getAttribute('price');
      return { name, price };
    });

    // Create a map to store unique products by name (handle duplicates)
    const uniqueProductsMap = new Map();
    allProducts.forEach(product => {
      if (!uniqueProductsMap.has(product.name)) {
        uniqueProductsMap.set(product.name, product);
      }
    });

    // Convert map back to array of unique products
    const uniqueProducts = Array.from(uniqueProductsMap.values());
    
    this.selectedProducts = uniqueProducts;

    // 1. Update selected count (only count unique products)
    const countSpan = this.querySelector('.featured-collection__selected_count-number');
    if (countSpan) {
      countSpan.textContent = uniqueProducts.length;
    }

    // 2. Update subtotal (only calculate for unique products)
    let subtotal = uniqueProducts.reduce((sum, p) => {
      const price = parseInt(p.price, 10);
      return sum + (isNaN(price) ? 0 : price);
    }, 0);
    const subtotalSpan = this.querySelector('span#subtotal');
    if (subtotalSpan) {
      subtotalSpan.textContent = formatMoney(subtotal, window.themeVariables.moneyFormat);
    }

    // 3. Update routine savings
    const routineSavingsSpan = this.querySelector('span#routineSavings');
    const routineSavingsLabel = this.querySelector('span#routineSavingsLabel');
    let routineSavings = 0;
    if (routineSavingsSpan) {
      const originalSavingsPercent = parseFloat(routineSavingsSpan.getAttribute('data-savings'));
      
      // If less than 3 unique products selected, set discount to 0%
      if (uniqueProducts.length < 3) {
        routineSavings = 0;
        routineSavingsSpan.textContent = '-' + formatMoney(0, window.themeVariables.moneyFormat);
        
        // Update the label to show 0% in brackets
        if (routineSavingsLabel) {
          routineSavingsLabel.textContent = 'Routine Savings (0%)';
        }
      } else {
        // Use normal calculation for 3+ products
        const savingsPercent = originalSavingsPercent;
        if (!isNaN(savingsPercent) && subtotal > 0) {
          routineSavings = Math.round(subtotal * (savingsPercent / 100));
          routineSavingsSpan.textContent = '-' + formatMoney(routineSavings, window.themeVariables.moneyFormat);
        } else {
          routineSavingsSpan.textContent = '-' + formatMoney(0, window.themeVariables.moneyFormat);
        }
        
        // Restore original percentage in label
        if (routineSavingsLabel && !isNaN(originalSavingsPercent)) {
          routineSavingsLabel.textContent = `Routine Savings (${originalSavingsPercent}%)`;
        }
      }
    }

    // 4. Update total cost
    const totalCostSpan = this.querySelector('span#totalCost');
    if (totalCostSpan) {
      const total = subtotal - routineSavings;
      totalCostSpan.textContent = formatMoney(total, window.themeVariables.moneyFormat);
    }
  }
}

class RoutineFinderActions extends HTMLElement {
  constructor() {
    super();
    // Bind the handler to preserve this context
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', this.handleClick);
    });
  }
  
  disconnectedCallback() {
    this.querySelectorAll('button').forEach(button => {
      button.removeEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const target = event.currentTarget;
    const action = target.getAttribute('data-action');
    const customerEmail = target.getAttribute('data-customer-email');
    const regimenId = target.getAttribute('data-regimen-id');
    const eyeConcern = target.getAttribute('data-eye-concern');

    if (action === 'email' && customerEmail && regimenId) {
      this.sendEmail(customerEmail, regimenId, eyeConcern);
    }
  }

  async sendEmail(customerEmail, regimenId, eyeConcern) { 
    const successBanner = this.querySelector('.routine-finder-header__actions-state .banner--success');
    const errorBanner = this.querySelector('.routine-finder-header__actions-state .banner--error');
    const bannerState = this.querySelector('.routine-finder-header__actions-state');

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-04-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            properties: {
              'Request Source': 'Skincare Hub (Northward API)',
              'Regimen ID': regimenId,
              'Has Eye Concerns': eyeConcern
            },
            metric: {
              data: {
                type: "metric",
                attributes: {
                  name: 'Revieve: Skincare Hub - Request Regimen',
                  service: "Northward Custom API"
                }
              }
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: customerEmail
                }
              }
            },
            time: new Date().toISOString(),
            unique_id: new Date().getTime()
          }
        }
      })
    };

    try {
      const response = await fetch('https://a.klaviyo.com/client/events?company_id=JbrnWH', options);
      
      if (!response.ok) {
        const errorText = await response.text();
        bannerState.hidden = false;
        errorBanner.hidden = false;
        throw new Error(`Failed to send event data: ${response.status} - ${errorText}`);
      } else {
        bannerState.hidden = false;
        successBanner.hidden = false;
        errorBanner.hidden = true;
      }
    } catch (err) {
      console.error('Error sending Klaviyo event:', err);
    }
  };

}

class RoutineFinderProductSelector extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this._touchHandled = false;
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('touchend', this.handleTouchEnd);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('touchend', this.handleTouchEnd);
  }

  handleClick(event) {
    if (this._touchHandled) {
      this._touchHandled = false;
      return;
    }
    this.toggleCheckbox(event);
  }

  handleTouchEnd(event) {
    this._touchHandled = true;
    this.toggleCheckbox(event);
  }

  toggleCheckbox(event) {
    const checkbox = this.querySelector('input[type="checkbox"]');
    
    if (!checkbox) {
      return;
    }
    
    const checkboxName = checkbox.name;
    let newCheckedState;
    
    // If the click target is the checkbox itself, let native behavior handle it
    if (event.target === checkbox) {
      // The checkbox state has already been changed by native behavior
      newCheckedState = checkbox.checked;
    } else {
      // If clicking anywhere else on the custom element, toggle programmatically
      event.preventDefault();
      event.stopPropagation();
      checkbox.checked = !checkbox.checked;
      newCheckedState = checkbox.checked;
    }
    
    // Sync all other checkboxes with the same name (same product)
    this.syncDuplicateProducts(checkboxName, newCheckedState);
    
    this.dispatchEvent(new CustomEvent('product-selection-changed', { bubbles: true }));
  }
  
  syncDuplicateProducts(productName, checkedState) {
    // Find the parent element that contains all product selectors
    const parentContainer = this.closest('routine-finder-primary') || document;
    
    // Find all checkboxes with the same name (same product)
    const duplicateCheckboxes = parentContainer.querySelectorAll(`routine-finder-product-selector input[type="checkbox"][name="${productName}"]`);
    
    duplicateCheckboxes.forEach(checkbox => {
      if (checkbox !== this.querySelector('input[type="checkbox"]')) {
        checkbox.checked = checkedState;
      }
    });
  }
}

class RoutineFinderContent extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }

  connectedCallback() {
    this._loadRoutineContent();
  }

  disconnectedCallback() {
    // Clean up any pending requests
    if (this._abortController) {
      this._abortController.abort();
    }
  }

  /**
   * Loads the routine content based on the data-routine-id attribute
   * Fetches the rendered markup using Shopify's view parameter
   */
  async _loadRoutineContent() {
    // Prevent multiple loads
    if (this._isLoaded) {
      return;
    }

    const routineId = this.getAttribute('data-routine-id');
    
    // Exit early if no routine ID is provided
    if (!routineId) {
      console.warn('RoutineFinderContent: No routine ID provided');
      return;
    }

    try {
      this._isLoaded = true;
      this._abortController = new AbortController();

      // Show loading state
      this.classList.add('is-loading');

      // Construct the URL with view parameter to get rendered markup
      // Uses current page URL with ?view=routine-finder-content-{routine_id}
      const currentUrl = new URL(window.location.href);
      const viewTemplate = routineId;
      
      // Clear existing query parameters and set the view parameter
      currentUrl.search = '';
      currentUrl.searchParams.set('view', viewTemplate);
      
      // Fetch the rendered HTML markup
      const response = await fetch(currentUrl.toString(), {
        signal: this._abortController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch routine content: ${response.status} ${response.statusText}`);
      }

      const htmlContent = await response.text();
      
      // Parse and inject the rendered content
      this._injectContent(htmlContent);

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('RoutineFinderContent: Error loading routine content:', error);
        this._showError();
      }
    } finally {
      this.classList.remove('is-loading');
    }
  }

  /**
   * Parses and injects the rendered HTML content into the element
   * Extracts the main content area and handles script re-initialization
   */
  _injectContent(htmlContent) {
    try {
      // Parse the HTML response
      const tempDiv = new DOMParser().parseFromString(htmlContent, 'text/html');
      
      // Extract the main content area (usually the page content or specific sections)
      // Look for the main content area - adjust selector based on your template structure
      const mainContent = tempDiv.querySelector('main > div.sections')

      if (!mainContent) {
        console.warn('RoutineFinderContent: Could not find main content in response');
        this._showError();
        return;
      }

      // Create a container for the content
      const contentContainer = document.createElement('div');
      contentContainer.className = 'routine-finder-content__injected';
      
      // Copy all child elements from the main content
      Array.from(mainContent.children).forEach(child => {
        contentContainer.appendChild(child.cloneNode(true));
      });

      // Replace the current content with the new content
      this.replaceChildren(contentContainer);

      // Re-initialize any custom elements and scripts within the new content
      this._initializeNewContent();

    } catch (error) {
      console.error('RoutineFinderContent: Error injecting content:', error);
      this._showError();
    }
  }

  /**
   * Initialize any new content that requires JavaScript
   */
  _initializeNewContent() {
    // Re-initialize any custom elements within the new content
    const customElements = this.querySelectorAll('[is]');
    customElements.forEach(element => {
      if (element.connectedCallback) {
        element.connectedCallback();
      }
    });

    // Dispatch an event to notify other components that new content has been loaded
    this.dispatchEvent(new CustomEvent('routine-content:loaded', {
      bubbles: true,
      detail: { element: this }
    }));
  }

  /**
   * Shows an error message when content fails to load
   */
  _showError() {
    const errorContainer = document.createElement('div');
    errorContainer.className = 'routine-finder-content__error';
    errorContainer.innerHTML = `
      <p>Unable to load routine content. Please try again later.</p>
    `;
    this.replaceChildren(errorContainer);
  }
}

var RoutineBuilder = class extends HTMLElement {
  constructor() {
    super();
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleTierClick = this.handleTierClick.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.syncFromCart = this.syncFromCart.bind(this);
  }

  connectedCallback() {
    this.layout = this.getAttribute('data-layout') || 'stacked';
    this.tiers = [
      parseFloat(this.getAttribute('data-tier-1')) || 0,
      parseFloat(this.getAttribute('data-tier-2')) || 0,
      parseFloat(this.getAttribute('data-tier-3')) || 0,
      parseFloat(this.getAttribute('data-tier-4')) || 0,
    ];

    this.steps = this.querySelectorAll('.routine-builder__step');

    this.addEventListener('product-selection-changed', this.handleSelectionChange);
    this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', this.handleCheckboxChange);
    });

    this.querySelectorAll('[slot="title"] button').forEach(btn => {
      btn.addEventListener('click', this.handleTabClick);
    });

    this.querySelectorAll('.routine-builder__progress-tier-button').forEach(btn => {
      btn.addEventListener('click', this.handleTierClick);
    });

    const atcButton = this.querySelector('button[is="routine-builder"]');
    if (atcButton) {
      atcButton.addEventListener('click', this.addToCart);
    }

    this.setupStickyShadow();

    document.addEventListener('cart:refresh', this.syncFromCart);
    document.addEventListener('variant:add', this.syncFromCart);

    this.updateAll();
    this.syncFromCart();
  }

  async syncFromCart() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) return;

      const cartVariantIds = new Set(
        cart.items.map(item => String(item.variant_id || item.id))
      );

      this.steps.forEach(step => {
        const allowMultiple = step.getAttribute('data-allow-multiple') === 'true';
        const checkboxes = Array.from(
          step.querySelectorAll('routine-finder-product-selector input[type="checkbox"]')
        );

        checkboxes.forEach(cb => { cb.checked = false; });

        let firstChecked = false;
        checkboxes.forEach(cb => {
          const inCart = cartVariantIds.has(String(cb.name));
          if (inCart) {
            if (allowMultiple) {
              cb.checked = true;
            } else if (!firstChecked) {
              cb.checked = true;
              firstChecked = true;
            }
          }

          const selector = cb.closest('routine-finder-product-selector');
          if (selector) {
            if (inCart) {
              selector.setAttribute('data-locked', 'true');
            } else {
              selector.removeAttribute('data-locked');
            }
          }

          const card = cb.closest('product-card');
          const badge = card && card.querySelector('[data-in-cart-badge]');
          if (badge) badge.toggleAttribute('hidden', !inCart);
        });
      });

      this.updateAll();
    } catch (err) {
      console.warn('Routine builder: failed to sync from cart', err);
    }
  }

  setupStickyShadow() {
    const bar = this.querySelector('.routine-builder__progress');
    if (!bar) return;

    this._stickyScrollHandler = () => {
      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim(),
        10
      ) || 0;
      const rect = bar.getBoundingClientRect();
      bar.classList.toggle('is-stuck', rect.top <= headerHeight + 1);
    };

    window.addEventListener('scroll', this._stickyScrollHandler, { passive: true });
    this._stickyScrollHandler();
  }

  handleTabClick(event) {
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    const wrapper = event.currentTarget.closest('[slot="title"]') || event.currentTarget;
    wrapper.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  handleTierClick(event) {
    const stepTarget = event.currentTarget.getAttribute('data-step-target');
    if (!stepTarget) return;

    if (this.layout === 'tabs') {
      const titleWrapper = this.querySelector(`[slot="title"][data-step="${stepTarget}"]`);
      const tabButton = titleWrapper && titleWrapper.querySelector('button');
      if (tabButton) {
        tabButton.click();
        if (window.matchMedia('(max-width: 699px)').matches) {
          titleWrapper.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }
    } else {
      const step = this.querySelector(`.routine-builder__step[data-step="${stepTarget}"]`);
      if (step) {
        step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  disconnectedCallback() {
    this.removeEventListener('product-selection-changed', this.handleSelectionChange);
    this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]').forEach(cb => {
      cb.removeEventListener('change', this.handleCheckboxChange);
    });
    this.querySelectorAll('[slot="title"] button').forEach(btn => {
      btn.removeEventListener('click', this.handleTabClick);
    });
    this.querySelectorAll('.routine-builder__progress-tier-button').forEach(btn => {
      btn.removeEventListener('click', this.handleTierClick);
    });
    const atcButton = this.querySelector('button[is="routine-builder"]');
    if (atcButton) {
      atcButton.removeEventListener('click', this.addToCart);
    }
    if (this._stickyScrollHandler) {
      window.removeEventListener('scroll', this._stickyScrollHandler);
      this._stickyScrollHandler = null;
    }
    document.removeEventListener('cart:refresh', this.syncFromCart);
    document.removeEventListener('variant:add', this.syncFromCart);
  }

  handleCheckboxChange(event) {
    this.enforceStepConstraint(event.target);
    this.updateAll();
  }

  handleSelectionChange(event) {
    const selectorEl = event.target.closest && event.target.closest('routine-finder-product-selector');
    if (selectorEl) {
      const checkbox = selectorEl.querySelector('input[type="checkbox"]');
      if (checkbox) this.enforceStepConstraint(checkbox);
    }
    this.updateAll();
  }

  enforceStepConstraint(checkbox) {
    if (!checkbox || !checkbox.checked) return;
    const step = checkbox.closest('.routine-builder__step');
    if (!step) return;
    if (step.getAttribute('data-allow-multiple') === 'true') return;

    step.querySelectorAll('routine-finder-product-selector input[type="checkbox"]').forEach(other => {
      if (other !== checkbox && other.checked) {
        const otherSelector = other.closest('routine-finder-product-selector');
        if (otherSelector && otherSelector.hasAttribute('data-locked')) return;
        other.checked = false;
      }
    });
  }

  handleTabChange(event) {
    const targetGroup = event.currentTarget.getAttribute('data-controls-group');

    this.tabButtons.forEach(button => {
      if (button.getAttribute('data-controls-group') === targetGroup) {
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('aria-selected');
        button.removeAttribute('disabled');
      }
    });

    this.steps.forEach(step => {
      if (step.getAttribute('data-group') === targetGroup) {
        step.removeAttribute('hidden');
      } else {
        step.setAttribute('hidden', true);
      }
    });
  }

  getStepsWithSelections() {
    let count = 0;
    this.steps.forEach(step => {
      if (step.getAttribute('data-extras') === 'true') return;
      if (step.querySelector('routine-finder-product-selector input[type="checkbox"]:checked')) {
        count++;
      }
    });
    return count;
  }

  updateStepCounts() {
    this.steps.forEach(step => {
      const stepNum = step.getAttribute('data-step');
      if (!stepNum) return;
      const allowMultiple = step.getAttribute('data-allow-multiple') === 'true';
      const checkboxes = step.querySelectorAll('routine-finder-product-selector input[type="checkbox"]');
      const total = checkboxes.length;
      const selected = step.querySelectorAll('routine-finder-product-selector input[type="checkbox"]:checked').length;
      this.querySelectorAll(`.routine-builder__step-count[data-step-count="${stepNum}"]`).forEach(el => {
        if (!allowMultiple && selected >= 1) {
          el.innerHTML = '<span class="routine-builder__step-check" aria-label="Selected"><svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg></span>';
        } else {
          el.textContent = `(${selected} of ${total})`;
        }
      });
    });
  }

  getUniqueSelectedProducts() {
    const selected = Array.from(this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]:checked'));
    const map = new Map();
    selected.forEach(cb => {
      if (!map.has(cb.name)) {
        map.set(cb.name, {
          name: cb.name,
          price: parseInt(cb.getAttribute('price'), 10) || 0,
        });
      }
    });
    return Array.from(map.values());
  }

  updateAll() {
    const stepsWithSelections = this.getStepsWithSelections();
    const uniqueProducts = this.getUniqueSelectedProducts();

    this.updateProgressBar(stepsWithSelections);
    this.updateStepCounts();
    this.updateTotals(uniqueProducts, stepsWithSelections);
    this.updateSelectedCount(uniqueProducts.length);
  }

  updateProgressBar(stepsWithSelections) {
    this.setAttribute('data-steps-selected', stepsWithSelections);
    this.querySelectorAll('.routine-builder__progress-tier').forEach(tier => {
      const threshold = parseInt(tier.getAttribute('data-step-threshold'), 10);
      if (!isNaN(threshold) && stepsWithSelections >= threshold) {
        tier.classList.add('is-active');
      } else {
        tier.classList.remove('is-active');
      }
    });
  }

  updateSelectedCount(count) {
    const countSpan = this.querySelector('.featured-collection__selected_count-number');
    if (countSpan) countSpan.textContent = count;
  }

  getCurrentTierDiscount(stepsWithSelections) {
    if (stepsWithSelections < 1) return 0;
    const idx = Math.min(stepsWithSelections, this.tiers.length) - 1;
    return this.tiers[idx] || 0;
  }

  updateTotals(uniqueProducts, stepsWithSelections) {
    const subtotal = uniqueProducts.reduce((sum, p) => sum + (isNaN(p.price) ? 0 : p.price), 0);
    const tierPct = this.getCurrentTierDiscount(stepsWithSelections);
    const savings = subtotal > 0 ? Math.round(subtotal * (tierPct / 100)) : 0;

    const subtotalSpan = this.querySelector('#subtotal');
    if (subtotalSpan) subtotalSpan.textContent = formatMoney(subtotal, window.themeVariables.moneyFormat);

    const savingsSpan = this.querySelector('#routineSavings');
    const savingsLabel = this.querySelector('#routineSavingsLabel');
    if (savingsSpan) savingsSpan.textContent = '-' + formatMoney(savings, window.themeVariables.moneyFormat);
    if (savingsLabel) {
      const stepWord = stepsWithSelections === 1 ? 'step' : 'steps';
      savingsLabel.textContent = `Routine Savings (${stepsWithSelections} ${stepWord} · ${tierPct}%)`;
    }

    const totalSpan = this.querySelector('#totalCost');
    if (totalSpan) totalSpan.textContent = formatMoney(subtotal - savings, window.themeVariables.moneyFormat);
  }

  generateUniqueId() {
    const regimenId = this.getAttribute('data-regimen-id') || 'builder';
    return 'routine-builder__regimenID-' + regimenId + '-' + Date.now();
  }

  async addToCart(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    const cartVariantIds = new Set();
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin',
      });
      if (cartResponse.ok) {
        const currentCart = await cartResponse.json();
        if (currentCart && Array.isArray(currentCart.items)) {
          currentCart.items.forEach(item => {
            cartVariantIds.add(String(item.variant_id || item.id));
          });
        }
      }
    } catch (err) {
      console.warn('Routine builder: failed to fetch cart before add', err);
    }

    const uniqueRoutineId = this.generateUniqueId();
    const selectedCheckboxes = this.querySelectorAll('routine-finder-product-selector input[type="checkbox"]:checked');
    const uniqueProductsMap = new Map();

    selectedCheckboxes.forEach((checkbox) => {
      const productIdRaw = checkbox.name;
      const productId = parseInt(productIdRaw, 10);

      if (
        !isNaN(productId) &&
        productId > 0 &&
        !uniqueProductsMap.has(productIdRaw) &&
        !cartVariantIds.has(String(productIdRaw))
      ) {
        uniqueProductsMap.set(productIdRaw, {
          id: productId,
          quantity: 1,
          properties: {
            "_routineBuilderSource": true,
            "_routineBuilderReference": uniqueRoutineId,
          },
        });
      }
    });

    const cartItems = Array.from(uniqueProductsMap.values());

    if (cartItems.length === 0) {
      button.textContent = originalText;
      button.disabled = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: cartItems }),
      });
      const cart = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
        detail: { items: cartItems, cart: cart },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error("Error adding routine items to the cart:", error);
    } finally {
      button.textContent = originalText;
      button.disabled = false;
    }
  }
}

if (!window.customElements.get("routine-builder")) {
  window.customElements.define("routine-builder", RoutineBuilder);
}

if (!window.customElements.get("routine-finder-content")) {
  window.customElements.define("routine-finder-content", RoutineFinderContent);
}

if (!window.customElements.get("routine-finder-primary")) {
  window.customElements.define("routine-finder-primary", RoutineFinderPrimary);
}

if (!window.customElements.get("routine-finder-actions")) {
  window.customElements.define("routine-finder-actions", RoutineFinderActions);
}

if (!window.customElements.get("routine-finder-product-selector")) {
  window.customElements.define("routine-finder-product-selector", RoutineFinderProductSelector);
}

if (!window.customElements.get("routine-finder-content")) {
  window.customElements.define("routine-finder-content", RoutineFinderContent);
}

// Rebuy-sourced add-to-cart Klaviyo tracking removed: Rebuy is gone, and native
// add-to-cart already pushes the 'Added to Cart' Klaviyo event (see the buy-buttons
// submit handler above). Repointing this to variant:add would double-track.

document.addEventListener('rebuy.beforeLoaded', function(){
  /* Disable Rebuy console attribution */
  window.Rebuy.disable_attribution = true;
});

// Migrating to the native cart: destroy the Rebuy Smart Cart so it stops
// hijacking the cart. The Rebuy app still loads Smart Cart via the installed
// app, so we tear it down as soon as it initialises (and on any attempt to
// show it). Remove this once Smart Cart is disabled in the Rebuy admin.
function destroyRebuySmartCart() {
  if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.destroy === 'function') {
    window.Rebuy.SmartCart.destroy();
  }
}

['rebuy:ready', 'rebuy:cart.ready', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(function (eventName) {
  document.addEventListener(eventName, destroyRebuySmartCart);
});

class OrbeToggle extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
  handleClick(event) {
    this.toggle();
  }

  toggle() {
    orbito.openModalWithoutRefresh();
    this.querySelector('button').setAttribute('aria-expanded', 'true');
  }
}

if (!window.customElements.get("orbe-toggle")) {
  window.customElements.define("orbe-toggle", OrbeToggle);
}

// js/theme.js
import { Delegate as Delegate4 } from "//drsambunting.com/cdn/shop/t/306/assets/vendor.min.js?v=114992621884149252901787686341";
(() => {
  const delegateDocument = new Delegate4(document.documentElement);
  if (window.themeVariables.settings.showPageTransition && "animate" in document.documentElement && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", 'a:not([target="_blank"])', async (event, target) => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey) {
        return;
      }
      if (target.hostname !== window.location.hostname || target.pathname === window.location.pathname) {
        return;
      }
      event.preventDefault();
      await document.body.animate({ opacity: [1, 0] }, { duration: 75, fill: "forwards" }).finished;
      window.location = target.href;
    });
  }
  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
      if (event.defaultPrevented || target.pathname !== window.location.pathname || target.search !== window.location.search) {
        return;
      }
      const url = new URL(target.href);
      if (url.hash === "") {
        return;
      }
      const anchorElement = document.querySelector(url.hash);
      if (anchorElement) {
        event.preventDefault();
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }
  const setScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }
  };
  setScrollbarWidth();
  window.addEventListener("resize", throttle(setScrollbarWidth));
})();
export {
  AccordionDisclosure,
  AnimatedDetails,
  BuyButtons,
  CartCount,
  CartDrawer,
  CartNote,
  CartNotificationDrawer,
  CartRecommendations,
  CompareAtPrice,
  ConfirmButton,
  CopyButton,
  CountrySelector,
  CustomButton,
  CustomCursor,
  DialogElement,
  Drawer,
  EffectCarousel,
  FacetApplyButton,
  FacetDialog,
  FacetDrawer,
  FacetFloatingFilter,
  FacetForm,
  FacetLink,
  FacetSortBy,
  FluidMetric,
  FreeGiftBar,
  FreeShippingBar,
  GestureArea,
  GiftCardRecipient,
  HeightObserver,
  LineItem,
  LineItemQuantity,
  Listbox,
  KlaviyoBackInStock,
  MarqueeText,
  MediaCarousel,
  ModelMedia,
  NextButton,
  OnSaleBadge,
  PageDots,
  PaymentTerms,
  PickupAvailability,
  PillLoader,
  Player,
  Popover,
  PredictiveSearch,
  PrevButton,
  PriceRange,
  PrivacyBar,
  ProductCard,
  ProductForm,
  ProductGallery,
  ProductLoader,
  ProductQuickAdd,
  ProductZoomButton,
  ProgressBar,
  QuantitySelector,
  QuickBuyDrawer,
  ResizableTextarea,
  RevealItems,
  SafeSticky,
  SalePrice,
  ScrollArea,
  ScrollCarousel,
  ScrollProgress,
  ScrollShadow,
  SearchDrawer,
  SectionHeader,
  SellingPlanPrice,
  ShareButton,
  ShippingEstimator,
  RivoRewards,
  RoutineBuilder,
  RoutineFinderPrimary,
  RoutineFinderActions,
  RoutineFinderProductSelector,
  RoutineFinderContent,
  SoldOutBadge,
  SplitLines,
  SubscriptionPicker,
  Tabs,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  cachedFetch,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  getHeadingKeyframe,
  imageLoaded,
  throttle,
  waitForEvent
};


